import {
  message,
  Spin,
  Progress,
  Row,
  Col,
  Select,
  //Form as FormInitial,
  notification,
  Space,
  //Tabs,
  Upload,
  PageHeader,
  Tooltip,
  Radio,
  Modal,
} from "antd";
import React, { Component } from "react";
import {
  Form,
  FormItem,
  InputNumberItem,
  SelectItem,
  round2Decimals,
  round6Decimals,
  dineroDisabledMask,
  ModalItem,
  InputItem,
  ButtonItem,
  NotificacionPolizas,
  NotificacionMovimientosInventario,
  SwitchItem,
  ErrorItem,
  MensajeError,
  SelectInsumosItem,
  TourItem,
  DatePickerItem,
  SelectClavePedimentoItem,
  SelectIncoTermsItem,
  DisponibilidadInsumoModal,
  HistorialInsumoClienteModal,
  DetalleInsumoModal,
  BusquedaAvanzadaInsumosModal,
  FilaHospedajeVenta,
  hospedajeParaPayload,
} from "../../../../Components/Items";
import VentasForm from "../../../../Components/VentasForm";
import moment from "moment";
import axios from "axios";
import { connect } from "react-redux";
import {
  DeleteOutlined,
  ClearOutlined,
  FileTextOutlined,
  TagsOutlined,
  AppstoreOutlined,
  DatabaseOutlined,
  CommentOutlined,
  GlobalOutlined,
  PlusOutlined,
  SwapOutlined, ArrowUpOutlined, ArrowDownOutlined, ScissorOutlined,
  BuildOutlined, PrinterOutlined, InfoCircleOutlined, WarningOutlined,
  FileExcelOutlined, EyeOutlined, SearchOutlined
} from "@ant-design/icons";
import facturaPdf from "../../../../Pdf/facturaPdf";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import ElegirTipoDeCliente from "../../Clientes/ElegirTipoDeCliente/ElegirTipoDeCliente";
import MandarCorreo from "../MandarCorreo/MandarCorreo";
import remisionPdf from "../../../../Pdf/remisionPdf";
import ElegirMarbetes from "../../Marbetes/ElegirMarbetes/ElegirMarbetes";
import AgregarCliente from "./AgregarCliente/AgregarCliente";
import ModalCargarExcelInsumos from "../../../../Components/ModalCargarExcelInsumos";
import {
  construirFilasInsumosDesdeExcel,
  insumosNuevosParaCatalogo,
  combinarFilasInsumos,
  payloadInventarioBulk,
  aplicarInventarioBulk,
} from "../../../../Components/cargarInsumosExcel.utils";
import AgregarCanalVenta from "../../CanalesVenta/AgregarCanalVenta/AgregarCanalVenta";
import TabEnvio from "./TabEnvio/TabEnvio";
import TabRelaciones from "./TabRelaciones/TabRelaciones";
import FormListLeyendasFiscales from "../../../../Components/FormListLeyendasFiscales";
import TabAnticipos from "./TabAnticipos/TabAnticipos";
import TabEntregaDireccion from "../../../../Components/TabEntregaDireccion";
import ElegirLeyenda from "../ElegirLeyenda/ElegirLeyenda";
import xmlToJson from "../../../../Components/xmlToJson";
import { IconFileXml } from "../../../../Icons/Icons";
import Compress from "../../../../Components/Compress";
import decodeHTMLEntities from "../../../../Components/decodeHtmlEntities";
import SelectClientesItem from "../../../../Components/SelectClientesItem";
import SelectListasEscuelaItem from "../../../../Components/SelectListasEscuelaItem";
import ElegirLotes from "../../LotesCaducidades/ElegirLotes/ElegirLotes";
import ElegirAgrupaciones from "../../Agrupaciones/ElegirAgrupaciones/ElegirAgrupaciones";
import ElegirComponentesKit from "../../InsumosCompuestos/ElegirComponentesKit/ElegirComponentesKit";
import ElegirObservaciones from "../ElegirObservaciones/ElegirObservaciones";
import VerInsumo from "./VerInsumo/VerInsumo";
import ticketPdf from "../../../../Pdf/ticketPdf";
import qz from "qz-tray";
import ComercioExteriorInsumo from "../ComercioExteriorInsumo/ComercioExteriorInsumo";
import printJS from "print-js";
import AgregarCirugia from "../../Cirugias/AgregarCirugia/AgregarCirugia";
import AgregarDoctor from "../../Doctores/AgregarDoctor/AgregarDoctor";
import AgregarPaciente from "../../Pacientes/AgregarPaciente/AgregarPaciente";
import VistaPreviaVenta from "../VistaPreviaVenta/VistaPreviaVenta";
import ModalAutorizacion from "../../../../Components/AutorizacionRapida/ModalAutorizacion";
import BotonAutorizacion from "../../../../Components/AutorizacionRapida/BotonAutorizacion";
import BotonDescripcionLarga, { textoDescripcionLarga } from "../../../../Components/BotonDescripcionLarga";
import { PERMISOS_AUTORIZABLES } from "../../../../Utils/autorizaciones";
import { crearReglasPrecio } from "../../../../Utils/reglasPrecioDocumento";
import { refrescarCatalogoInsumosCliente } from "../../../../Components/catalogoInsumosCliente";
import {
  aplicarDescuentoBaseAFila,
  normalizarDescuentoFila,
  sincronizarDescuentoFila,
} from "../../../../Utils/descuentoEscuela";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;
//const { TabPane } = Tabs;

class AgregarVenta extends Component {
  formRef = React.createRef();
  refGenerales = React.createRef();
  refFactura = React.createRef();
  refContado = React.createRef();
  refCliente = React.createRef();
  refVendedor = React.createRef();
  refMoneda = React.createRef();
  refPago = React.createRef();
  refCuentasXC = React.createRef();
  refFormaPago = React.createRef();
  refInsumos = React.createRef();
  refObservaciones = React.createRef();
  refTotales = React.createRef();
  refChecks = React.createRef();
  contadoAnterior = 1;
  precioIdAnterior = undefined;
  usarPrecioClienteAnterior = true;
  // Maquinaria de reglas de lista de precios (aviso en vivo, bloqueo al guardar y
  // descuento minimo automatico). Compartida con Cotizaciones, Pedidos y Embarques.
  reglas = crearReglasPrecio(this, {
    modulo: "VENTA",
    recalcularTotales: (insumos) => this.recalcularInsumosEnBatch(insumos),
  });
  state = {
    loading: false,
    // Autorizaciones rápidas: clave "campo[:index]" → {autorizacionId, tokenConsumo}
    autorizacionesActivas: {},
    modalAutorizacion: null, // {visible, permisoId, clave, contexto}
    filasConError: [],
    // Reglas de la lista de precios para este cliente. Se recarga al cambiar de
    // cliente o de lista; null = sin reglas que revisar.
    contextoReglas: null,
    // Violaciones de rango por renglón: index → {campo, motivo, limite, valor}
    fueraDeRango: {},
    objetoClientes: null,
    todasClientes: [],
    objetoProyectos: null,
    todasProyectos: null,
    todasSeriesVenta: [],
    //Hotelería: habitaciones activas con su insumo de tarifa, y el set de esos insumoId para saber de
    //un vistazo si un renglón es de hospedaje (ver consultarHabitacionesHotel).
    habitacionesHotel: [],
    insumosHospedajeIds: new Set(),
    objetoPrecios: null,
    todasPrecios: null,
    objetoFormasDePago: null,
    todasFormasDePago: null,
    objetoInsumos: null,
    todasInsumos: [],
    objetoUsosDeCFDI: null,
    todasUsosDeCFDI: null,
    objetoBancos: null,
    todasBancos: null,
    objetoUsuarios: null,
    todasUsuarios: null,
    objetoMonedas: null,
    todasMonedas: null,
    objetoDoctores: null,
    todasDoctores: null,
    objetoPacientes: null,
    todasPacientes: null,
    objetoCirugias: null,
    todasCirugias: null,
    impuestos: [],
    modalConfirmacion: false,
    modalCorreo: false,
    modalCorreoId: null,
    modalElegirTipoDeCliente: false,
    modalElegirTipoDeClienteNombre: null,
    modalElegirTipoDeClienteId: null,
    valuesForm: null,
    entregarInsumos: false,
    // "Agregar y Entregar Disponibles": se guarda como "+ Agregar" y despues se entrega lo que alcance
    entregarDisponibles: false,
    entregarDisponiblesVenta: false,
    totalPagar: 0,
    venderSinInventario: false,
    complementoDetallista: false,
    complementoComercioExterior: false,
    detallista: null,
    flete: false,
    factura: 2,
    quitarImpuestos: false,
    modalElegirMarbetes: false,
    modalElegirMarbetesMarbetes: [],
    modalElegirMarbetesInsumoId: null,
    modalElegirMarbetesProyectoId: null,
    activeTabKey: "1",
    modalAgregar: false,
    modalAgregarCanal: false,
    ubicacionesEnvio: [],
    mercanciasEnvio: [],
    modalLeyenda: false,
    modalLeyendaIndex: null,
    modalLeyendaLeyenda: null,
    modalLeyendaLeyendasPasadas: null,
    modalObservaciones: false,
    modalObservacionesIndex: null,
    modalObservacionesObservaciones: null,
    modalObservacionesObservacionesPasadas: null,
    modalObservacionesObservacionesXml: null,
    modalVerInsumo: false,
    modalVerInsumoId: null,
    modalVerInsumoPrecioId: null,
    modalVerInsumoIndex: 0,
    modalVerInsumoTipoDeCambio: 1,
    modalCargarExcelVisible: false,
    xmlSubido: false,
    archivosXml: [],
    empresaRfc: null,
    cadenaOriginalSAT: null,
    noCertificadoSAT: null,
    noCertificadoCFDI: null,
    uuid: null,
    selloSAT: null,
    selloCFDI: null,
    fechaTimbrado: null,
    qrCode: null,
    cfdi: null,
    folioFIngresada: null,
    serieFIngresada: null,
    totalFIngresada: null,
    totalImpuestosFIngresada: null,
    subtotalFIngresada: null,
    activarRegimenes: true,
    todasRegimenFiscal: null,
    objetoRegimenFiscal: null,
    loadingModal: false,
    creditoDisponible: undefined,
    limiteCredito: 0,
    modalElegirLotes: false,
    modalElegirLotesIndex: null,
    modalElegirLotesLotes: null,
    modalElegirLotesInsumoId: null,
    modalElegirLotesProyectoId: null,
    modalElegirLotesClienteId: null,
    modalElegirLotesCantidad: null,
    openTour: false,
    cotizacionesSeleccionadas: this.props.location?.state?.cotizacionesSeleccionadas || [],
    pedidosSeleccionados: this.props.location?.state?.pedidosSeleccionados || [],
    pedidoId: this.props.location?.state?.pedidoId || null,
    cotizacionId: this.props.location?.state?.cotizacionId || null,
    embarquesSeleccionados: this.props.location?.state?.embarquesSeleccionados || [],
    embarqueId: this.props.location?.state?.embarqueId || null,
    cerrarCotizaciones: false,
    cerrarPedidos: false,
    cerrarEmbarques: false,
    direccionesCliente: [],
    objetoDireccionesCliente: null,
    todasPaises: [],
    todasEstado: [],
    todasMunicipios: [],
    todasColonias: [],
    objetoPaises: null,
    objetoEstados: null,
    objetoMunicipios: null,
    objetoColonias: null,
    loadingEntrega: false,
    addendaMabe: false,
    addendaViscofan: false,
    usarLeyendasFiscales: false,
    loadingPlantasEntrega: false,
    objetoCanalesVenta: null,
    todasCanalesVenta: [],
    tickets: false,
    desactivarBtnCXC: false,
    tiposDescuento: {},
    docObligatorio : false,
    cantidadDefault : false,
    modoReordenar: false,
    clienteIdActual: null, 
    nombreClienteActual: null,
    modalVistaPrevia: false,
    datosVistaPrevia: null,
    modalDisponibilidadVisible: false,
    insumoSeleccionadoDisponibilidad: { id: null, nombre: '' },
    modalHistorialClienteVisible: false,
    insumoSeleccionadoHistorial: { id: null, nombre: '', clienteId: null, index: 0 },
    modalDetalleInsumoVisible: false,
    insumoSeleccionadoDetalle: { id: null, nombre: '' },
    modalBusquedaAvanzadaVisible: false,
    contextoBusquedaAvanzada: {},
    listasEscolaresSeleccionadas: [],
    insumosObligatoriosLista: {},
    insumosNoEliminablesLista: {},
    clienteEscuelaId: null,
    todasSucursalesGrupadas: [],
    loadingLista: false,
    progresoLista: 0,
    marcarVentaOnline: false,
    deliveryMethod: null,
    pickupBranchId: null,
    opcionesSucursales: [],
    todasSucursalesEntrega: [],
    insumoEnvio: null,
    loadingSucursales: false,
    entregaSucursalActivada: false,
    entregaLocalActivada: false,
    envioLocalInsumoId: null,
    envioLocalCostoFijo: 0,
    envioLocalMontoParaEnvioGratis: 0,
    fechaServidor: null,
  };

  // Hora real, tomada del servidor al cargar la pantalla (no depende del reloj de la computadora)
  horaServidor = () => this.state.fechaServidor ? this.state.fechaServidor.clone() : moment();

  abrirDisponibilidad = (insumoId, nombre, proyectoId) => {
    this.setState({ modalDisponibilidadVisible: true, insumoSeleccionadoDisponibilidad: { id: insumoId, nombre, proyectoId } });
  }

  cerrarDisponibilidad = () => {
    this.setState({ modalDisponibilidadVisible: false });
  }

  abrirDetalleInsumo = (insumoId, nombre) => {
    if (!insumoId) return;
    this.setState({ modalDetalleInsumoVisible: true, insumoSeleccionadoDetalle: { id: insumoId, nombre } });
  }

  cerrarDetalleInsumo = () => {
    this.setState({ modalDetalleInsumoVisible: false });
  }

  // Boton "Busqueda avanzada" junto a "Agregar Insumo". El contexto es una foto del documento al
  // abrir; el modal lo manda igual que el SelectInsumosItem del renglon.
  abrirBusquedaAvanzada = () => {
    const form = this.formRef.current;
    if (!form) return;
    this.setState({
      modalBusquedaAvanzadaVisible: true,
      contextoBusquedaAvanzada: {
        clienteId: form.getFieldValue("clienteId"),
        usarPrecioCliente: form.getFieldValue("usarPrecioCliente"),
        precioId: form.getFieldValue("precioId"),
        proyectoId: form.getFieldValue("proyectoId"),
      },
    });
  }

  cerrarBusquedaAvanzada = () => {
    this.setState({ modalBusquedaAvanzadaVisible: false });
  }

  // Llena el primer renglon vacio o agrega uno, y corre el mismo onChangeInsumoProyecto que el
  // select del renglon. El modal espera esta promesa antes de dejar agregar otro: el handler
  // reescribe el arreglo completo y dos altas a la vez se pisarian. Vacio = sin insumo ni precio
  // ("Agregar Insumo" con cantidadDefault ya crea renglones con cantidad 1). El proyecto va
  // explicito porque el initialValue del renglon nuevo aun no se aplica cuando corre el handler.
  agregarInsumoDesdeBusqueda = async ({ insumo, cantidad }) => {
    const form = this.formRef.current;
    if (!form) return;
    const insumos = [...(form.getFieldValue("insumos") || [])];
    const proyectoId = form.getFieldValue("proyectoId");
    const insumoId = insumo._id?.toString();
    let indice = insumos.findIndex((fila) => !fila?.insumoId && !fila?.precioUnitario);
    if (indice === -1) {
      indice = insumos.length;
      insumos.push({ insumoId, cantidad, proyectoId });
    } else {
      insumos[indice] = { ...insumos[indice], insumoId, cantidad, proyectoId: insumos[indice]?.proyectoId || proyectoId };
    }
    form.setFieldsValue({ insumos });
    await this.onChangeInsumoProyecto(insumoId, indice, "insumo", false, insumo);
  }

  // Clic derecho en la misma celda donde el doble clic abre Disponibilidad.
  abrirHistorialCliente = (insumoId, nombre, index) => {
    if (!insumoId) return message.warning("Primero selecciona un insumo en el renglón");
    const clienteId = this.formRef.current?.getFieldValue("clienteId");
    if (!clienteId) return message.warning("Primero selecciona un cliente para ver su historial");
    this.setState({
      modalHistorialClienteVisible: true,
      insumoSeleccionadoHistorial: { id: insumoId, nombre, clienteId, index },
    });
  }

  // Mismo contrato que cerrarVerInsumo: si el modal devuelve un precio, se escribe en el renglón
  // y se dispara el recálculo canónico (impuestos, descuentos, totales).
  cerrarHistorialCliente = async (precio) => {
    const index = this.state.insumoSeleccionadoHistorial.index;
    if (precio && precio > 0) {
      const insumos = await this.formRef.current.getFieldValue('insumos');
      // El precio del historial viene NETO (ya traia su descuento dentro), asi que se limpia el
      // descuento del renglon: si no, se descontaria dos veces y lo cobrado no seria lo que
      // mostraba el modal.
      const teniaDescuento = !!insumos[index]?.descuento || !!insumos[index]?.descuentoCantidad;
      insumos[index].precioUnitario = precio;
      insumos[index].descuento = 0;
      insumos[index].descuentoCantidad = 0;
      if (this.props.escuela) {
        insumos[index].descuentoBase = 0;
        insumos[index].descuentoAdicional = 0;
      }
      await this.formRef.current.setFieldsValue({ insumos });
      this.onChangePrecioCantidadDescuento(undefined, index);
      if (teniaDescuento) message.info("Se limpió el descuento del renglón: el precio del historial ya viene neto");
    }
    this.setState({ modalHistorialClienteVisible: false });
  }

  agregarInsumosDeListaEscolar = async (listaId) => {
    const proyectoId = this.formRef.current.getFieldValue("proyectoId");
    const precioId = this.formRef.current.getFieldValue("precioId");
    const clienteId = this.formRef.current.getFieldValue("clienteId");
    const monedaId = this.formRef.current.getFieldValue("monedaId");
    if (!proyectoId || !precioId || !clienteId || !monedaId) {
      return message.warning("Primero llene los datos principales de la venta");
    }

    this.setState({ loading: true, loadingLista: true, progresoLista: 15 });
    try {
      const res = await axios.post(
        "listasEscuela/datosListaEscuela",
        { listaId, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      );

      if (res.data.success !== 2) {
        this.setState({ loading: false, loadingLista: false, progresoLista: 0 });
        return message.error("No se pudo cargar la lista escolar");
      }
      this.setState({ progresoLista: 45 });

      const { lista, insumos: catalogoInsumos } = res.data;
      const itemsLista = (lista.insumos || []).filter((item) =>
        catalogoInsumos.some((valueInsumo) => valueInsumo._id.toString() === item.insumoId.toString())
      );

      if (itemsLista.length === 0) {
        this.setState({ loading: false });
        return message.warning("La lista no tiene insumos disponibles para vender");
      }

      // Fusionar el catálogo nuevo en todasInsumos en una sola tanda
      const yaExistentes = new Set(this.state.todasInsumos.map((valueInsumo) => valueInsumo._id.toString()));
      const catalogoNuevo = catalogoInsumos.filter((valueInsumo) => !yaExistentes.has(valueInsumo._id.toString()));
      if (catalogoNuevo.length > 0) {
        await new Promise((resolve) =>
          this.setState((prev) => ({ todasInsumos: [...prev.todasInsumos, ...catalogoNuevo] }), resolve)
        );
      }

      // Limpiar insumos anteriores antes de cargar la nueva lista
      this.formRef.current.setFieldsValue({ insumos: [] });

      const filasActuales = [];
      const offset = 0;
      const insumoIdsLista = [];
      const nuevosObligatorios = {};

      const filasNuevas = itemsLista.map((item, index) => {
        const insumoCat = catalogoInsumos.find(
          (valueInsumo) => valueInsumo._id.toString() === item.insumoId.toString()
        );
        const precio = insumoCat.precios?.find(
          (valuePrecio) => valuePrecio.precioId?.toString() === precioId
        );
        insumoIdsLista.push(insumoCat._id);
        if (item.requerido) nuevosObligatorios[offset + index] = true;
        return {
          insumoId: insumoCat._id,
          cantidad: item.cantidad,
          precioUnitario: precio ? precio.precio : 0,
        };
      });

      const arrayCompleto = [...filasActuales, ...filasNuevas];

      // Inventario en bulk para todas las filas nuevas de una sola vez
      const insumosBulkPayload = filasNuevas.map((fila, index) => {
        const insumoOriginal = catalogoInsumos.find(
          (valueInsumo) => valueInsumo._id.toString() === fila.insumoId.toString()
        );
        return {
          index: offset + index,
          insumoId: fila.insumoId,
          proyectoId,
          inventariable: insumoOriginal?.inventariable,
          noPrincipal: insumoOriginal?.noPrincipal,
          insumoCompuesto: insumoOriginal?.insumoCompuesto,
          componentesKit: fila.componentesKit,
        };
      });

      try {
        const resInventarios = await axios.post(
          "inventarios/inventarioInsumoProyectoBulk",
          { empresaId: this.props.empresaId, proyectoId, insumos: insumosBulkPayload },
          { headers: this.props.headersToken }
        );
        if (resInventarios.data?.results) {
          resInventarios.data.results.forEach((resItem) => {
            if (arrayCompleto[resItem.index]) {
              arrayCompleto[resItem.index].cantidadProyecto =
                resItem.cantidad !== null ? resItem.cantidad : "No inventariable";
            }
          });
        }
      } catch (error) {
        console.error("Error al consultar inventario de la lista escolar:", error);
      }
      this.setState({ progresoLista: 85 });

      this.recalcularInsumosEnBatch(arrayCompleto);

      const observacionesActuales = this.formRef.current.getFieldValue("observaciones") || "";
      const lineaPaquete = `Venta de paquete: ${lista.nombre}`;
      this.formRef.current.setFieldsValue({
        observaciones: observacionesActuales
          ? (observacionesActuales.includes(lineaPaquete) ? observacionesActuales : `${observacionesActuales}\n${lineaPaquete}`)
          : lineaPaquete,
      });

      this.setState({
        insumosObligatoriosLista: nuevosObligatorios,
        listasEscolaresSeleccionadas: [{ listaId, nombre: lista.nombre, insumoIds: insumoIdsLista }],
        loading: false,
        progresoLista: 100,
      });
      message.success(`Se cargaron los insumos de "${lista.nombre}"`);
      setTimeout(() => this.setState({ loadingLista: false, progresoLista: 0 }), 600);
    } catch (error) {
      console.error("Error al cargar la lista escolar:", error);
      this.setState({ loading: false, loadingLista: false, progresoLista: 0 });
      message.error("Error al cargar la lista escolar");
    }
  }

  limpiarInsumosLista = () => {
    this.formRef.current.setFieldsValue({ insumos: [] });
    this.setState({
      insumosObligatoriosLista: {},
      listasEscolaresSeleccionadas: [],
    });
  }

  limpiarLista = () => {
    this.formRef.current.setFieldsValue({ insumos: [], observaciones: '' });
    this.setState({
      insumosObligatoriosLista: {},
      listasEscolaresSeleccionadas: [],
    });
  }

  construirClienteOnline = (clienteId) => {
    const cliente = this.state.todasClientes?.find((valueCliente) => valueCliente._id === clienteId);
    if (!cliente) return undefined;
    return {
      nombre: cliente.persona ? (cliente.razonSocial || "") : (cliente.nombre || ""),
      apellidoPaterno: cliente.persona ? "" : (cliente.apellidoPaterno || ""),
      apellidoMaterno: cliente.persona ? "" : (cliente.apellidoMaterno || ""),
      email: cliente.correo || "",
      telefono: cliente.telefono != null ? String(cliente.telefono) : "",
    };
  }

  construirPaquetesEscolares = (clienteId, insumosFinal) => {
    if (!this.state.listasEscolaresSeleccionadas?.length) {
      return { paquetesEscolares: undefined, paqueteEscolarId: undefined, paqueteEscolarNombre: undefined };
    }
    const idsPresentes = new Set(
      (insumosFinal || []).map((valueInsumo) => (valueInsumo.insumoId?._id || valueInsumo.insumoId)?.toString())
    );
    const cliente = this.state.todasClientes?.find((valueCliente) => valueCliente._id === clienteId);
    const paquetesEscolares = this.state.listasEscolaresSeleccionadas.map((valueLista) => ({
      clienteId,
      listaId: valueLista.listaId,
      nombre: valueLista.nombre,
      matricula: cliente?.datosAlumno?.matricula || "",
      insumoIds: valueLista.insumoIds.filter((idInsumo) => idsPresentes.has(idInsumo.toString())),
    }));
    return {
      paquetesEscolares,
      paqueteEscolarId: paquetesEscolares.length === 1 ? paquetesEscolares[0].listaId : undefined,
      paqueteEscolarNombre: paquetesEscolares.length === 1 ? paquetesEscolares[0].nombre : undefined,
    };
  }

  actualizarOpcionesSucursales = (escuelaId, grupos) => {
    const gruposFiltrados = grupos.length === 0
      ? []
      : (escuelaId
          ? grupos.filter(g => !g.escuelaId || g.escuelaId.toString() === escuelaId.toString())
          : grupos);

    const todasFlat = gruposFiltrados.flatMap(g => g.sucursales);
    const opcionesSucursales = gruposFiltrados.length > 1
      ? gruposFiltrados.map(grupo => ({
          label: grupo.escuelaNombre,
          options: grupo.sucursales.map(s => ({ label: s.label, value: s.optionKey })),
        }))
      : todasFlat.map(s => ({ label: s.label, value: s.optionKey }));

    this.setState({ todasSucursalesEntrega: todasFlat, opcionesSucursales });
  };

  cargarSucursalesEntrega = async () => {
    this.setState({ loadingSucursales: true });
    try {
      const res = await axios.post(
        "ventas/selectSucursalesEntrega",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      );
      if (res.data.success === 2) {
        const entregaSucursalActivada = !!res.data.entregaSucursalActivada;
        const entregaLocalActivada = !!res.data.entregaLocalActivada;
        const grupos = res.data.sucursalesGrupadas || [];
        this.setState({
          loadingSucursales: false,
          todasSucursalesGrupadas: grupos,
          insumoEnvio: res.data.insumoEnvio || null,
          entregaSucursalActivada,
          entregaLocalActivada,
          envioLocalCostoFijo: Number(res.data.envioLocalCostoFijo) || 0,
          envioLocalMontoParaEnvioGratis: Number(res.data.envioLocalMontoParaEnvioGratis) || 0,
        }, () => {
          this.actualizarOpcionesSucursales(this.state.clienteEscuelaId, grupos);
        });
        if (!entregaSucursalActivada && !entregaLocalActivada) {
          message.warning("No se puede marcar como venta online: no hay métodos de entrega configurados (ni recolección en sucursal ni entrega local).");
          this.setState({ marcarVentaOnline: false });
        }
      }
    } catch (error) {
      console.error("Error al cargar las sucursales de entrega:", error);
      this.setState({ loadingSucursales: false });
    }
  }

  actualizarEnvioPickup = async (metodo) => {
    // La recolección en sucursal no agrega ningún insumo de envío (es gratis y
    // no se contabiliza como línea aparte). Solo la entrega local agrega el
    // insumo configurado, con el monto calculado según la configuración.
    const filaActual = this.formRef.current.getFieldValue("insumos") || [];

    if (this.state.envioLocalInsumoId) {
      const idAQuitar = this.state.envioLocalInsumoId.toString();
      const sinEnvio = filaActual.filter(
        (fila) => (fila.insumoId?._id || fila.insumoId)?.toString() !== idAQuitar
      );
      if (sinEnvio.length !== filaActual.length) {
        this.recalcularInsumosEnBatch(sinEnvio);
      }
      this.setState({ envioLocalInsumoId: null });
    }

    if (metodo === 'local' && this.state.insumoEnvio) {
      const insumoEnvio = this.state.insumoEnvio;
      const filasBase = this.formRef.current.getFieldValue("insumos") || [];
      const yaPresente = filasBase.some(
        (fila) => (fila.insumoId?._id || fila.insumoId)?.toString() === insumoEnvio._id.toString()
      );
      if (!yaPresente) {
        const yaExisteEnCatalogo = this.state.todasInsumos.some(
          (valueInsumo) => valueInsumo._id.toString() === insumoEnvio._id.toString()
        );
        if (!yaExisteEnCatalogo) {
          await new Promise((resolve) =>
            this.setState((prev) => ({ todasInsumos: [...prev.todasInsumos, insumoEnvio] }), resolve)
          );
        }
        // Monto autocalculado: gratis si el subtotal ya alcanza el mínimo
        // configurado, si no, el costo fijo configurado para entrega local.
        const subtotalActual = filasBase.reduce((acc, fila) => acc + (Number(fila.subtotal) || 0), 0);
        const { envioLocalMontoParaEnvioGratis, envioLocalCostoFijo } = this.state;
        const esGratis = envioLocalMontoParaEnvioGratis > 0 && subtotalActual >= envioLocalMontoParaEnvioGratis;
        const montoConImpuestos = esGratis ? 0 : envioLocalCostoFijo;

        // El costo configurado es el monto FINAL que paga el cliente (igual que
        // `costoCliente` en el checkout online), no el precio antes de impuestos.
        // Hay que sacar el precio unitario neto para que, tras aplicarle los
        // impuestos del insumo de envío, el total quede exactamente en ese monto
        // (misma fórmula inversa que usa onChangePrecioConImpuestos).
        const tipoDeCambio = this.formRef.current.getFieldValue("tipoDeCambio");
        let factor = 1;
        let sumaCuotasFijas = 0;
        (insumoEnvio.impuestos || []).forEach((valueImpuesto) => {
          const porcentaje = valueImpuesto.monto / 100;
          if (valueImpuesto.tasaCuota === 1) {
            factor += porcentaje;
          } else if (valueImpuesto.tasaCuota === 2) {
            factor *= (1 + porcentaje);
          } else if (valueImpuesto.tasaCuota === 3) {
            sumaCuotasFijas += valueImpuesto.monto / tipoDeCambio;
          }
        });
        const precioEnvio = montoConImpuestos === 0
          ? 0
          : round6Decimals((montoConImpuestos - sumaCuotasFijas) / factor);

        const proyectoId = this.formRef.current.getFieldValue('proyectoId');
        const arrayCompleto = [...filasBase, {
          insumoId: insumoEnvio._id,
          cantidad: 1,
          precioUnitario: precioEnvio,
          proyectoId,
          cantidadProyecto: insumoEnvio.inventariable ? 0 : "No inventariable",
        }];
        this.recalcularInsumosEnBatch(arrayCompleto);
        this.setState({ envioLocalInsumoId: insumoEnvio._id });
      }
    }
  }

  construirCotizacionEnvioOnline = () => {
    if (this.state.deliveryMethod === 'pickup') {
      const sucursal = this.state.todasSucursalesEntrega.find(
        (valueSucursal) => valueSucursal.optionKey === this.state.pickupBranchId
      );
      if (!sucursal) return undefined;
      return [{
        origen: 'entrega_sucursal',
        costoCliente: 0,
        esEnvioGratis: true,
        pickupBranch: { ...sucursal },
      }];
    }
    if (this.state.deliveryMethod === 'local') {
      const insumos = this.formRef.current?.getFieldValue("insumos") || [];
      const filaEnvio = this.state.envioLocalInsumoId
        ? insumos.find((fila) => (fila.insumoId?._id || fila.insumoId)?.toString() === this.state.envioLocalInsumoId.toString())
        : null;
      const costoCliente = round2Decimals(filaEnvio?.total ?? this.state.envioLocalCostoFijo);
      return [{
        origen: 'envio_manual',
        costoCliente,
        esEnvioGratis: costoCliente === 0,
        notasInternas: 'Entrega local capturada desde Agregar Venta',
      }];
    }
    return undefined;
  }

  abrirAgregarCliente = () => {
    this.setState({ modalAgregar: true });
  };

  cerrarAgregarCliente = (id) => {
    this.setState({ modalAgregar: false });
    this.consultarTodo();
    if (id) {
      this.formRef.current.setFieldsValue({ clienteId: id })
    }
  };

  abrirAgregarCanal = () => {
    this.setState({ modalAgregarCanal: true });
  };

  cerrarAgregarCanal = (id) => {
    this.setState({ modalAgregarCanal: false });
    this.consultarTodo();
    if (id) {
      this.formRef.current.setFieldsValue({ canalDeVentaId: id });
    }
  };


  componentDidMount() {
    // FASE DE CAPTURA para poder bloquear cuando haya escaneo
    document.addEventListener("keydown", this.eventListenerKeyboards, { capture: true });
    this.consultarTodo?.();
    if (
      this.props.complementoSeriesPersonalizadas &&
      this.props.permisoElegirSerieFolioPersonalizado
    ) {
      this.consultarSeriesVenta();
    }
    if (this.props.moduloHoteleria) {
      this.consultarHabitacionesHotel();
    }
  }

  //Hotelería: una sola consulta al montar deja la lista de habitaciones activas con su insumo. Con esa
  //lista la pantalla resuelve las dos preguntas que necesita —si un renglón es de hospedaje (su
  //insumoId aparece aquí) y qué habitaciones se pueden elegir— sin ningún campo nuevo en el catálogo
  //de Insumos y sin un request por renglón.
  consultarHabitacionesHotel() {
    axios
      .post(
        "hoteleria/selectHabitacionesParaVenta",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success !== 2) return;
        const habitaciones = res.data.habitaciones || [];
        this.setState({
          habitacionesHotel: habitaciones,
          insumosHospedajeIds: new Set(habitaciones.map((valor) => String(valor.insumoId))),
        });
      })
      .catch((error) => console.error("Error al cargar las habitaciones del hotel:", error));
  }

  //Pone las noches capturadas como cantidad del renglón y dispara el mismo recálculo de importes que
  //usa el campo de cantidad, para que el subtotal no quede desfasado del rango de la estancia.
  onChangeNochesHospedaje(noches, arrayKey) {
    const insumos = this.formRef.current?.getFieldValue("insumos");
    if (!insumos || !insumos[arrayKey]) return;
    insumos[arrayKey].cantidad = noches;
    this.formRef.current.setFieldsValue({ insumos });
    this.onChangePrecioCantidadDescuento(noches, arrayKey);
  }

  consultarSeriesVenta() {
    axios
      .post(
        "serieventas/selectSeriesVentaActivas",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        const series = Array.isArray(res.data) ? res.data : [];
        this.setState({ todasSeriesVenta: series });
      });
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
         "ventas/selectDatosParaVenta",
        { empresaId: this.props.empresaId, duplicarId: this.props?.location?.state?.duplicar, cotizacionesSeleccionadas: this.state.cotizacionesSeleccionadas, pedidosSeleccionados: this.state.pedidosSeleccionados, cotizacionId: this.state.cotizacionId, pedidoId: this.state.pedidoId, embarquesSeleccionados: this.state.embarquesSeleccionados, embarqueId: this.state.embarqueId },
        {
          headers: this.props.headersToken,
        }
      )
      .then(async (res) => {
        if (res.data.status === 404) {
        } else {
          const fechaServidor = res.data.fechaServidor ? moment(res.data.fechaServidor) : null;
          this.setState({
            fechaServidor,
            todasProyectos: res.data.proyectos,
            todasPrecios: res.data.precios,
            todasFormasDePago: res.data.formasDePago,
            todasUsosDeCFDI: res.data.usosDeCFDI,
            todasBancos: res.data.bancosYCajas,
            todasUsuarios: res.data.usuariosEmpresa,
            todasMonedas: res.data.monedas,
            venderSinInventario: res.data.venderSinInventario,
            entregarDisponiblesVenta: !!res.data.entregarDisponiblesVenta,
            empresaRfc: res.data.empresaRfc,
            activarRegimenes: res.data.activarRegimenes,
            todasRegimenFiscal: res.data.regimenesFiscales,
            todasCanalesVenta: res.data.canalesVenta,
            ponerVendedor: res.data.ponerVendedor,
            ponerCanal: res.data.ponerCanal,
            ponerMetodoDePago: res.data.ponerMetodoDePago,
            tickets: res.data.tickets,
            desactivarBtnCXC: res.data.desactivarBtnCXC,
            docObligatorio: res.data.docObligatorio,
            cantidadDefault : res.data.cantidadDefault,
            ventasNoContables: res.data.ventasNoContables,
            facturaFechaAnterior: res.data.facturaFechaAnterior,
            objetoProyectos: res.data.proyectos.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
            objetoPrecios: res.data.precios.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
            objetoFormasDePago: res.data.formasDePago.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.c_FormaPago + ' - ' + value.descripcion}
                </Option>
              );
            }),
            objetoUsosDeCFDI: res.data.usosDeCFDI.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.c_UsoCFDI + ' - ' + value.descripcion}
                </Option>
              );
            }),
            objetoBancos: res.data.bancosYCajas.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
            objetoUsuarios: res.data.usuariosEmpresa.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre +
                    " " +
                    value.apellidoPaterno +
                    " " +
                    value.apellidoMaterno}
                </Option>
              );
            }),
            objetoMonedas: res.data.monedas.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.abreviacion}
                </Option>
              );
            }),
            objetoRegimenFiscal: res.data.regimenesFiscales.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.c_RegimenFiscal + " - " + value.descripcion}
                </Option>
              );
            }),
            objetoCanalesVenta: res.data.canalesVenta.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
          });

          this.formRef.current?.setFieldsValue({ fechaVenta: fechaServidor || moment() });

                   if (res.data.tickets) {
            this.activarQzTray()
          }

          if (res.data.predeterminarCXC) {
            this.formRef.current.setFieldsValue({ cuentasXC: true })
          }

          if (res.data.activarRegimenes) {
            this.formRef.current.setFieldsValue({ regimenFiscalId: res.data.regimenDefaultId })
          }

          if (res.data?.deshabilitarBanco) {
            this.formRef.current.setFieldsValue({ deshabilitarBanco: res.data?.deshabilitarBanco });
          }

          if (res.data?.datosVenta?.clienteId) {

            const responseCliente = await axios.post("clientes/buscarCliente", {
              clienteId: res.data.datosVenta.clienteId,
              empresaId: this.props.empresaId
            }, { headers: this.props.headersToken })

            if (responseCliente.data.success === 2) {
              await this.setState({
                todasClientes: [responseCliente.data.cliente],
                addendaMabe: responseCliente.data.cliente?.usarAdenda && responseCliente.data.cliente?.adendaActiva === "Mabe",
                addendaViscofan: responseCliente.data.cliente?.usarAdenda && responseCliente.data.cliente?.adendaActiva === "Viscofan",
                usarLeyendasFiscales: !!responseCliente.data.cliente?.usarLeyendasFiscales,
                direccionesCliente: responseCliente.data.cliente.direcciones,
                objetoDireccionesCliente: responseCliente.data.cliente.direcciones.map((value) => {
                  return (
                    <Option value={value._id} key={value._id}>
                      {(value.calle || "Sin calle") + ' ' + (value.numeroCalle || "Sin número") + (value.numeroInterior ? ' Int. ' + value.numeroInterior : '') + ', ' + (value.colonia || "Sin colonia")}
                    </Option>
                  )
                }),
              })

            } else {
              return message.error('No se pudo obtener el cliente de la venta a duplicar')
            }
            const insumosAgregarTodos = res.data.datosVenta.insumosCatalogo || [];
            if (insumosAgregarTodos.length === 0 && res.data?.datosVenta?.insumos?.length > 0) {
              return message.error('No se pudieron obtener todos los insumos. ');
            }

            const insumosFormat = res.data.datosVenta.insumos.map((insumo) => {
              const divisor = insumo.cantidad > 0 ? insumo.cantidad : 1; 
              const precioUnitarioConImpuestos = insumo.precioUnitario + (insumo.impuestos / divisor);
              return { 
                ...insumo, 
                precioUnitarioConImpuestos 
              };
            });
            
            const tiposDescuentoIniciales = {};
            const noEliminablesIniciales = {};
            insumosFormat.forEach((insumo, index) => {
              if (insumo.descuentoCantidad && insumo.descuentoCantidad > 0) {
                tiposDescuentoIniciales[index] = 'cantidad';
              } else {
                tiposDescuentoIniciales[index] = 'porcentaje';
              }
              if (insumo.entregadoOrigenCompleto) {
                noEliminablesIniciales[index] = true;
              }
            });

            await this.setState({
              tiposDescuento: tiposDescuentoIniciales,
              todasInsumos: insumosAgregarTodos,
              insumosNoEliminablesLista: noEliminablesIniciales,
            });

            if (res?.data?.datosVenta?.contado) {
              this.onChangeContado(res.data.datosVenta.contado)
            }

            const insumosBulkPayload = insumosFormat.map((insumo, index) => {
              const insumoIdString = insumo.insumoId?._id || insumo.insumoId;
              const insumoOriginal = insumosAgregarTodos.find(
                  (i) => i._id.toString() === insumoIdString.toString()
              );
              return {
                  index: index,
                  insumoId: insumoIdString,
                  proyectoId: insumo.proyectoId,
                  inventariable: insumoOriginal?.inventariable,
                  noPrincipal: insumoOriginal?.noPrincipal,
                  insumoCompuesto: insumoOriginal?.insumoCompuesto,
                  componentesKit: insumo.componentesKit,
              };
            });

            try {
                const resInventarios = await axios.post("inventarios/inventarioInsumoProyectoBulk", { 
                    empresaId: this.props.empresaId,
                    proyectoId: res.data.datosVenta?.proyectoId,
                    pedidosSeleccionados: this.state.pedidosSeleccionados,
                    insumos: insumosBulkPayload 
                }, { headers: this.props.headersToken });
                
                if (resInventarios.data && resInventarios.data.results) {
                    resInventarios.data.results.forEach(resItem => {
                        if (insumosFormat[resItem.index]) {
                            insumosFormat[resItem.index].cantidadProyecto = 
                                resItem.cantidad !== null ? resItem.cantidad : "No inventariable";
                        }
                    });
                }
            } catch (error) {
                console.error("Error al consultar inventario", error);
            }

            await this.formRef.current.setFieldsValue({
              ...res.data.datosVenta,
              factura: res.data.datosVenta?.factura ? 1 : 2,
              insumos: insumosFormat
            });

            this.setState({ quitarImpuestos: !!res.data.datosVenta?.quitarImpuestos }, () => {
              this.recalcularInsumosEnBatch(insumosFormat);
            });

            if (res.data?.datosVenta?.direccionEntrega?.plantaEntregaId) {
              this.onSearchPlantaEntrega(res.data?.datosVenta?.direccionEntrega?.plantaEntregaId, "direccionEntrega", { byId: true, setSelected: false });
            }
          }

        }
      });

     if (this.props.equipoMedico) {

      await axios
        .post(
          "ventas/selectDatosParaEquipoMedico",
          { empresaId: this.props.empresaId },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          if (res.data.success === 2) {
            this.setState({
              todasDoctores: res.data.doctores,
              todasPacientes: res.data.pacientes,
              todasCirugias: res.data.cirugias,
              objetoDoctores: res.data.doctores.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.codigo + ' - ' + value.nombre}
                  </Option>
                );
              }),
              objetoPacientes: res.data.pacientes.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.codigo + ' - ' + value.nombre}
                  </Option>
                );
              }),
              objetoCirugias: res.data.cirugias.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.codigo + ' - ' + value.nombre}
                  </Option>
                );
              }),
            });
          } else {
            message.error('No se encontraron datos de equipo medico')
          }
        });

      }

    if (this.props.location?.state?.duplicar) {

      const idDuplicar = this.props.location.state.duplicar;

      await axios.post("ventas/datosVenta",
        { ventaId: idDuplicar, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      ).then(async (res) => {
        if (res.data.status !== 404) {

          const responseCliente = await axios.post("clientes/buscarCliente", {
            clienteId: res.data.clienteId,
            empresaId: this.props.empresaId
          }, { headers: this.props.headersToken })

          if (responseCliente.data.success === 2) {
            await this.setState({
              todasClientes: [responseCliente.data.cliente],
              direccionesCliente: responseCliente.data.cliente.direcciones,
              objetoDireccionesCliente: responseCliente.data.cliente.direcciones.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {(value.calle || "Sin calle") + ' ' + (value.numeroCalle || "Sin número") + (value.numeroInterior ? ' Int. ' + value.numeroInterior : '') + ', ' + (value.colonia || "Sin colonia")}
                  </Option>
                )
              }),
            })
          } else {
             return message.error('No se pudo obtener el cliente de la venta a duplicar')
          }

          const insumosAgregarTodos = res.data.insumosCatalogo || [];

          if (insumosAgregarTodos.length === 0 && res.data?.insumos?.length > 0) {
            return message.error('No se pudieron obtener todos los insumos de la venta original.');
          }

          const insumosFormat = res.data.insumos.map((insumo) => {
            const divisor = insumo.cantidad > 0 ? insumo.cantidad : 1; 
            const precioUnitarioConImpuestos = insumo.precioUnitario + (insumo.impuestos / divisor);
            return { 
              ...insumo, 
              precioUnitarioConImpuestos 
            };
          });

          await this.setState({
            todasInsumos: insumosAgregarTodos,
            ubicacionesEnvio: Array.isArray(res.data.ubicacionesEnvio) ? res.data.ubicacionesEnvio.map(value => ({ ...value, _id: undefined })) : undefined,
            mercanciasEnvio: Array.isArray(res.data.mercanciasEnvio) ? res.data.mercanciasEnvio.map(value => ({ ...value, _id: undefined })) : undefined,
          });

          this.onChangeContado(res.data.contado)


          const tiposDescuentoIniciales = {};
          (res.data.insumos || []).forEach((insumo, index) => {
            if (insumo.descuentoCantidad && insumo.descuentoCantidad > 0) {
              tiposDescuentoIniciales[index] = 'cantidad';
            } else {
              tiposDescuentoIniciales[index] = 'porcentaje';
            }
          });

          this.setState({ tiposDescuento: tiposDescuentoIniciales });

          const insumosBulkPayload = insumosFormat.map((insumo, index) => {
            const insumoIdString = insumo.insumoId?._id || insumo.insumoId;
            const insumoOriginal = insumosAgregarTodos.find(
                (i) => i._id.toString() === insumoIdString.toString()
            );
            return {
                index: index,
                insumoId: insumoIdString,
                proyectoId: insumo.proyectoId || res.data.proyectoId,
                inventariable: insumoOriginal?.inventariable,
                noPrincipal: insumoOriginal?.noPrincipal,
                insumoCompuesto: insumoOriginal?.insumoCompuesto,
                componentesKit: insumo.componentesKit,
            };
          });

          try {
            const resInventarios = await axios.post("inventarios/inventarioInsumoProyectoBulk", { 
                empresaId: this.props.empresaId,
                proyectoId: res.data.proyectoId, 
                insumos: insumosBulkPayload 
            }, { headers: this.props.headersToken });
            
            if (resInventarios.data && resInventarios.data.results) {
                resInventarios.data.results.forEach(resItem => {
                    if (insumosFormat[resItem.index]) {
                        insumosFormat[resItem.index].cantidadProyecto = 
                            resItem.cantidad !== null ? resItem.cantidad : "No inventariable";
                    }
                });
            }
          } catch (error) {
              console.error("Error al consultar inventario", error);
          }
          await this.formRef.current.setFieldsValue({
            factura: res.data.factura ? 1 : 2,
            contado: res.data.contado,
            clienteId: res.data.clienteId,
            vendedorId: res.data.vendedorId,
            monedaId: res.data.monedaId,
            tipoDeCambio: res.data.tipoDeCambio,
            doctorId: res.data.doctorId,
            pacienteId: res.data.pacienteId,
            cirugiaId: res.data.cirugiaId,
            bancoId: res.data.bancoId,
            cuentasXC: res.data.cuentasXC,
            proyectoId: res.data.proyectoId,
            formaPagoId: res.data.formaPagoId,
            precioId: res.data.precioId,
            diasCredito: res.data.diasCredito,
            usoDeCfdiId: res.data.usoDeCfdiId,
            ordenDeCompra: res.data.ordenDeCompra,
            insumos: insumosFormat,
            proyectoTransporteId: res.data.proyectoTransporteId,
            remolquesIds: res.data.remolquesIds,
            remolquesEventuales: res.data.remolquesEventuales,
            choferesIds: res.data.choferesIds,
            tranporteInt: res.data.tranporteInt,
            registroISTMO: res.data.registroISTMO,
            ubicacionPoloOrigenId: res.data.ubicacionPoloOrigenId,
            ubicacionPoloDestinoId: res.data.ubicacionPoloDestinoId,
            leyendasFiscales: res.data.leyendasFiscales || [],
          })
          this.contadoAnterior = res.data.contado;
          this.precioIdAnterior = res.data.precioId;

          this.recalcularInsumosEnBatch(insumosFormat);

        } else {
          message.error('No se pudo obtener la venta a duplicar')
        }
      }).catch((err) => {
        message.error('Error al obtener la venta a duplicar')
      })

    }

    this.setState({ loading: false });

    // Al montar: un documento que llega precargado (duplicado, o desde
    // cotizaciones/pedidos/embarques seleccionados) ya trae cliente y lista, y sin
    // esto se quedaria sin reglas hasta que el usuario tocara uno de los dos.
    this.reglas.consultarContexto();
  }

  estaBloqueado = (campo, index) => {
    const permisoProp = {
      precioUnitario: "permisoModificarPrecioUnitario",
      descuento: "permisoModificarDescuento",
      listaPrecios: "permisoModificarListaPrecios",
    }[campo];
    const clave = index !== undefined && index !== null ? `${campo}:${index}` : campo;
    return !this.props[permisoProp] && !this.state.autorizacionesActivas[clave]?.accesoLibre;
  };

  tieneInsumoSeleccionado = (index) =>
    !!this.formRef.current?.getFieldValue(["insumos", index, "insumoId"]);

  /**
   * Carga las reglas de precio aplicables al cliente y la lista actuales.
   * Las reglas llegan en crudo: la resolución final depende de la familia y la
   * marca de cada insumo, así que se apilan renglón por renglón.
   */
  abrirModalAutorizacion = (campo, index, reanudarGuardado) => {
    const definicion = PERMISOS_AUTORIZABLES[campo];
    if (!definicion) return;
    const clave = index !== undefined && index !== null ? `${campo}:${index}` : campo;
    let contexto = { modulo: "VENTA", campo, descripcion: definicion.etiqueta };
    if (index !== undefined && index !== null) {
      const insumos = this.formRef.current?.getFieldValue("insumos") || [];
      const item = insumos[index] || {};
      const insumoOriginal = this.state.todasInsumos.find(
        (i) => i._id === item.insumoId
      );
      const insumoNombre = insumoOriginal?.nombre || insumoOriginal?.descripcion || "";
      contexto = {
        ...contexto,
        insumoId: item.insumoId,
        insumoNombre,
        valorActual:
          campo === "descuento"
            ? item.descuento ?? item.descuentoCantidad ?? 0
            : item.precioUnitario,
        tipoDescuento: campo === "descuento" ? this.state.tiposDescuento[index] : undefined,
        descripcion: `${definicion.etiqueta}${insumoNombre ? ` — ${insumoNombre}` : ""}`,
      };
    } else if (campo === "listaPrecios") {
      const clienteId = this.formRef.current?.getFieldValue("clienteId");
      const cliente = this.state.todasClientes?.find((c) => c._id === clienteId);
      const clienteNombre = cliente
        ? cliente.persona
          ? cliente.razonSocial || ""
          : `${cliente.nombre || ""} ${cliente.apellidoPaterno || ""} ${cliente.apellidoMaterno || ""}`.trim()
        : "";
      const precioIdActual = this.formRef.current?.getFieldValue("precioId");
      const precioActual = this.state.todasPrecios?.find((p) => p._id === precioIdActual);
      contexto = {
        ...contexto,
        valorActual: precioActual?.nombre || undefined,
        descripcion: `${definicion.etiqueta}${clienteNombre ? ` — ${clienteNombre}` : ""}`,
      };
    }
    this.setState({
      modalAutorizacion: { visible: true, permisoId: definicion.permisoId, campo, index, clave, contexto, reanudarGuardado },
    });
  };

  onAutorizado = async (datos) => {
    const { modalAutorizacion } = this.state;
    if (!modalAutorizacion) return;
    const { campo, index } = modalAutorizacion;
    if (!datos.accesoLibre && datos.valorSolicitado !== undefined && datos.valorSolicitado !== null) {
      if (index !== undefined && index !== null) {
        const insumos = this.formRef.current.getFieldValue("insumos") || [];
        const campoDestino =
          campo === "descuento"
            ? (this.state.tiposDescuento[index] === "cantidad"
              ? "descuentoCantidad"
              : (this.props.escuela ? "descuentoAdicional" : "descuento"))
            : campo;
        insumos[index] = { ...insumos[index], [campoDestino]: datos.valorSolicitado };
        if (this.props.escuela && campo === "descuento") sincronizarDescuentoFila(insumos[index]);
        this.formRef.current.setFieldsValue({ insumos });
      } else if (campo === "listaPrecios") {
        this.formRef.current.setFieldsValue({ precioId: datos.valorSolicitado });
        this.precioIdAnterior = datos.valorSolicitado;
        const insumos = this.formRef.current.getFieldValue("insumos");
        if (insumos?.length > 0) {
          message.info("Se actualizaron los precios de los insumos según la nueva lista de precios autorizada.");
          this.recalcularPreciosTodosLosInsumos(datos.valorSolicitado);
        }
      }
    }
    this.setState(
      {
        autorizacionesActivas: {
          ...this.state.autorizacionesActivas,
          [modalAutorizacion.clave]: datos,
        },
        modalAutorizacion: null,
      },
      () => {
        // Si la autorización venía de un rango fuera de límite al guardar, se
        // reanuda la venta ahora que el campo ya está cubierto.
        if (!modalAutorizacion.reanudarGuardado) return;
        if (this.reglas.primeraSinAutorizar()) return;
        this.onFinish(this.state.valuesForm);
      }
    );
  };

  autorizacionesParaPayload = () =>
    Object.values(this.state.autorizacionesActivas).map((a) => ({
      autorizacionId: a.autorizacionId,
      tokenConsumo: a.tokenConsumo,
    }));

  /**
   * Primera violación de rango que todavía no tiene autorización.
   *
   * El perdón es por campo y por documento, igual que en el backend: una
   * autorización de descuento cubre los demás renglones del mismo documento.
   */


  onFinishFailed(e) {
    ErrorItem(e);
  }
  // Solo visual: reutiliza EXACTAMENTE la misma condición de inventario del onFinish
  // (unión de ambas ramas, según la configuración: entregarInsumos / venderSinInventario /
  // agregarSinAfectarInventario / entregarDisponibles) para saber qué filas provocan el error. No altera ninguna
  // validación, condición ni variable existente.
  calcularFilasConErrorInventario(insumos = []) {
    return (insumos || []).reduce((acc, valueInsumo, index) => {
      if (
        !this.state.agregarSinAfectarInventario &&
        valueInsumo?.cantidadProyecto !== "No inventariable" &&
        valueInsumo?.cantidad > valueInsumo?.cantidadProyecto &&
        (this.state.entregarInsumos || (!this.state.venderSinInventario && !this.state.entregarDisponibles))
      ) {
        acc.push(index);
      }
      return acc;
    }, []);
  }
  // "Agregar y Entregar Disponibles": la venta ya se guardó como con "+ Agregar"; aquí se
  // entrega lo que alcance con el inventario. Si falla, la venta sólo queda pendiente de entregar.
  async entregarDisponiblesDespuesDeAgregar(ventaId) {
    this.setState({ loading: true });
    try {
      const res = await axios.post(
        "ventas/entregarDisponiblesVenta",
        { empresaId: this.props.empresaId, ventaId },
        { headers: this.props.headersToken }
      );
      const { success, entregaId, resumen, polizasId, movimientosIds } = res.data || {};
      if (success !== 2) {
        message.warning("La venta se guardó, pero no se pudieron entregar los insumos: " + (res.data?.message || "error desconocido"));
        return;
      }
      if (!entregaId) {
        message.warning(res.data.message);
        return;
      }
      NotificacionPolizas(polizasId);
      NotificacionMovimientosInventario(movimientosIds);
      if (!resumen?.omitidos?.length) {
        message.success("Se entregaron todos los insumos");
        return;
      }
      message.success(`Entrega: ${resumen.entregados} renglón(es) completos, ${resumen.parciales} parciales y ${resumen.pendientes} sin entregar`);
      notification.info({
        message: "Quedó pendiente por entregar",
        description: (
          <ul style={{ paddingLeft: 16, margin: 0 }}>
            {resumen.omitidos.map((omitido, index) => (
              <li key={index}>{omitido.descripcion}: {omitido.pendiente} ({omitido.motivo})</li>
            ))}
          </ul>
        ),
        duration: 0,
      });
    } catch (err) {
      message.warning("La venta se guardó, pero no se pudieron entregar los insumos. Entréguelos desde Entregar Insumos.");
    } finally {
      this.setState({ loading: false });
    }
  }
  onFinish(values) {
    if (!values.insumos || values.insumos?.length === 0)
      return message.warning("Agregue insumos para agregar la venta");

    // Solo visual: marca las filas con conflicto de inventario al enviar.
    this.setState({ filasConError: this.calcularFilasConErrorInventario(values.insumos) });

    for (const valueInsumo of values.insumos) {
      if (this.state.entregarInsumos && !this.state.agregarSinAfectarInventario && valueInsumo.cantidadProyecto !== "No inventariable" && valueInsumo.cantidad > valueInsumo.cantidadProyecto) {
        return message.warning("No se pueden entregar los insumos ya que supera la cantidad disponible");
      } else if (!this.state.entregarInsumos && !this.state.agregarSinAfectarInventario && !this.state.venderSinInventario && !this.state.entregarDisponibles && valueInsumo.cantidadProyecto !== "No inventariable" && valueInsumo.cantidad > valueInsumo.cantidadProyecto) {
        return message.warning("No se puede agregar la venta ya que no hay suficientes insumos");
      }
    }

    if (this.state.flete && this.props.fletes) {
      if (!this.state.ubicacionesEnvio || this.state.ubicacionesEnvio?.length < 1 || !this.state.mercanciasEnvio || this.state.mercanciasEnvio?.length < 1) {
        return message.info('Agregar ubicaciones y mercancias para el flete')
      }
    }

    if (this.state.marcarVentaOnline) {
      if (!this.state.deliveryMethod) {
        return message.warning('Selecciona el método de entrega de la venta online (recolección en sucursal o entrega local)');
      }
      if (this.state.deliveryMethod === 'pickup' && !this.state.pickupBranchId) {
        return message.warning('Selecciona la sucursal de recolección');
      }
      if (this.state.deliveryMethod === 'local' && !values.direccionEntrega) {
        return message.warning('Capture la dirección de entrega en la pestaña "Entrega"');
      }
    }

    // Rangos de margen y descuento de la lista de precios. Si algún renglón se
    // sale y ese campo no está autorizado todavía, se pide la autorización y la
    // venta se reanuda desde onAutorizado. El backend valida lo mismo.
    const violacionPendiente = this.reglas.primeraSinAutorizar();
    if (violacionPendiente) {
      this.setState({ valuesForm: values });
      message.warning(violacionPendiente.motivo);
      this.abrirModalAutorizacion(violacionPendiente.campo, violacionPendiente.index, true);
      return;
    }

    this.setState({ loading: true });
    let insumos = values.insumos;
    let total = 0;
    let subtotal = 0;
    let arrayImpuestos = [];
    let arrayRetenciones = [];
    let cuentasCliente = 0;
    insumos.map((value) => {
      total += value.subtotal;
      subtotal += value.subtotal;
      value.arrayImpuestos.map((valueImpuestos) => {
        let index = arrayImpuestos.findIndex(
          (valueImpuestosAnterios) =>
            valueImpuestosAnterios.descripcionFactura ===
            valueImpuestos.descripcionFactura
            &&
            valueImpuestosAnterios.tasaCuota ===
            valueImpuestos.tasaCuota
            &&
            valueImpuestosAnterios.impuesto ===
            valueImpuestos.impuesto
        );
        if (index !== -1) {
          let newItem = {
            totalImpuestos:
              arrayImpuestos[index].totalImpuestos +
              valueImpuestos.totalImpuestos,
            baseImpuesto:
              arrayImpuestos[index].baseImpuesto +
              valueImpuestos.baseImpuesto,
            descripcionFactura:
              valueImpuestos.descripcionFactura,
            tasaCuota:
              valueImpuestos.tasaCuota,
            impuesto:
              valueImpuestos.impuesto,
            montoImpuesto:
              valueImpuestos.montoImpuesto,
            local: valueImpuestos.local,
          };
          arrayImpuestos.splice(index, 1, newItem);
        } else {
          arrayImpuestos.push({
            tasaCuota: valueImpuestos.tasaCuota,
            local: valueImpuestos.local,
            impuesto: valueImpuestos.impuesto,
            montoImpuesto: valueImpuestos.montoImpuesto,
            baseImpuesto: valueImpuestos.baseImpuesto,
            descripcionFactura: valueImpuestos.descripcionFactura,
            totalImpuestos: valueImpuestos.totalImpuestos,
          });
        }
        return null;
      });
      if (value.arrayRetenciones) {
        value.arrayRetenciones.map((valueRetenciones) => {
          let index = arrayRetenciones.findIndex(
            (valueRetencionesAnterios) =>
              valueRetencionesAnterios.descripcionFactura ===
              valueRetenciones.descripcionFactura
              &&
              valueRetencionesAnterios.tasaCuota ===
              valueRetenciones.tasaCuota
              &&
              valueRetencionesAnterios.impuesto ===
              valueRetenciones.impuesto
          );
          cuentasCliente += round2Decimals(valueRetenciones.totalRetenciones);
          if (index !== -1) {
            let newItem = {
              totalRetenciones:
                arrayRetenciones[index].totalRetenciones +
                valueRetenciones.totalRetenciones,
              baseRetencion:
                arrayRetenciones[index].baseRetencion +
                valueRetenciones.baseRetencion,
              descripcionFactura:
                valueRetenciones.descripcionFactura,
              tasaCuota:
                valueRetenciones.tasaCuota,
              impuesto:
                valueRetenciones.impuesto,
              montoRetencion:
                valueRetenciones.montoRetencion,
              local: valueRetenciones.local,
            };
            arrayRetenciones.splice(index, 1, newItem);
          } else {
            arrayRetenciones.push({
              tasaCuota: valueRetenciones.tasaCuota,
              impuesto: valueRetenciones.impuesto,
              montoRetencion: valueRetenciones.montoRetencion,
              baseRetencion: valueRetenciones.baseRetencion,
              local: valueRetenciones.local,
              descripcionFactura: valueRetenciones.descripcionFactura,
              totalRetenciones: valueRetenciones.totalRetenciones,
            });
          }
          return null;
        });
      }
      return null;
    });
    arrayImpuestos = arrayImpuestos.map(valueImpuesto => {
      total += round2Decimals(valueImpuesto.totalImpuestos)
      return {
        ...valueImpuesto,
        totalImpuestos: round2Decimals(valueImpuesto.totalImpuestos),
      }
    })

    if (this.state.xmlSubido) {
      if (Math.abs(round2Decimals(this.state.totalFIngresada - round2Decimals(total - cuentasCliente))) > 0.01) {
        this.setState({ loading: false });
        return message.warning('El total de la factura no coincide con el total de la venta Total de la factura: ' + this.state.totalFIngresada + ' Total de la venta: ' + round2Decimals(total))
      }

      if (Math.abs(round2Decimals(this.state.subtotalFIngresada - round2Decimals(subtotal))) > 0.01) {
        this.setState({ loading: false });
        return message.warning('El subtotal de la factura no coincide con el subtotal de la venta Subtotal de la factura: ' + this.state.subtotalFIngresada + ' Subtotal de la venta: ' + round2Decimals(subtotal))
      }
    }
    //Hotelería: la estancia se captura con DatePicker (moment con la hora actual pegada) y se manda
    //como "YYYY-MM-DD" para que el backend la ancle al día correcto; un renglón sin estancia completa
    //se manda en null y queda como una venta normal. Ver hospedajeParaPayload.
    if (this.props.moduloHoteleria) {
      values.insumos = values.insumos.map((valueInsumo) => ({
        ...valueInsumo,
        hospedaje: hospedajeParaPayload(valueInsumo.hospedaje),
      }));
    }

    //Misma regla que la estancia: es un día de calendario, no un instante. El DatePicker
    //le pega la hora actual, y el backend corre en UTC, así que se manda como "YYYY-MM-DD"
    //para que parsearFechaDia lo ancle al día correcto.
    values.fechaPagoInformativa = values.fechaPagoInformativa
      ? moment(values.fechaPagoInformativa).format("YYYY-MM-DD")
      : undefined;

    axios
      .post(
        "ventas/agregarVenta",
        {
          ...values,
          anticipo: this.props.location?.state?.anticipo || false,
          empresaId: this.props.empresaId,
          cotizacionesSeleccionadas: this.state.cotizacionesSeleccionadas,
          cotizacionId: this.state.cotizacionId,
          pedidosSeleccionados: this.state.pedidosSeleccionados,
          pedidoId: this.state.pedidoId,
          embarquesSeleccionados: this.state.embarquesSeleccionados,
          embarqueId: this.state.embarqueId,
          cerrarCotizaciones: this.state.cerrarCotizaciones,
          cerrarPedidos: this.state.cerrarPedidos,
          cerrarEmbarques: this.state.cerrarEmbarques,
          ...this.construirPaquetesEscolares(values.clienteId, values.insumos),
          ventaOnline: this.state.marcarVentaOnline || undefined,
          clienteOnline: this.state.marcarVentaOnline ? this.construirClienteOnline(values.clienteId) : undefined,
          cotizacionesEnvioOnline: this.state.marcarVentaOnline ? this.construirCotizacionEnvioOnline() : undefined,
          total,
          subtotal,
          cuentasCliente: round2Decimals(cuentasCliente),
          totalPagar: round2Decimals(total - cuentasCliente),
          arrayImpuestos,
          arrayRetenciones,
          autorizaciones: this.autorizacionesParaPayload(),
          entregarInsumos: this.state.entregarInsumos,
          agregarSinAfectarInventario: this.state.agregarSinAfectarInventario,
          ubicacionesEnvio: this.state.ubicacionesEnvio,
          mercanciasEnvio: this.state.mercanciasEnvio,
          xmlSubido: this.state.xmlSubido,
          cadenaOriginalSAT: this.state.cadenaOriginalSAT,
          noCertificadoSAT: this.state.noCertificadoSAT,
          noCertificadoCFDI: this.state.noCertificadoCFDI,
          uuid: this.state.uuid,
          selloSAT: this.state.selloSAT,
          selloCFDI: this.state.selloCFDI,
          fechaTimbrado: this.state.fechaTimbrado,
          qrCode: this.state.qrCode,
          cfdi: this.state.cfdi,
          folioFIngresada: this.state.folioFIngresada,
          serieFIngresada: this.state.serieFIngresada,
          totalFIngresada: this.state.totalFIngresada,
          subtotalFIngresada: this.state.subtotalFIngresada,
        },
        { headers: this.props.headersToken }
      )
      .then(async (res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se ha registrado una venta");
          if (this.state.entregarDisponibles) {
            await this.entregarDisponiblesDespuesDeAgregar(res.data.ventaId);
          }
          if (res.data.respuestaFactura.status === "success") {

            if (window.registrarMovimiento) {
              const dataSat = res.data.respuestaFactura.dataSat;
              const nombreArchivo = (dataSat.Serie ? dataSat.Serie : 'F') + ' - ' + dataSat.Folio + ' ( ' + dataSat.Receptor.Rfc + ' - ' + dataSat.Receptor.Nombre + ' )';

              window.registrarMovimiento({
                titulo: 'Factura Emitida',
                mensaje: `${nombreArchivo} - Haga click para descargar`,
                icono: 2, // DownloadOutlined
                onClick: () => {
                  var xmltext = res.data.respuestaFactura.data.cfdi;

                  // Crear el archivo XML (pero no descargarlo directamente)
                  const archivos = [
                    { nombre: `${nombreArchivo}.xml`, contenido: xmltext },
                  ];

                  // Generar el PDF y agregarlo al ZIP
                  const pdf = facturaPdf(res.data);
                  pdfMake.createPdf(pdf).getBlob((blob) => {
                    archivos.push({ nombre: `${nombreArchivo}.pdf`, contenido: blob });

                    // Comprimir los archivos (XML y PDF) en un ZIP y descargarlo
                    Compress(archivos, nombreArchivo, res?.data?.respuestaFactura?.empresa?.facturaZip);
                  });
                  // Eliminamos la descarga directa del XML
                  /*
                  var filename = nombreArchivo + ".xml";
                  var pom = document.createElement("a");
                  var bb = new Blob([xmltext], { type: "text/plain" });
              
                  pom.setAttribute("href", window.URL.createObjectURL(bb));
                  pom.setAttribute("download", filename);
              
                  pom.dataset.downloadurl = [
                      "text/plain",
                      pom.download,
                      pom.href,
                  ].join(":");
                  pom.draggable = true;
                  pom.classList.add("dragout");
              
                  pom.click();
                  */
                },
              });
            }
            NotificacionPolizas(res.data.polizasId);
            NotificacionMovimientosInventario(res.data.movimientosIds);
            this.setState({
              modalCorreo: true,
              modalCorreoId: res.data.ventaId,
            });
          } else {
            // Registrar movimiento en lugar de mostrar popup
            if (window.registrarMovimiento) {
              const dataSat = res.data.respuestaFactura.dataSat;
              const nombreArchivo = (dataSat.Serie ? dataSat.Serie : 'R') + ' - ' + dataSat.Folio + ' ( ' + dataSat.Receptor.Nombre + ' )';

              window.registrarMovimiento({
                titulo: 'Remisión Emitida',
                mensaje: `${nombreArchivo} - Haga click para descargar`,
                icono: 2, // DownloadOutlined
                onClick: () => {
                  const pdf = remisionPdf(res.data);
                  pdfMake.createPdf(pdf).download(nombreArchivo + '.pdf');
                },
              });
            }

            NotificacionPolizas(res.data.polizasId);
            NotificacionMovimientosInventario(res.data.movimientosIds);
            this.setState({
              modalCorreo: true,
              modalCorreoId: res.data.ventaId,
            });
          }
          if (res.data.respuestaFactura?.empresa?.tikets) {
            this.printTicket(res.data, res.data.respuestaFactura?.empresa, res.data?.respuestaFactura?.dataSat?.MetodoPago === "PUE");
          }
          if (Array.isArray(res.data.notasAnticipos)) {
            res.data.notasAnticipos.forEach((nota) => {
              if (nota.exito) {
                notification.success({
                  message: "Nota de crédito de anticipo",
                  description: "La nota de crédito se generó correctamente.",
                  duration: 6,
                });
              } else {
                notification.error({
                  message: "Error en nota de crédito de anticipo",
                  description: (nota.message || "No se pudo generar la nota de crédito.") + " Por favor, genérala manualmente desde la venta.",
                  duration: 0,
                });
              }
            });
          }
        } else if (res.data.success === 1) {
          MensajeError({
            message: res.data.errorTimbrado?.titulo || res.data.message || "No se pudo registrar la venta",
            description: res.data.errorTimbrado?.mensaje || res.data.description,
            detalleTecnico: res.data.errorTimbrado?.detalleTecnico,
          });
        } else {
          message.error("Hubo un error y la venta no se registro");
        }
      });
  }

  activarQzTray = () => {
    qz.security.setCertificatePromise(function (resolve, reject) {
      //Preferred method - from server
      fetch("../cert_qz_tray.txt", { cache: 'no-store', headers: { 'Content-Type': 'text/plain' } })
        .then(function (data) { data.ok ? resolve(data.text()) : reject(data.text()); });
    })

    qz.security.setSignatureAlgorithm("SHA512"); // Since 2.1
    qz.security.setSignaturePromise(function (toSign) {
      return function (resolve, reject) {
        // Preferred method - from server

        // axios.post('/puntoVenta/signQzTray', toSign, {
        //   headers: {
        //     ...this.props.headersToken,
        //     'Content-Type': 'text/plain',
        //   }
        // })
        //   .then(response => {
        //     console.log("Firma recibida:", response.data);
        //     resolve(response.data); // ✔️ Texto plano (la firma base64)
        //   })
        //   .catch(error => {
        //     console.error('Error firmando para QZ Tray:', error);
        //     reject("No se pudo firmar el contenido");
        //   });

        fetch("../erp/api/puntoVenta/signQzTray?request=" + toSign, { cache: 'no-store', headers: { 'Content-Type': 'text/plain' } })
          .then(function (data) { data.ok ? resolve(data.text()) : reject(data.text()); });

        //Alternate method - unsigned
        // resolve(); // remove this line in live environment
      };
    });
  }

  recalcularInsumosEnBatch(insumosFormat) {
    const clienteId = this.formRef.current.getFieldValue("clienteId");
    const tipoDeCambio = this.formRef.current.getFieldValue("tipoDeCambio");
    const noTax = this.state.quitarImpuestos;
    const arrayValue = [...insumosFormat];

    arrayValue.forEach((item, key) => {
        if (this.props.escuela) normalizarDescuentoFila(item);
        const insumoId = item.insumoId?._id || item.insumoId;
        const insumo = this.state.todasInsumos.find(
            (v) => v._id.toString() === insumoId?.toString()
        );
        if (!insumo) return;

        const precioUnitario = Number(item.precioUnitario);

        let totalImpuestosPrecioSinImpuestos = 0;
        if (!noTax) {
            insumo.impuestos.forEach((valueImpuesto) => {
                let totalImpuesto;
                if (valueImpuesto.tasaCuota === 1) {
                    totalImpuesto = precioUnitario * (valueImpuesto.monto / 100);
                } else if (valueImpuesto.tasaCuota === 2) {
                    totalImpuesto = (precioUnitario + totalImpuestosPrecioSinImpuestos) * (valueImpuesto.monto / 100);
                } else if (valueImpuesto.tasaCuota === 3) {
                    totalImpuesto = valueImpuesto.monto / tipoDeCambio;
                } else {
                    totalImpuesto = 0;
                }
                totalImpuestosPrecioSinImpuestos += totalImpuesto;
            });
        }
        arrayValue[key].precioUnitarioConImpuestos = round2Decimals(precioUnitario + totalImpuestosPrecioSinImpuestos);

        const cantidad = item.cantidad;
        const descuento = item.descuento || 0;
        const descuentoCantidad = item.descuentoCantidad || 0;

        if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
            const subtotal = round6Decimals(cantidad * precioUnitario);
            const totalDescuento = round6Decimals(((subtotal * (descuento / 100)) || 0) + descuentoCantidad);
            const totalEntrada = round6Decimals(subtotal - totalDescuento);
            arrayValue[key].subtotal = totalEntrada;

            let totalImpuestos = 0;
            let arrayImpuestos = [];
            if (!noTax) {
                arrayImpuestos = insumo.impuestos.map((valueImpuesto) => {
                    let totalImpuesto, baseImpuesto, montoImpuesto;
                    if (valueImpuesto.tasaCuota === 1) {
                        totalImpuesto = round6Decimals(totalEntrada * (valueImpuesto.monto / 100));
                        baseImpuesto = totalEntrada;
                        montoImpuesto = round6Decimals(valueImpuesto.monto / 100);
                    } else if (valueImpuesto.tasaCuota === 2) {
                        totalImpuesto = round6Decimals((totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100));
                        baseImpuesto = totalEntrada + totalImpuestos;
                        montoImpuesto = round6Decimals(valueImpuesto.monto / 100);
                    } else if (valueImpuesto.tasaCuota === 3) {
                        totalImpuesto = round6Decimals((cantidad * valueImpuesto.monto) / tipoDeCambio);
                        baseImpuesto = cantidad;
                        montoImpuesto = round6Decimals(valueImpuesto.monto / tipoDeCambio);
                    } else {
                        totalImpuesto = 0; baseImpuesto = totalEntrada; montoImpuesto = 0;
                    }
                    totalImpuestos += totalImpuesto;
                    return { tasaCuota: valueImpuesto.tasaCuota, impuesto: valueImpuesto.impuesto, montoImpuesto, local: valueImpuesto.local, baseImpuesto, descripcionFactura: valueImpuesto.descripcionFactura, totalImpuestos: totalImpuesto };
                });
            }
            arrayValue[key].impuestos = totalImpuestos;
            arrayValue[key].arrayImpuestos = arrayImpuestos;
            arrayValue[key].total = round2Decimals(totalEntrada + totalImpuestos);

            if (!noTax && clienteId) {
                const cliente = this.state.todasClientes?.find((v) => v._id === clienteId);
                if (cliente) {
                    let totalRetenciones = 0;
                    const arrayRetenciones = [];
                    [...cliente.retenciones, ...insumo.retenciones.filter(r =>
                        (r.aplicaVenta === 1 && !cliente.persona) ||
                        (r.aplicaVenta === 2 && cliente.persona) ||
                        r.aplicaVenta === 3
                    )].forEach((valueRetencion) => {
                        let totalRetencion, baseRetencion;
                        if (valueRetencion.tasaCuota === 1) {
                            totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
                            baseRetencion = totalEntrada;
                        } else if (valueRetencion.tasaCuota === 2) {
                            totalRetencion = round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
                            baseRetencion = totalEntrada + totalImpuestos;
                        }
                        totalRetenciones += totalRetencion;
                        arrayRetenciones.push({ tasaCuota: valueRetencion.tasaCuota, impuesto: valueRetencion.impuesto, montoRetencion: valueRetencion.monto, local: valueRetencion.local, baseRetencion, descripcionFactura: valueRetencion.descripcionFactura, totalRetenciones: totalRetencion });
                    });
                    arrayValue[key].retenciones = totalRetenciones;
                    arrayValue[key].arrayRetenciones = arrayRetenciones;
                }
            } else if (noTax) {
                arrayValue[key].retenciones = 0;
                arrayValue[key].arrayRetenciones = [];
            }
        }
    });

    this.formRef.current.setFieldsValue({ insumos: arrayValue });
}

  componentWillUnmount() {
    document.removeEventListener("keydown", this.eventListenerKeyboards, { capture: true });
    clearTimeout(this.idleTimer);
  }

  // --- CONFIG ---
  SCAN_GAP_MS = 25;
  FAST_KEYS_TO_ARM = 3;    // puedes dejar 3
  IDLE_TIMEOUT_MS = 80;
  MIN_SCAN_LEN = 4;

  // --- STATE ---
  buffer = "";
  tempBuffer = [];         // <— acumula TODO desde la 1ª tecla
  lastTs = 0;
  fastCount = 0;
  scanning = false;
  idleTimer = null;

  eventListenerKeyboards = (e) => {
    // Escribir rapido en el buscador de la busqueda avanzada pareceria un escaneo y escribiria
    // renglones en paralelo a las altas del modal.
    if (this.state.modalBusquedaAvanzadaVisible) return;
    const tag = (e.target && e.target.tagName) || "";
    const isTypingField = /INPUT|TEXTAREA|SELECT/.test(tag);
    const key = e.key;
    const isPrintable = key && key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey;
    const isEndKey = key === "Enter" || key === "Tab";
    if (!isPrintable && !isEndKey) return;

    const now = performance.now();
    const delta = now - (this.lastTs || now);
    this.lastTs = now;

    // -------- NO ESCANEANDO AÚN --------
    if (!this.scanning) {
      if (isPrintable) {
        // si hubo pausa, empezamos nueva racha (y tempBuffer arranca en la tecla actual)
        if (delta >= this.SCAN_GAP_MS) {
          this.fastCount = 0;
          this.tempBuffer = [];
        } else {
          this.fastCount += 1;
        }

        // SIEMPRE guarda la tecla en tempBuffer (para no perder la 1ª)
        this.tempBuffer.push(key);

        // ¿armamos? (ya hubo suficientes teclas rápidas)
        if (this.fastCount >= this.FAST_KEYS_TO_ARM - 1) {
          this.scanning = true;

          // bloquea escritura desde ESTA tecla en adelante
          e.preventDefault();
          e.stopPropagation();

          // si veníamos tecleando en un input, borra lo ya escrito (tempBuffer)
          if (isTypingField && e.target && typeof e.target.value === "string") {
            try {
              const el = e.target;
              const len = this.tempBuffer.length;
              const end = el.selectionEnd ?? el.value.length;
              const start = Math.max(0, end - len);
              el.value = el.value.slice(0, start) + el.value.slice(end);
              if (el.setSelectionRange) el.setSelectionRange(start, start);
              el.dispatchEvent(new Event("input", { bubbles: true }));
            } catch { }
            if (e.target?.blur) e.target.blur();
          }

          // siembra el buffer con TODO lo capturado (incluye el primer dígito)
          this.buffer = this.tempBuffer.join("");

          clearTimeout(this.idleTimer);
          this.idleTimer = setTimeout(this.finishIfScan, this.IDLE_TIMEOUT_MS);
          return;
        }

        // aún no armado → deja pasar la escritura normal
        return;
      }
      // Enter/Tab sin armar → ignora
      return;
    }

    // -------- YA EN MODO ESCÁNER --------
    if (isPrintable) {
      e.preventDefault();
      e.stopPropagation();
      this.buffer += key;
      clearTimeout(this.idleTimer);
      this.idleTimer = setTimeout(this.finishIfScan, this.IDLE_TIMEOUT_MS);
      return;
    }
    if (isEndKey) {
      e.preventDefault();
      e.stopPropagation();
      this.finishIfScan();
      return;
    }
  };

  finishIfScan = () => {
    clearTimeout(this.idleTimer);
    const code = (this.buffer || "").trim();

    // reset SIEMPRE antes de llamar
    this.buffer = "";
    this.tempBuffer = [];
    this.fastCount = 0;
    this.scanning = false;

    if (code.length >= this.MIN_SCAN_LEN && !this.state?.loading) {
      this.leerCodigo?.(code);
    }
  };



  async leerCodigo(codigo) {
    const proyecto = this.formRef.current.getFieldValue("proyectoId");
    const precio = this.formRef.current.getFieldValue("precioId");
    const cliente = this.formRef.current.getFieldValue("clienteId");
    const moneda = this.formRef.current.getFieldValue("monedaId");
    const tipoDeCambio = this.formRef.current.getFieldValue("tipoDeCambio");
    if (!proyecto || !precio || !cliente || !moneda || !tipoDeCambio) {
      return message.warning("Primero llene los datos principales");
    }
    let insumo

    if (Array.isArray(this.state.todasInsumos)) {
      const insumoPrecargado = this.state.todasInsumos.find(i => i.codigoBarras === codigo);
      if (insumoPrecargado) {
        insumo = insumoPrecargado;
      }
    }

    if (!insumo) {
      await axios.post(
        "puntoVenta/obtenerInsumoPorCodigo",
        {
          codigoBarras: codigo,
          proyectoId: proyecto,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
        .then(res => {
          if (res.data && res.data.success === 2 && res.data.insumo) {
            insumo = res.data.insumo;
            message.success(`Producto "${insumo.stringBuscar}" encontrado`);
          } else {
            message.error('Producto no encontrado');
          }
        })
        .catch(error => {
          console.error("Error al buscar insumo:", error);
          message.error('Error al buscar producto');
        });
    }
    if (!insumo) {
      return message.warning("No encontramos el producto");
    }
    const insumosEnVenta = this.formRef.current.getFieldValue("insumos") || [];
    const indexInsumoEnVenta = insumosEnVenta.findIndex((todosInsumosVenta) => {
      if (todosInsumosVenta.insumoId) {
        return (
          todosInsumosVenta?.insumoId?.toString() ===
          insumo._id.toString()
        );
      } else {
        return false;
      }
    })
    if (indexInsumoEnVenta === -1) {
      const indexInsumoEnVentaSinInsumo = insumosEnVenta.findIndex((todosInsumosVenta) => {
        return !todosInsumosVenta?.insumoId && !todosInsumosVenta?.precioUnitario && !todosInsumosVenta?.cantidad;
      })
      if (indexInsumoEnVentaSinInsumo !== -1) {
        const insumosConNuevaCantidad = [...insumosEnVenta];
        insumosConNuevaCantidad[indexInsumoEnVentaSinInsumo].insumoId = insumo._id?.toString();
        insumosConNuevaCantidad[indexInsumoEnVentaSinInsumo].cantidad = 1;
        this.formRef.current.setFieldsValue({
          insumos: insumosConNuevaCantidad,
        });
        this.onChangeInsumoProyecto(null, indexInsumoEnVentaSinInsumo, "insumo", false, insumo);
      } else {
        const nuevosInsumos = [
          ...insumosEnVenta,
          { insumoId: insumo._id?.toString(), cantidad: 1 }
        ];
        this.formRef.current.setFieldsValue({
          insumos: nuevosInsumos,
        });
        this.onChangeInsumoProyecto(null, insumosEnVenta.length, "insumo", false, insumo);
      }
    } else {
      const insumosConNuevaCantidad = [...insumosEnVenta];
      insumosConNuevaCantidad[indexInsumoEnVenta].cantidad =
        insumosConNuevaCantidad[indexInsumoEnVenta].cantidad + 1;
      this.formRef.current.setFieldsValue({
        insumos: insumosConNuevaCantidad,
      });
      this.onChangeInsumoProyecto(null, indexInsumoEnVenta, "insumo", false, insumo);
    }
  }

  printTicket = async (dataTicket, empresa, contadoCredito) => {
    try {

      if (!this.props.impresoraSeleccionada) {
        throw new Error("No hay impresora seleccionada");
      }

      if (!qz.websocket.isActive()) {
        await qz.websocket.connect();
      }

      const config = await qz.configs.create(this.props.impresoraSeleccionada ? this.props.impresoraSeleccionada : "",
        {
          encoding: 'Cp1252',
          scaleContent: false,     // No escalar el contenido del PDF
          rasterize: true,        // Evita convertir a imagen si no quieres que reduzca resolución
          density: 300             // Ajusta según tu impresora (203 o 300 dpi típico)
        }
      );


      // const data = ticketEscPos(dataTicket);
      const pdf2 = ticketPdf(dataTicket);
      const base64_1 = await new Promise((resolve) => {
        pdfMake.createPdf(pdf2).getBase64((base64) => resolve(base64));
      });

      let copias = 1;

      if (!contadoCredito && empresa?.impresionTicketsContado > 1) {
        copias = empresa?.impresionTicketsContado;
      }

      if (contadoCredito && empresa?.impresionTicketsCredito > 1) {
        copias = empresa?.impresionTicketsCredito;
      }

      for (let i = 1; i <= copias; i++) {
        await qz.print(config, [
          {
            type: 'pixel',
            format: 'pdf',
            flavor: 'base64',
            data: base64_1
          },
        ]);
      }


      await qz.websocket.disconnect();
      // await qz.print(config, data);

    } catch (err) {
      console.error('Error imprimiendo ticket:', err);
      const pdf2 = ticketPdf(dataTicket);
      pdfMake.createPdf(pdf2).getBlob((blob) => {
        const pdfURL = URL.createObjectURL(blob);

        const ua = navigator.userAgent || "";
        const isAndroid = /Android/i.test(ua);

        // Chrome en iOS aparece como "CriOS"
        const isChromeiOS = /CriOS/i.test(ua);

        // WebView Android común (opcional pero útil)
        const isWebViewAndroid =
          isAndroid && /wv|Version\/\d+\.\d+.*Chrome\/\d+/i.test(ua);

        // ❌ Navegadores que NO pueden con printJS → visor directo
        if (isAndroid || isWebViewAndroid || isChromeiOS) {
          const win = window.open(pdfURL, "_blank");
          if (!win) window.location.href = pdfURL;
          setTimeout(() => URL.revokeObjectURL(pdfURL), 60000);
          return;
        }

        // ✅ Navegadores que SÍ pueden (o al menos vale la pena intentar)
        // Intentamos printJS y NO hacemos fallback si falla
        try {
          printJS({
            printable: pdfURL,
            type: "pdf",
            showModal: false,
          });
        } catch (e) {
          // Si falla de inmediato, NO hacemos nada más
          message.error("No se pudo imprimir el ticket automáticamente. Cambie de navegador (por ejemplo, Chrome o Firefox).");
          console.warn("printJS falló inmediatamente:", e);
        }

        // No revocar rápido o rompes printJS
        setTimeout(() => URL.revokeObjectURL(pdfURL), 60000);
      });
    }
  }

  atras() {
    this.props.history.goBack();
  }
  async onChangeInsumoProyecto(value, key, tipo, noPonerPrecio, insumoEncontrado) {
    this.setState({ loading: true });
    let arrayValue = await this.formRef.current.getFieldValue("insumos");
    let proyectoId = arrayValue[key].proyectoId;
    const insumoId = arrayValue[key].insumoId;
    let insumo
    if (insumoEncontrado) {
      insumo = insumoEncontrado;
      await this.setState(prev => {
        const indiceExistente = prev.todasInsumos.findIndex(i => i._id === insumo._id);
        if (indiceExistente === -1) {
          return { todasInsumos: [...prev.todasInsumos, insumo] };
        }
        const todasInsumosActualizado = [...prev.todasInsumos];
        todasInsumosActualizado[indiceExistente] = insumo;
        return { todasInsumos: todasInsumosActualizado };
      });
    } else {
      insumo = this.state.todasInsumos.find(
        (valueInsumos) => valueInsumos._id === insumoId
      );
    }
    this.setState({ loading: false });
    let precioId = await this.formRef.current.getFieldValue("precioId");
    let clienteId = await this.formRef.current.getFieldValue("clienteId");
    let tipoDeCambio = await this.formRef.current.getFieldValue("tipoDeCambio");
    const noTax = this.state.quitarImpuestos;
    // if(tipo === 'insumo'){
    //   function getAllIndexes(arr, val) {
    //     var indexes = [], i = -1;
    //     while ((i = arr.indexOf(val, i+1)) != -1){
    //         indexes.push(i);
    //     }
    //     return indexes;
    // }
    // }
    if (!insumo) return;
    if (insumo.inventariable || insumo.insumoCompuesto) {
      await axios
        .post(
          "inventarios/inventarioInsumoProyecto",
          {
            proyectoId: proyectoId,
            insumoId: insumoId,
            noPrincipal: insumo.noPrincipal,
            insumoCompuesto: insumo.insumoCompuesto,
            componentesKit: arrayValue[key].componentesKit,
            empresaId: this.props.empresaId,
            pedidosSeleccionados: this.state.pedidosSeleccionados
          },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          this.setState({ loading: false });
          arrayValue[key].cantidadProyecto = res.data.cantidad;
        });
    } else {
      arrayValue[key].cantidadProyecto = "No inventariable";
    }

    if (tipo === "insumo") {
      // Producto elegido en el select: la descripcion larga vuelve al default de su catalogo.
      // Sin `value` es el lector de codigo de barras sumando al mismo renglon: se respeta.
      if (value) arrayValue[key].imprimirDescripcionLarga = undefined;
      const usarPrecioCliente = this.formRef.current.getFieldValue("usarPrecioCliente") !== false;
      const precio = insumo.precios.find(
        (valuePrecios) => valuePrecios.precioId?.toString() === precioId
      );
      if (!noPonerPrecio) {
        if (precio) {
          arrayValue[key].precioUnitario = precio.precio;
        } else {
          message.info("Este insumo no tiene ese precio");
          arrayValue[key].precioUnitario = 0;
        }
        // Si el cliente tiene un precio unitario personalizado para este insumo, se prellena ese en vez del de la lista de precios
        if (usarPrecioCliente && insumo.precioClienteAlternativo !== undefined && insumo.precioClienteAlternativo !== null) {
          arrayValue[key].precioUnitario = insumo.precioClienteAlternativo;
        }
      }
    }

    // Complemento Escuela: el insumo elegido trae el descuento predeterminado del
    // cliente como base. Sin poner precio (p. ej. XML) se respeta el que traia.
    if (this.props.escuela) {
      if (tipo === "insumo" && !noPonerPrecio) {
        aplicarDescuentoBaseAFila(arrayValue[key], this.descuentoPredeterminadoCliente());
      } else {
        normalizarDescuentoFila(arrayValue[key]);
      }
    }

    // Descuento minimo de la lista, ya acotado por el margen minimo. Va antes de
    // que se lea `descuento` mas abajo para que el subtotal salga bien en esta
    // misma pasada; solo toca renglones que estan en 0.
    this.reglas.aplicarDescuentoMinimoAFila(key, arrayValue[key]);


    const precioUnitario = Number(arrayValue[key].precioUnitario)

    let totalImpuestosPrecioSinImpuestos = 0;
    if (!noTax) {
      insumo.impuestos.map((valueImpuesto) => {
        let totalImpuesto;
        if (valueImpuesto.tasaCuota === 1) {
          totalImpuesto = precioUnitario * (valueImpuesto.monto / 100);
        } else if (valueImpuesto.tasaCuota === 2) {
          totalImpuesto =
            (precioUnitario + totalImpuestosPrecioSinImpuestos) *
            (valueImpuesto.monto / 100);
        } else if (valueImpuesto.tasaCuota === 3) {
          totalImpuesto = (valueImpuesto.monto / tipoDeCambio);
        } else if (valueImpuesto.tasaCuota === 5) {
          totalImpuesto = 0
        }
        totalImpuestosPrecioSinImpuestos += totalImpuesto;
        return null;
      });
    }
    arrayValue[key].precioUnitarioConImpuestos = round2Decimals(
      precioUnitario + totalImpuestosPrecioSinImpuestos
    );

    const cantidad = arrayValue[key].cantidad;
    const descuento = arrayValue[key].descuento || 0;
    const descuentoCantidad = arrayValue[key].descuentoCantidad || 0;

    if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
      //1
      const subtotal = round6Decimals(cantidad * precioUnitario);
      //2
      const totalDescuento = round6Decimals(((subtotal * (descuento / 100)) || 0) + descuentoCantidad);
      //3
      const totalEntrada = round6Decimals(subtotal - totalDescuento);
      arrayValue[key].subtotal = totalEntrada;

      let totalImpuestos = 0;
      let arrayImpuestos = [];
      if (!noTax) {
        arrayImpuestos = insumo.impuestos.map(
        //4
        (valueImpuesto) => {
          let totalImpuesto;
          let baseImpuesto;
          let montoImpuesto;
          if (valueImpuesto.tasaCuota === 1) {
            totalImpuesto = round6Decimals(
              totalEntrada * (valueImpuesto.monto / 100)
            );
            baseImpuesto = totalEntrada
            montoImpuesto = round6Decimals(valueImpuesto.monto / 100)
          } else if (valueImpuesto.tasaCuota === 2) {
            totalImpuesto = round6Decimals(
              (totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100)
            );
            baseImpuesto = (totalEntrada + totalImpuestos)
            montoImpuesto = round6Decimals(valueImpuesto.monto / 100)
          } else if (valueImpuesto.tasaCuota === 3) {
            totalImpuesto = round6Decimals((cantidad * valueImpuesto.monto) / tipoDeCambio);
            baseImpuesto = cantidad
            montoImpuesto = round6Decimals(valueImpuesto.monto / tipoDeCambio)
          } else if (valueImpuesto.tasaCuota === 5) {
            totalImpuesto = 0
            baseImpuesto = totalEntrada
            montoImpuesto = 0
          }
          totalImpuestos += totalImpuesto;
          return {
            tasaCuota: valueImpuesto.tasaCuota,
            impuesto: valueImpuesto.impuesto,
            montoImpuesto: montoImpuesto,
            local: valueImpuesto.local,
            baseImpuesto: baseImpuesto,
            descripcionFactura: valueImpuesto.descripcionFactura,
            totalImpuestos: totalImpuesto,
          };
        }
      );
      }
      arrayValue[key].impuestos = totalImpuestos;
      arrayValue[key].arrayImpuestos = arrayImpuestos;
      //5
      arrayValue[key].total = round2Decimals(
        arrayValue[key].subtotal + totalImpuestos
      );

      if (!noTax && clienteId) {
        //Consultar cliente

        const cliente = this.state.todasClientes.find(
          (valueP) => valueP._id === clienteId
        );
        //6
        let totalRetenciones = 0;
        let arrayRetenciones = []
        cliente.retenciones.map((valueRetencion) => {
          //7
          let totalRetencion;
          let baseRetencion;
          if (valueRetencion.tasaCuota === 1) {
            totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
            baseRetencion = totalEntrada
          } else if (valueRetencion.tasaCuota === 2) {
            totalRetencion =
              round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
            baseRetencion = (totalEntrada + totalImpuestos)
          }
          totalRetenciones += totalRetencion;
          arrayRetenciones.push({
            tasaCuota: valueRetencion.tasaCuota,
            impuesto: valueRetencion.impuesto,
            montoRetencion: valueRetencion.monto,
            local: valueRetencion.local,
            baseRetencion: baseRetencion,
            descripcionFactura: valueRetencion.descripcionFactura,
            totalRetenciones: totalRetencion,
          });
          return null
        })

        insumo.retenciones.map((valueRetencion) => {
          if ((valueRetencion.aplicaVenta === 1 && cliente.persona === false) || (valueRetencion.aplicaVenta === 2 && cliente.persona === true) || valueRetencion.aplicaVenta === 3) {
            //7
            let totalRetencion;
            let baseRetencion;
            if (valueRetencion.tasaCuota === 1) {
              totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
              baseRetencion = totalEntrada
            } else if (valueRetencion.tasaCuota === 2) {
              totalRetencion =
                round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
              baseRetencion = (totalEntrada + totalImpuestos)
            }
            totalRetenciones += totalRetencion;
            arrayRetenciones.push({
              tasaCuota: valueRetencion.tasaCuota,
              impuesto: valueRetencion.impuesto,
              montoRetencion: valueRetencion.monto,
              local: valueRetencion.local,
              baseRetencion: baseRetencion,
              descripcionFactura: valueRetencion.descripcionFactura,
              totalRetenciones: totalRetencion,
            });
          }
          return null
        })
        arrayValue[key].retenciones = totalRetenciones;
        arrayValue[key].arrayRetenciones = arrayRetenciones;
      } else if (noTax) {
        arrayValue[key].retenciones = 0;
        arrayValue[key].arrayRetenciones = [];
      }
    }

    this.formRef.current.setFieldsValue({
      insumos: arrayValue
    });
    this.setState({ flete: (!!insumo.flete || this.state.flete) })
  }
  async onChangePrecioCantidadDescuento(value, key) {
    let arrayValue = await this.formRef.current.getFieldValue("insumos");
    let clienteId = await this.formRef.current.getFieldValue("clienteId");
    let tipoDeCambio = await this.formRef.current.getFieldValue("tipoDeCambio");
    const noTax = this.state.quitarImpuestos;
    const insumo = this.state.todasInsumos.find(
      (valueInsumos) => valueInsumos._id === arrayValue[key].insumoId
    );
    if (!insumo) return;
    const precioUnitario = Number(arrayValue[key].precioUnitario)

    let totalImpuestosPrecioSinImpuestos = 0;
    if (!noTax) {
      insumo.impuestos.map((valueImpuesto) => {
        let totalImpuesto;
        if (valueImpuesto.tasaCuota === 1) {
          totalImpuesto = precioUnitario * (valueImpuesto.monto / 100);
        } else if (valueImpuesto.tasaCuota === 2) {
          totalImpuesto =
            (precioUnitario + totalImpuestosPrecioSinImpuestos) *
            (valueImpuesto.monto / 100);
        } else if (valueImpuesto.tasaCuota === 3) {
          totalImpuesto = (valueImpuesto.monto / tipoDeCambio);
        } else if (valueImpuesto.tasaCuota === 5) {
          totalImpuesto = 0
        }
        totalImpuestosPrecioSinImpuestos += totalImpuesto;
        return null;
      });
    }
    arrayValue[key].precioUnitarioConImpuestos = round2Decimals(
      precioUnitario + totalImpuestosPrecioSinImpuestos
    );
    const cantidad = arrayValue[key].cantidad;
    const descuento = arrayValue[key].descuento || 0;
    const descuentoCantidad = arrayValue[key].descuentoCantidad || 0;

    if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
      //1
      const subtotal = round6Decimals(cantidad * precioUnitario);
      //2
      const totalDescuento = round6Decimals(((subtotal * (descuento / 100)) || 0) + descuentoCantidad);
      //3
      const totalEntrada = round6Decimals(subtotal - totalDescuento);
      arrayValue[key].subtotal = totalEntrada;

      let totalImpuestos = 0;
      let arrayImpuestos = [];
      if (!noTax) {
        arrayImpuestos = insumo.impuestos.map(
          //4
          (valueImpuesto) => {
            let totalImpuesto;
            let baseImpuesto;
            let montoImpuesto;
            if (valueImpuesto.tasaCuota === 1) {
              totalImpuesto = round6Decimals(
                totalEntrada * (valueImpuesto.monto / 100)
              );
              baseImpuesto = totalEntrada
              montoImpuesto = round6Decimals(valueImpuesto.monto / 100)
            } else if (valueImpuesto.tasaCuota === 2) {
              totalImpuesto = round6Decimals(
                (totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100)
              );
              baseImpuesto = (totalEntrada + totalImpuestos)
              montoImpuesto = round6Decimals(valueImpuesto.monto / 100)
            } else if (valueImpuesto.tasaCuota === 3) {
              totalImpuesto = round6Decimals((cantidad * valueImpuesto.monto) / tipoDeCambio);
              baseImpuesto = cantidad
              montoImpuesto = round6Decimals(valueImpuesto.monto / tipoDeCambio)
            } else if (valueImpuesto.tasaCuota === 5) {
              totalImpuesto = 0
              baseImpuesto = totalEntrada
              montoImpuesto = 0
            }
            totalImpuestos += totalImpuesto;
            return {
              tasaCuota: valueImpuesto.tasaCuota,
              impuesto: valueImpuesto.impuesto,
              montoImpuesto: montoImpuesto,
              local: valueImpuesto.local,
              baseImpuesto: baseImpuesto,
              descripcionFactura: valueImpuesto.descripcionFactura,
              totalImpuestos: totalImpuesto,
            };
          }
        );
      }
      arrayValue[key].impuestos = totalImpuestos;
      arrayValue[key].arrayImpuestos = arrayImpuestos;
      //5
      arrayValue[key].total = round2Decimals(
        arrayValue[key].subtotal + totalImpuestos
      );

      if (!noTax && clienteId) {
        //Consultar cliente

        const cliente = this.state.todasClientes.find(
          (valueP) => valueP._id === clienteId
        );
        //6
        let totalRetenciones = 0;
        let arrayRetenciones = []
        cliente.retenciones.map((valueRetencion) => {
          //7
          let totalRetencion;
          let baseRetencion;
          if (valueRetencion.tasaCuota === 1) {
            totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
            baseRetencion = totalEntrada
          } else if (valueRetencion.tasaCuota === 2) {
            totalRetencion =
              round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
            baseRetencion = (totalEntrada + totalImpuestos)
          }
          totalRetenciones += totalRetencion;
          arrayRetenciones.push({
            tasaCuota: valueRetencion.tasaCuota,
            impuesto: valueRetencion.impuesto,
            montoRetencion: valueRetencion.monto,
            local: valueRetencion.local,
            baseRetencion: baseRetencion,
            descripcionFactura: valueRetencion.descripcionFactura,
            totalRetenciones: totalRetencion,
          });
          return null
        })
        insumo.retenciones.map((valueRetencion) => {
          if ((valueRetencion.aplicaVenta === 1 && cliente.persona === false) || (valueRetencion.aplicaVenta === 2 && cliente.persona === true) || valueRetencion.aplicaVenta === 3) {
            //7
            let totalRetencion;
            let baseRetencion;
            if (valueRetencion.tasaCuota === 1) {
              totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
              baseRetencion = totalEntrada
            } else if (valueRetencion.tasaCuota === 2) {
              totalRetencion =
                round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
              baseRetencion = (totalEntrada + totalImpuestos)
            }
            totalRetenciones += totalRetencion;
            arrayRetenciones.push({
              tasaCuota: valueRetencion.tasaCuota,
              impuesto: valueRetencion.impuesto,
              montoRetencion: valueRetencion.monto,
              local: valueRetencion.local,
              baseRetencion: baseRetencion,
              descripcionFactura: valueRetencion.descripcionFactura,
              totalRetenciones: totalRetencion,
            });
          }
          return null
        })
        arrayValue[key].retenciones = totalRetenciones;
        arrayValue[key].arrayRetenciones = arrayRetenciones;
      } else if (noTax) {
        arrayValue[key].retenciones = 0;
        arrayValue[key].arrayRetenciones = [];
      }

    }
    this.formRef.current.setFieldsValue({
      insumos: arrayValue,
    });
    this.reglas.actualizarFila(key);
  }
  async onChangePrecioConImpuestos(value, key) {
    if (value === undefined || value === null || value === "") return;

    let arrayValue = await this.formRef.current.getFieldValue("insumos");
    let tipoDeCambio = await this.formRef.current.getFieldValue("tipoDeCambio");
    let clienteId = await this.formRef.current.getFieldValue("clienteId");
    const noTax = this.state.quitarImpuestos;

    const insumo = this.state.todasInsumos.find(
      (valueInsumos) => valueInsumos._id === arrayValue[key].insumoId
    );
    if (!insumo) return;

    // Inversa correcta del precio con impuestos
    // Con impuestos quitados no hay nada que revertir: el precio neto capturado ES el precio unitario
    let factor = 1;
    let sumaCuotasFijas = 0;

    if (!noTax) {
      insumo.impuestos.forEach((valueImpuesto) => {
        const porcentaje = valueImpuesto.monto / 100;

        if (valueImpuesto.tasaCuota === 1) {
          // porcentaje sobre base
          factor += porcentaje;
        } else if (valueImpuesto.tasaCuota === 2) {
          // porcentaje sobre base + impuestos acumulados
          factor *= (1 + porcentaje);
        } else if (valueImpuesto.tasaCuota === 3) {
          // cuota fija
          sumaCuotasFijas += valueImpuesto.monto / tipoDeCambio;
        }
      });
    }

    const precioUnitario = round6Decimals(
      (Number(value) - sumaCuotasFijas) / factor
    );

    arrayValue[key].precioUnitario = precioUnitario;

    const cantidad = Number(arrayValue[key].cantidad || 0);
    const descuento = Number(arrayValue[key].descuento || 0);
    const descuentoCantidad = Number(arrayValue[key].descuentoCantidad || 0);

    if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
      const subtotal = round6Decimals(cantidad * precioUnitario);
      const totalDescuento = round6Decimals(
        ((subtotal * (descuento / 100)) || 0) + descuentoCantidad
      );
      const totalEntrada = round6Decimals(subtotal - totalDescuento);
      arrayValue[key].subtotal = totalEntrada;

      let totalImpuestos = 0;
      let arrayImpuestos = [];
      if (!noTax) arrayImpuestos = insumo.impuestos.map((valueImpuesto) => {
        let totalImpuesto = 0;
        let baseImpuesto = 0;
        let montoImpuesto = 0;

        if (valueImpuesto.tasaCuota === 1) {
          totalImpuesto = round6Decimals(
            totalEntrada * (valueImpuesto.monto / 100)
          );
          baseImpuesto = totalEntrada;
          montoImpuesto = round6Decimals(valueImpuesto.monto / 100);
        } else if (valueImpuesto.tasaCuota === 2) {
          baseImpuesto = totalEntrada + totalImpuestos;
          totalImpuesto = round6Decimals(
            baseImpuesto * (valueImpuesto.monto / 100)
          );
          montoImpuesto = round6Decimals(valueImpuesto.monto / 100);
        } else if (valueImpuesto.tasaCuota === 3) {
          totalImpuesto = round6Decimals(
            (cantidad * valueImpuesto.monto) / tipoDeCambio
          );
          baseImpuesto = cantidad;
          montoImpuesto = round6Decimals(valueImpuesto.monto / tipoDeCambio);
        } else if (valueImpuesto.tasaCuota === 5) {
          totalImpuesto = 0;
          baseImpuesto = totalEntrada;
          montoImpuesto = 0;
        }

        totalImpuestos += totalImpuesto;

        return {
          tasaCuota: valueImpuesto.tasaCuota,
          impuesto: valueImpuesto.impuesto,
          montoImpuesto,
          local: valueImpuesto.local,
          baseImpuesto,
          descripcionFactura: valueImpuesto.descripcionFactura,
          totalImpuestos: totalImpuesto,
        };
      });

      arrayValue[key].impuestos = totalImpuestos;
      arrayValue[key].arrayImpuestos = arrayImpuestos;
      arrayValue[key].total = round2Decimals(
        arrayValue[key].subtotal + totalImpuestos
      );

      if (!noTax && clienteId) {
        const cliente = this.state.todasClientes.find(
          (valueP) => valueP._id === clienteId
        );

        if (cliente) {
          let totalRetenciones = 0;
          let arrayRetenciones = [];

          cliente.retenciones.forEach((valueRetencion) => {
            let totalRetencion = 0;
            let baseRetencion = 0;

            if (valueRetencion.tasaCuota === 1) {
              totalRetencion = round6Decimals(
                totalEntrada * (valueRetencion.monto / 100)
              );
              baseRetencion = totalEntrada;
            } else if (valueRetencion.tasaCuota === 2) {
              baseRetencion = totalEntrada + totalRetenciones;
              totalRetencion = round6Decimals(
                baseRetencion * (valueRetencion.monto / 100)
              );
            }

            totalRetenciones += totalRetencion;

            arrayRetenciones.push({
              tasaCuota: valueRetencion.tasaCuota,
              impuesto: valueRetencion.impuesto,
              montoRetencion: valueRetencion.monto,
              local: valueRetencion.local,
              baseRetencion,
              descripcionFactura: valueRetencion.descripcionFactura,
              totalRetenciones: totalRetencion,
            });
          });

          insumo.retenciones.forEach((valueRetencion) => {
            if (
              (valueRetencion.aplicaVenta === 1 && cliente.persona === false) ||
              (valueRetencion.aplicaVenta === 2 && cliente.persona === true) ||
              valueRetencion.aplicaVenta === 3
            ) {
              let totalRetencion = 0;
              let baseRetencion = 0;

              if (valueRetencion.tasaCuota === 1) {
                totalRetencion = round6Decimals(
                  totalEntrada * (valueRetencion.monto / 100)
                );
                baseRetencion = totalEntrada;
              } else if (valueRetencion.tasaCuota === 2) {
                baseRetencion = totalEntrada + totalRetenciones;
                totalRetencion = round6Decimals(
                  baseRetencion * (valueRetencion.monto / 100)
                );
              }

              totalRetenciones += totalRetencion;

              arrayRetenciones.push({
                tasaCuota: valueRetencion.tasaCuota,
                impuesto: valueRetencion.impuesto,
                montoRetencion: valueRetencion.monto,
                local: valueRetencion.local,
                baseRetencion,
                descripcionFactura: valueRetencion.descripcionFactura,
                totalRetenciones: totalRetencion,
              });
            }
          });

          arrayValue[key].retenciones = totalRetenciones;
          arrayValue[key].arrayRetenciones = arrayRetenciones;
        }
      } else if (noTax) {
        arrayValue[key].retenciones = 0;
        arrayValue[key].arrayRetenciones = [];
      }
    }

    // conservar lo capturado por el usuario
    arrayValue[key].precioUnitarioConImpuestos = round2Decimals(Number(value));

    this.formRef.current.setFieldsValue({
      insumos: arrayValue,
    });
    this.reglas.actualizarFila(key);
  }

  // Réplica pura (sin tocar el form) del bloque de impuestos/retenciones de onChangeInsumoProyecto.
  // Se usa en la carga masiva por Excel para no disparar un re-render del formulario por cada fila.
  cargarInsumosDesdeExcel = async (filasValidas, modo) => {
    const proyectoId = this.formRef.current.getFieldValue("proyectoId");
    const precioId = this.formRef.current.getFieldValue("precioId");
    const usarPrecioCliente = this.formRef.current.getFieldValue("usarPrecioCliente") !== false;

    // Registrar en el catálogo local, de una sola vez, los insumos que aún no estuvieran cacheados
    const insumosNuevos = insumosNuevosParaCatalogo(filasValidas, this.state.todasInsumos);
    if (insumosNuevos.length > 0) {
      await new Promise((resolve) =>
        this.setState((prev) => ({ todasInsumos: [...prev.todasInsumos, ...insumosNuevos] }), resolve)
      );
    }

    const filasNuevas = construirFilasInsumosDesdeExcel({
      filas: filasValidas,
      proyectoId,
      precioId,
      usarPrecioCliente,
    });

    // Inventario en bulk para todas las filas de una sola vez (igual que cargarDatosDeListaEscolar)
    try {
      const resInventarios = await axios.post(
        "inventarios/inventarioInsumoProyectoBulk",
        {
          empresaId: this.props.empresaId,
          proyectoId,
          pedidosSeleccionados: this.state.pedidosSeleccionados,
          insumos: payloadInventarioBulk(filasValidas, proyectoId),
        },
        { headers: this.props.headersToken }
      );
      aplicarInventarioBulk(filasNuevas, resInventarios.data?.results);
    } catch (error) {
      console.error("Error al consultar inventario en batch:", error);
    }

    const insumosActuales = this.formRef.current.getFieldValue("insumos") || [];
    const filasFinales = combinarFilasInsumos(insumosActuales, filasNuevas, modo);

    const hayFlete = filasValidas.some((f) => f.insumo.flete);
    this.recalcularInsumosEnBatch(filasFinales);
    this.setState({ modalCargarExcelVisible: false, flete: hayFlete || this.state.flete });
    message.success(`${filasNuevas.length} línea(s) cargada(s) desde Excel.`);
  };

  // Quita el nombre alterno cacheado de un cliente anterior para que no se le quede pegado a otro cliente
  limpiarAliasClienteInsumos() {
    this.setState((prev) => ({
      todasInsumos: prev.todasInsumos.map((insumo) => {
        if (!insumo.nombreClienteAlternativo) return insumo;
        const { nombreClienteAlternativo, ...resto } = insumo;
        return {
          ...resto,
          stringBuscar: `${insumo.clave || ''} - ${insumo.descripcion} - ${insumo.unidad || ''}`,
        };
      }),
    }));
  }

  async onChangeCliente(valueId, clienteEncontrado, inicial) {
    this.limpiarAliasClienteInsumos();
    let contado = this.formRef.current.getFieldValue("contado");
    this.setState({ loading: true });
    let cliente
    if (clienteEncontrado) {
      cliente = clienteEncontrado;
      const yaExiste = this.state.todasClientes.find(i => i._id === cliente._id);
      if (!yaExiste) {
        await this.setState(prev => ({
          todasClientes: [...prev.todasClientes, cliente]
        }));
      }
    } else {
      cliente = this.state.todasClientes.find(
        (valueClientes) => valueClientes._id === valueId
     );
    }
    this.setState({ loading: false });

    const escuelaIdCliente = cliente.datosAlumno?.escuelaId || null;
    this.setState({ clienteEscuelaId: escuelaIdCliente }, () => {
      if (this.state.todasSucursalesGrupadas.length > 0) {
        this.actualizarOpcionesSucursales(escuelaIdCliente, this.state.todasSucursalesGrupadas);
      }
    });

    if (!cliente.regimenFiscalId || !cliente.direcciones[0]?.coloniaId) {
      message.info('No se podra facturar a este cliente. Faltan datos')
    }
    if (!cliente.tipoClienteId) {
      const nombre = cliente.persona
        ? cliente.razonSocial
        : `${cliente.nombre} ${cliente.apellidoPaterno} ${cliente.apellidoMaterno}`;
      this.abrirElegirTipoDeCliente(cliente._id, nombre);
    }
    let objetoCambiar = {}
    if (cliente.usoDeCFDIID) {
      objetoCambiar.usoDeCfdiId = cliente.usoDeCFDIID
    }
    if (cliente.contado && this.state.ponerMetodoDePago) {
      objetoCambiar.contado = cliente.contado
      contado = cliente.contado
      this.onChangeContado(cliente.contado, true, cliente.formaDePagoId)
      message.info('Se actualizo el metodo de pago')
    }
    if ((cliente.precioContadoId || cliente.precioCreditoId) && !inicial) {
      objetoCambiar.precioId = contado === 1 ? cliente.precioContadoId : cliente.precioCreditoId
    }
    if (cliente.proyectoId) {
      objetoCambiar.proyectoId = cliente.proyectoId
    }
    if (cliente.vendedorId && this.state.ponerVendedor && this.state.todasUsuarios?.find(u => u._id?.toString() === cliente.vendedorId?.toString())) {
      objetoCambiar.vendedorId = cliente.vendedorId
    }
    if (cliente.canalDeVentaId && this.state.ponerCanal && this.state.todasCanalesVenta?.find(c => c._id?.toString() === cliente.canalDeVentaId?.toString())) {
      objetoCambiar.canalDeVentaId = cliente.canalDeVentaId
    }
    if (cliente.monedaId){
      objetoCambiar.monedaId = cliente.monedaId
      this.onChangeMoneda(cliente.monedaId)
    }
    this.setState({
      complementoDetallista: cliente.complementoDetallista,
      complementoComercioExterior: cliente.complementoComercioExterior,
      detallista: {
        orderIdentification: cliente.orderIdentification,
        referenceDateOrderIdentification: cliente.referenceDateOrderIdentification,
        additionalInformation: cliente.additionalInformation,
        deliveryNote: cliente.deliveryNote,
        referenceDateDeliveryNote: cliente.referenceDateDeliveryNote,
      },
      direccionesCliente: cliente.direcciones,
      objetoDireccionesCliente: cliente.direcciones.map((value) => {
        return (
          <Option value={value._id} key={value._id}>
            {(value.calle || "Sin calle") + ' ' + (value.numeroCalle || "Sin número") + (value.numeroInterior ? ' Int. ' + value.numeroInterior : '') + ', ' + (value.colonia || "Sin colonia")}
          </Option>
        )
      }), 
    })
    this.formRef.current.setFieldsValue({
      diasCredito: cliente.diasCredito || 0,
      direccionEntrega: null, // Reset dirección de entrega al cambiar cliente
      ...objetoCambiar
    });
    this.contadoAnterior = this.formRef.current.getFieldValue("contado");
    this.precioIdAnterior = this.formRef.current.getFieldValue("precioId");
    const insumos = this.formRef.current.getFieldValue("insumos");
    if (insumos?.length > 0) {
      // Complemento Escuela: el Desc. Cliente pasa a ser el del cliente nuevo y el
      // adicional se queda. En la carga inicial los renglones ya traen el suyo.
      if (this.props.escuela && !inicial) {
        insumos.forEach((fila) => {
          if (fila?.insumoId) aplicarDescuentoBaseAFila(fila, cliente.descuentoPredeterminado);
        });
      }
      this.recalcularInsumosEnBatch(insumos);
    }
    if(cliente?.usarAdenda && cliente?.adendaActiva === "Mabe"){
      this.setState({ addendaMabe: true });
    }
    if(cliente?.usarAdenda && cliente?.adendaActiva === "Viscofan"){
      this.setState({ addendaViscofan: true });
    } else {
      this.setState({ addendaViscofan: false });
    }
    this.setState({ usarLeyendasFiscales: !!cliente?.usarLeyendasFiscales });
    this.formRef.current.setFieldsValue({
      leyendasFiscales: cliente?.usarLeyendasFiscales ? (cliente?.leyendasFiscales || []) : [],
    });
    // Las reglas dependen del cliente y de su tipo de cliente.
    this.reglas.consultarContexto(valueId, this.formRef.current.getFieldValue("precioId"));
  }
  onChangePrecioId = (value) => {
    const insumos = this.formRef.current.getFieldValue("insumos");
    if (!insumos || insumos.length === 0) {
      this.precioIdAnterior = value;
      this.reglas.consultarContexto(undefined, value);
      return;
    }
    const anterior = this.precioIdAnterior;
    Modal.confirm({
      title: "Cambiar lista de precios",
      content: "Esta venta ya tiene insumos agregados. Cambiar la lista de precios actualizará los precios e importes de todos los insumos ya agregados. ¿Deseas continuar?",
      okText: "Sí, actualizar precios",
      cancelText: "Cancelar",
      onOk: () => {
        this.precioIdAnterior = value;
        this.recalcularPreciosTodosLosInsumos(value);
        // Cada lista trae sus propias reglas y rangos.
        this.reglas.consultarContexto(undefined, value);
      },
      onCancel: () => {
        this.formRef.current.setFieldsValue({ precioId: anterior });
      },
    });
  };

  // Aplica la nueva lista de precios a todas las filas y delega el recálculo de
  // impuestos/retenciones/total en recalcularInsumosEnBatch (un solo setFieldsValue).
  recalcularPreciosTodosLosInsumos = (precioId) => {
    const insumos = this.formRef.current.getFieldValue("insumos");
    if (!insumos || insumos.length === 0) return;
    const usarPrecioCliente = this.formRef.current.getFieldValue("usarPrecioCliente") !== false;

    let sinPrecio = 0;
    const nuevosInsumos = insumos.map((fila) => {
      const insumoId = fila.insumoId?._id || fila.insumoId;
      const insumo = this.state.todasInsumos.find((i) => i._id.toString() === insumoId?.toString());
      if (!insumo) return fila;

      const precio = insumo.precios.find((p) => p.precioId?.toString() === precioId);
      if (!precio) sinPrecio++;
      let precioUnitario = precio ? precio.precio : 0;
      if (usarPrecioCliente && insumo.precioClienteAlternativo !== undefined && insumo.precioClienteAlternativo !== null) {
        precioUnitario = insumo.precioClienteAlternativo;
      }
      return { ...fila, precioUnitario };
    });

    this.recalcularInsumosEnBatch(nuevosInsumos);
    if (sinPrecio > 0) {
      message.info(`${sinPrecio} insumo(s) no tienen precio en esta lista y se dejaron en $0.`);
    }
  };
  refrescarInsumosCliente = async (usarPrecioCliente) => {
    try {
      const todasInsumos = await refrescarCatalogoInsumosCliente({
        empresaId: this.props.empresaId,
        clienteId: this.formRef.current.getFieldValue("clienteId"),
        usarPrecioCliente,
        insumos: this.formRef.current.getFieldValue("insumos"),
        todasInsumos: this.state.todasInsumos,
        headersToken: this.props.headersToken,
      });
      await new Promise((resolve) => this.setState({ todasInsumos }, resolve));
    } catch (error) {
      console.error("Error al refrescar los insumos del cliente:", error);
    }
  };
  onChangeUsarPrecioCliente = (checked) => {
    const insumos = this.formRef.current.getFieldValue("insumos");
    if (!insumos || insumos.length === 0) {
      this.usarPrecioClienteAnterior = checked;
      return;
    }
    const precioId = this.formRef.current.getFieldValue("precioId");
    const anterior = this.usarPrecioClienteAnterior;
    Modal.confirm({
      title: "Cambiar Usar Precio de Cliente",
      content: "Esta venta ya tiene insumos agregados. Cambiar esta opción actualizará los precios e importes de todos los insumos ya agregados. ¿Deseas continuar?",
      okText: "Sí, actualizar precios",
      cancelText: "Cancelar",
      onOk: async () => {
        this.usarPrecioClienteAnterior = checked;
        await this.refrescarInsumosCliente(checked);
        this.recalcularPreciosTodosLosInsumos(precioId);
      },
      onCancel: () => {
        this.formRef.current.setFieldsValue({ usarPrecioCliente: anterior });
      },
    });
  };

  onChangeContado(value, inicial, metodoClienteId = null) {
    if (value !== 1) {
      this.formRef.current.setFieldsValue({
        formaDePagoId: '6125149afe07662acc100d6d'
      })
    } else {
      this.formRef.current.setFieldsValue({
        formaDePagoId: metodoClienteId ? metodoClienteId : '6125149afe07662acc100d58'
      })
    }

    if (value === 2) {
      const clienteId = this.formRef?.current.getFieldValue("clienteId");
      if (clienteId) {
        const cliente = this.state.todasClientes.find(c => c._id === clienteId);
        if (cliente) {
          this.formRef.current.setFieldsValue({
            diasCredito: cliente.diasCredito || 0
          });
        }
      }
    }

    const insumos = this.formRef.current.getFieldValue("insumos");
    const clienteId = this.formRef.current.getFieldValue("clienteId");
    const cliente = clienteId && this.state.todasClientes.find(
      (valueProv) => valueProv._id === clienteId
    );
    const nuevoPrecioId = cliente ? (value === 1 ? cliente.precioContadoId : cliente.precioCreditoId) : null;
    const precioIdActual = this.formRef.current.getFieldValue("precioId");
    const esCambioReal = !inicial || !!inicial?.children;

    if (esCambioReal && insumos?.length > 0
        && !(this.state.cotizacionesSeleccionadas?.length > 0 || this.state.pedidosSeleccionados?.length > 0)
        && clienteId && nuevoPrecioId && nuevoPrecioId !== precioIdActual) {
      const anterior = this.contadoAnterior;
      Modal.confirm({
        title: value === 1 ? "Cambiar a Contado" : "Cambiar a Crédito",
        content: "Esta venta ya tiene insumos agregados. Cambiar el método actualizará la lista de precios y, con ella, los precios e importes de los insumos ya agregados. ¿Deseas continuar?",
        okText: "Sí, actualizar precios",
        cancelText: "Cancelar",
        onOk: () => {
          this.contadoAnterior = value;
          this.precioIdAnterior = nuevoPrecioId;
          this.formRef.current.setFieldsValue({ precioId: nuevoPrecioId });
          this.recalcularPreciosTodosLosInsumos(nuevoPrecioId);
          // Cambió la lista, así que cambian las reglas y los rangos.
          this.reglas.consultarContexto(clienteId, nuevoPrecioId);
        },
        onCancel: () => {
          this.formRef.current.setFieldsValue({ contado: anterior });
        },
      });
      return;
    }

    if (insumos?.length > 0) { this.contadoAnterior = value; return; }
    if (this.state.cotizacionesSeleccionadas?.length > 0 || this.state.pedidosSeleccionados?.length > 0) { this.contadoAnterior = value; return; }
    if (!clienteId) { this.contadoAnterior = value; return; }
    if (esCambioReal) {
      this.formRef.current.setFieldsValue({
        precioId: nuevoPrecioId,
      });
      this.precioIdAnterior = nuevoPrecioId;
    }
    this.contadoAnterior = value;
  }
  abrirElegirTipoDeCliente(id, nombre) {
    this.setState({
      modalElegirTipoDeCliente: true,
      modalElegirTipoDeClienteId: id,
      modalElegirTipoDeClienteNombre: nombre,
    });
  }
  cerrarElegirTipoDeCliente(elegido) {
    if (!elegido) {
      this.formRef.current.setFieldsValue({ clienteId: undefined });
    }
    this.consultarTodo();
    this.setState({
      modalElegirTipoDeCliente: false,
      modalElegirTipoDeClienteId: null,
      modalElegirTipoDeClienteNombre: null,
    });
  }
  // La Vista previa (MandarCorreo) carga el PDF en un iframe con pdf.open(), y eso agrega
  // una entrada al historial con esta misma URL: un goBack() sólo regresaba el iframe y el
  // usuario se quedaba en Agregar Venta. Por eso al guardar se navega a la lista de donde
  // se abrió la venta. Se lee location.state (el origen), no this.state, que puede cambiar.
  rutaDeOrigen() {
    const estado = this.props.location?.state || {};
    if (estado.cotizacionesSeleccionadas?.length > 0 || estado.cotizacionId) return "/panel/cotizaciones";
    if (estado.pedidosSeleccionados?.length > 0 || estado.pedidoId) return "/panel/pedidos";
    if (estado.embarquesSeleccionados?.length > 0 || estado.embarqueId) return "/panel/embarques";
    return "/panel/ventas";
  }
  cerrarMandarCorreo() {
    this.setState({
      modalCorreo: false,
      modalCorreoId: null,
    });
    this.formRef.current.resetFields();
    this.props.history.push(this.rutaDeOrigen());
  }
  abrirElegirMarbetes(value, marbetes, insumoId, proyectoId) {
    if (proyectoId) {
      this.setState({
        modalElegirMarbetes: true,
        modalElegirMarbetesIndex: value,
        modalElegirMarbetesMarbetes: marbetes || [],
        modalElegirMarbetesInsumoId: insumoId,
        modalElegirMarbetesProyectoId: proyectoId
      })
    } else {
      message.warning('Elegir un proyecto para elegir marbetes')
    }
  }
  cerrarElegirMarbetes(value) {
    const insumos = this.formRef.current.getFieldValue('insumos')
    insumos[this.state.modalElegirMarbetesIndex].marbetes = value
    this.formRef.current.setFieldsValue({
      insumos: insumos
    })
    this.setState({
      modalElegirMarbetes: false,
      modalElegirMarbetesIndex: null,
      modalElegirMarbetesMarbetes: null,
      modalElegirMarbetesInsumoId: null,
      modalElegirMarbetesProyectoId: null
    })
  }

  abrirElegirLotes(value, lotes, insumoId, proyectoId, cantidad) {
    const clienteId = this.formRef.current.getFieldValue('clienteId')
    if (proyectoId) {
      this.setState({
        modalElegirLotes: true,
        modalElegirLotesIndex: value,
        modalElegirLotesLotes: lotes || [],
        modalElegirLotesInsumoId: insumoId,
        modalElegirLotesProyectoId: proyectoId,
        modalElegirLotesClienteId: clienteId,
        modalElegirLotesCantidad: cantidad
      })
    } else {
      message.warning('Elegir un proyecto para elegir lotes')
    }
  }
  cerrarElegirLotes(value) {
    const insumos = this.formRef.current.getFieldValue('insumos')
    insumos[this.state.modalElegirLotesIndex].lotes = value
    this.formRef.current.setFieldsValue({
      insumos: insumos
    })
    this.setState({
      modalElegirLotes: false,
      modalElegirLotesIndex: null,
      modalElegirLotesLotes: null,
      modalElegirLotesInsumoId: null,
      modalElegirLotesProyectoId: null,
      modalElegirLotesClienteId: null,
      modalElegirLotesCantidad: null
    })
  }

  abrirElegirAgrupaciones(value, agrupaciones, insumoId, proyectoId) {
    const clienteId = this.formRef.current.getFieldValue('clienteId')
    if (proyectoId) {
      this.setState({
        modalElegirAgrupaciones: true,
        modalElegirAgrupacionesIndex: value,
        modalElegirAgrupacionesAgrupaciones: agrupaciones || [],
        modalElegirAgrupacionesInsumoId: insumoId,
        modalElegirAgrupacionesProyectoId: proyectoId,
        modalElegirAgrupacionesClienteId: clienteId
      })
    } else {
      message.warning('Elegir un proyecto para elegir agrupaciones')
    }
  }
  cerrarElegirAgrupaciones(value) {
    const insumos = this.formRef.current.getFieldValue('insumos')
    insumos[this.state.modalElegirAgrupacionesIndex].agrupaciones = value
    this.formRef.current.setFieldsValue({
      insumos: insumos
    })
    this.setState({
      modalElegirAgrupaciones: false,
      modalElegirAgrupacionesIndex: null,
      modalElegirAgrupacionesAgrupaciones: null,
      modalElegirAgrupacionesInsumoId: null,
      modalElegirAgrupacionesProyectoId: null,
      modalElegirAgrupacionesClienteId: null
    })
  }

  abrirElegirComponentesKit(arrayKey, componentesKit, insumoId) {
    const insumo = this.state.todasInsumos?.find(i => i._id.toString() === insumoId?.toString());
    // La descripción de cada componente la resuelve el propio modal (vía
    // insumos/selectInsumosPorIds), ya que estos insumos de la receta no
    // necesariamente están en el catálogo ya cargado en esta pantalla.
    const componentesIniciales = (componentesKit && componentesKit.length > 0)
      ? componentesKit
      : (insumo?.insumosUtilizar || []).map(valueUtilizar => ({
          insumoId: valueUtilizar.insumoId,
          cantidad: valueUtilizar.cantidad,
        }));
    this.setState({
      modalElegirComponentesKit: true,
      modalElegirComponentesKitIndex: arrayKey,
      modalElegirComponentesKitComponentes: componentesIniciales,
    });
  }
  cerrarElegirComponentesKit(componentes) {
    const index = this.state.modalElegirComponentesKitIndex;
    const insumos = this.formRef.current.getFieldValue('insumos');
    insumos[index].componentesKit = componentes;
    this.formRef.current.setFieldsValue({
      insumos: insumos
    });
    this.setState({
      modalElegirComponentesKit: false,
      modalElegirComponentesKitIndex: null,
      modalElegirComponentesKitComponentes: null,
    });
    // Recalcular el inventario disponible: cambiar los componentes del kit
    // cambia contra qué insumos se checa disponibilidad.
    this.onChangeInsumoProyecto(null, index, 'proyecto', true);
  }

  abrirLeyenda = (value, leyenda, insumoId) => {
    const insumo = this.state.todasInsumos.find(valueTI => valueTI._id.toString() === insumoId.toString())

    const clienteIdActual = this.formRef.current.getFieldValue('clienteId');
    const clienteActual = this.state.todasClientes.find(c => c._id === clienteIdActual);
    const nombreClienteActual = clienteActual ? (clienteActual.persona ? clienteActual.razonSocial : `${clienteActual.nombre} ${clienteActual.apellidoPaterno} ${clienteActual.apellidoMaterno}`) : 'Cliente Desconocido';

    this.setState({
        modalLeyenda: true,
        modalLeyendaIndex: value,
        modalLeyendaLeyenda: leyenda,
        modalLeyendaLeyendasPasadas: insumo?.leyendasPasadas,
        clienteIdActual: clienteIdActual, 
        nombreClienteActual: nombreClienteActual
    })
  }
  cerrarLeyenda = (value) =>{
      const insumos = this.formRef.current.getFieldValue('insumos')
      insumos[this.state.modalLeyendaIndex].leyenda = value
      this.formRef.current.setFieldsValue({
          insumos: insumos
      })
      this.setState({
          modalLeyenda: false,
          modalLeyendaIndex: null,
          modalLeyendaLeyenda: null,
          modalLeyendaLeyendasPasadas: null,
          clienteIdActual: null,
          nombreClienteActual: null
      })
  }

  abrirObservaciones = (value, observaciones, insumoId, observacionesXml) =>{
    const insumo = this.state.todasInsumos.find(valueTI => valueTI._id.toString() === insumoId.toString())
    const clienteIdActual = this.formRef.current.getFieldValue('clienteId');
    const clienteActual = this.state.todasClientes.find(c => c._id === clienteIdActual);
    const nombreClienteActual = clienteActual ? (clienteActual.persona ? clienteActual.razonSocial : `${clienteActual.nombre} ${clienteActual.apellidoPaterno}`) : 'Cliente Desconocido';
    this.setState({
        modalObservaciones: true,
        modalObservacionesIndex: value,
        modalObservacionesObservaciones: observaciones,
        modalObservacionesObservacionesXml: observacionesXml,
        modalObservacionesObservacionesPasadas: insumo?.observacionesPasadas, 
        clienteIdActual: clienteIdActual, 
        nombreClienteActual: nombreClienteActual
    })
  }
  cerrarObservaciones(value, observacionesXml) {
    const insumos = this.formRef.current.getFieldValue('insumos')
    insumos[this.state.modalObservacionesIndex].observaciones = value
    insumos[this.state.modalObservacionesIndex].observacionesXml = observacionesXml
    this.formRef.current.setFieldsValue({
        insumos: insumos
    })
    this.setState({
        modalObservaciones: false,
        modalObservacionesIndex: null,
        modalObservacionesObservaciones: null,
        modalObservacionesObservacionesXml: null,
        modalObservacionesObservacionesPasadas: null,
        clienteIdActual: null,
        nombreClienteActual: null
    })
  }


  editarUbicacionesEnvio(value) {
    this.setState({ ubicacionesEnvio: value })
  }

  editarMercanciasEnvio(value) {
    this.setState({ mercanciasEnvio: value })
  }

  abrirComercioExteriorInsumo(value, comercioExteriorInsumoValues, insumoId) {
    this.setState({
      modalComercioExteriorInsumo: true,
      modalComercioExteriorInsumoIndex: value,
      modalComercioExteriorInsumoValues: comercioExteriorInsumoValues,
    })
  }
  cerrarComercioExteriorInsumo(value) {
    const insumos = this.formRef.current.getFieldValue('insumos')
    insumos[this.state.modalComercioExteriorInsumoIndex].comercioExteriorInsumo = value
    this.formRef.current.setFieldsValue({
      insumos: insumos
    })
    this.setState({
      modalComercioExteriorInsumo: false,
      modalComercioExteriorInsumoIndex: null,
      modalComercioExteriorInsumoValues: null,
    })
  }

  onChangeMoneda(value) {
    if (value && value !== '60c7e4396465ad440c41c15a') {
      axios
        .post(
          "tipoDeCambio/obtenerTipoDeCambio",
          {
            monedaId: value,
            empresaId: this.props.empresaId,
          },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.success === 2) {
            if (res.data.monedaString && res.data.dia) {
              message.success("Se ha obtenido el tipo de cambio" + (res.data.monedaString ? (" " + res.data.monedaString) : '') + (res.data.dia ? (' del día ' + res.data.dia) : ''));
            }
            this.formRef.current.setFieldsValue({
              tipoDeCambio: res.data.tipoDeCambio,
            });
          }
        });
    }
  }

  async obtenerTipoCambioUSDCO() {
    await axios
      .post(
        "tipoDeCambio/obtenerTipoDeCambio",
        {
          monedaId: "60c7e4396465ad440c41c15b",
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          if (res.data.monedaString && res.data.dia) {
            message.success("Se ha obtenido el tipo de cambio" + (res.data.monedaString ? (" " + res.data.monedaString) : '') + (res.data.dia ? (' del día ' + res.data.dia) : ''));
          }
          this.formRef.current.setFieldsValue({
            comercioExterior: {
              ...this.formRef.current.getFieldValue('comercioExterior'),
              tipoDeCambioUSD: res.data.tipoDeCambio,
            },
          });
        }
      });
  }

  cargarXmlPrevio(e) {

    const precioId = this.formRef.current.getFieldValue("precioId");
    const proyectoId = this.formRef.current.getFieldValue("proyectoId");

    this.setState({ loading: true });
    if (e.file.type === "text/xml") {
      var reader = new FileReader();
      reader.onload = async (event) => {
        let insumosSinRegistrar = 0
        let insumos = []
        let clienteId
        let fechaTimbrado
        let uuid
        let serieFIngresada
        let folioFIngresada
        let tipoDeCambio
        let monedaId
        let metodoDePago
        let noCertificadoSAT
        let noCertificadoCFDI
        let selloSAT
        let selloCFDI
        let totalFIngresada
        let subtotalFIngresada
        let cfdi = event.target.result
        let formaDePagoId
        let usoDeCfdiId
        const hola = new xmlToJson().parseFromString(event.target.result);
        const comprobante = hola?.attributes;
        const emisor = hola.children.find(
          (valueXml) => valueXml.name === "cfdi:Emisor"
        )?.attributes;
        const complemento = hola.children.find(
          (valueXml) => valueXml.name === "cfdi:Complemento"
        );
        const timbre = complemento.children.find(
          (valueXml) => valueXml.name === "tfd:TimbreFiscalDigital"
        )?.attributes;
        const receptor = hola.children.find(
          (valueXml) => valueXml.name === "cfdi:Receptor"
        )?.attributes;
        const conceptos = hola.children.find(
          (valueXml) => valueXml.name === "cfdi:Conceptos"
        )?.children;

        if (
          decodeHTMLEntities(emisor.Rfc ? emisor.Rfc : '').toLowerCase() === this.state.empresaRfc?.toLowerCase()
        ) {

          const responseCliente = await axios.post("clientes/buscarCliente", {
            rfc: decodeHTMLEntities(receptor.Rfc ? receptor.Rfc : ''),
            empresaId: this.props.empresaId
          }, { headers: this.props.headersToken })

          let clienteBuscar

          if (responseCliente.data.success === 2) {
            clienteBuscar = responseCliente.data.cliente;
            await this.setState({
              todasClientes: [responseCliente.data.cliente],
              direccionesCliente: responseCliente.data.cliente.direcciones,
              objetoDireccionesCliente: responseCliente.data.cliente.direcciones.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {(value.calle || "Sin calle") + ' ' + (value.numeroCalle || "Sin número") + (value.numeroInterior ? ' Int. ' + value.numeroInterior : '') + ', ' + (value.colonia || "Sin colonia")}
                  </Option>
                )
              }),
            })
          }

          if (
            !clienteBuscar
          ) {
            this.setState({
              loading: false
            })
            notification.warning({
              message: 'El cliente no esta registrado',
            })
            return message.warning('El cliente no esta registrado')
          } else {
            clienteId = clienteBuscar._id
          }
        } else {
          this.setState({
            archivosXml: [],
            archivo: e.file,
            loading: false
          });
          return message.error(
            "El rfc del emisor no es igual al de la empresa"
          );
        }


        let insumosAgregarTodos = []

        await Promise.all(conceptos.map(async (valueConcepto) => {
          const attr = valueConcepto.attributes;
          valueConcepto.children
            .find((valueTodos) => valueTodos.name === "cfdi:Impuestos")
            ?.children.find(
              (valueTodos) => valueTodos.name === "cfdi:Traslados"
            )
            ?.children.map((valueImpuesto) => {
              return null
            });


          const responseInsumo = await axios.post("insumos/buscarInsumoVenta", {
            clave: decodeHTMLEntities(attr.NoIdentificacion),
            descripcion: decodeHTMLEntities(attr.Descripcion),
            empresaId: this.props.empresaId
          }, { headers: this.props.headersToken })

          let insumoBuscar

          if (responseInsumo.data.success === 2) {
            insumoBuscar = responseInsumo.data.insumo;
            insumosAgregarTodos.push(responseInsumo.data.insumo)
          }


          if (insumoBuscar) {
            insumos.push({
              insumoId: insumoBuscar._id,
              precioUnitario: Number(attr.ValorUnitario),
              cantidad: attr.Cantidad,
              codigo: decodeHTMLEntities(attr.NoIdentificacion),
              descuento: attr.Descuento ? (Math.round(attr.Descuento / attr.Importe * 1000000) / 10000) : 0,
            })

          } else {
            insumosSinRegistrar += 1
            message.warning('No se encontro el insumo ' + decodeHTMLEntities(attr.Descripcion))
          }
          return null
        }));

        await this.setState({
          todasInsumos: insumosAgregarTodos
        })

        fechaTimbrado = moment(comprobante.Fecha)
        if (!comprobante.MetodoPago || (comprobante.MetodoPago === 'PUE' && comprobante.MetodoPago === 'PPD')) return message.warning('No se encontro el metodo de pago')
        metodoDePago = comprobante.MetodoPago === 'PUE' ? 1 : 2
        serieFIngresada = comprobante.Serie
        folioFIngresada = comprobante.Folio
        uuid = timbre.UUID
        tipoDeCambio = comprobante.TipoCambio || 1
        noCertificadoSAT = timbre.NoCertificadoSAT
        noCertificadoCFDI = comprobante.NoCertificado
        selloSAT = timbre.SelloSAT
        selloCFDI = comprobante.Sello
        totalFIngresada = round2Decimals(comprobante.Total)
        subtotalFIngresada = round2Decimals(comprobante.SubTotal - (comprobante.Descuento || 0))

        if (insumosSinRegistrar > 0) {
          this.setState({
            archivosXml: [],
            archivo: e.file,
            loading: false
          });
          return notification.warning({
            message: insumosSinRegistrar + ' insumos no se encontraron',
          })
        }
        if (clienteId) {
          this.onChangeCliente(clienteId, undefined, true)
        }

        const checarUUID = await axios.post('ventas/checarUUID', { uuid, empresaId: this.props.empresaId }, { headers: this.props.headersToken })

        if (checarUUID.data.success === 2) {
          if (checarUUID.data.buscarVenta) {
            this.setState({
              archivosXml: [],
              archivo: e.file,
              loading: false
            });
            return message.warning('El uuid ya esta ligado a otra venta')
          }
        } else {
          return message.warning('No se pudo checar el UUID')
        }


        const moneda = this.state.todasMonedas?.find(
          (valueTodos) =>
            valueTodos.abreviacion?.toLowerCase() === comprobante.Moneda?.toLowerCase()
        );

        if (moneda) {
          monedaId = moneda._id
        } else {
          this.setState({
            archivosXml: [],
            archivo: e.file,
            loading: false
          });
          return message.info('No encontramos la moneda del comprobante')
        }

        const formaDePago = this.state.todasFormasDePago?.find(
          (valueTodos) => Number(valueTodos.c_FormaPago).toString().padStart(2, '0') === comprobante.FormaPago
        );

        if (formaDePago) {
          formaDePagoId = formaDePago._id
        } else {
          this.setState({
            archivosXml: [],
            archivo: e.file,
            loading: false
          });
          return message.info('No encontramos la forma de pago del comprobante')
        }

        const usoDeCfdi = this.state.todasUsosDeCFDI?.find(
          (valueTodos) => {
            return valueTodos.c_UsoCFDI === receptor.UsoCFDI
          }
        );

        if (usoDeCfdi) {
          usoDeCfdiId = usoDeCfdi._id
        } else {
          this.setState({
            archivosXml: [],
            archivo: e.file,
            loading: false
          });
          return message.info('No encontramos el uso de cfdi del comprobante')
        }

        let mostrarMensaje = false

        if (!precioId) {
          if (this.state.todasPrecios[0]) {
            this.formRef.current.setFieldsValue({
              precioId: this.state.todasPrecios[0]._id
            })
            mostrarMensaje = true
          }
        }

        if (!proyectoId) {
          if (this.state.todasProyectos[0]) {
            this.formRef.current.setFieldsValue({
              proyectoId: this.state.todasProyectos[0]._id
            })
            mostrarMensaje = true
          }
          insumos = insumos.map(value => {
            return {
              ...value,
              proyectoId: this.state.todasProyectos[0]._id
            }
          })
        }

        if (mostrarMensaje) {
          message.info('Se ha asignado el primer precio y proyecto')
        }

        await this.formRef.current.setFieldsValue({
          monedaId,
          tipoDeCambio,
          insumos,
          clienteId,
          fechaVenta: fechaTimbrado,
          factura: 1,
          contado: metodoDePago,
          formaDePagoId,
          usoDeCfdiId
        })
        insumos.map((value, index) => this.onChangeInsumoProyecto(null, index, false, true))
        this.setState({
          xmlSubido: true,
          uuid,
          serieFIngresada,
          folioFIngresada,
          noCertificadoSAT,
          noCertificadoCFDI,
          selloSAT,
          selloCFDI,
          totalFIngresada,
          subtotalFIngresada,
          cfdi: cfdi,
          archivosXml: [
            {
              ...e.file,
              name: e.file.name,
              status: "success",
            },
          ],
          archivo: e.file,
          loading: false
        });
      };


      reader.readAsText(e.file);
    } else {
      message.error("El archivo debe ser un archivo de xml");
      this.setState({ loading: false });
    }
  }

  async abrirVerInsumo(key) {
    if (!this.props.permisoModificarPrecioUnitario) return;
    const arrayValue = await this.formRef.current.getFieldValue("insumos");
    const precioId = await this.formRef.current.getFieldValue("precioId");
    const tipoDeCambio = await this.formRef.current.getFieldValue("tipoDeCambio");
    const insumo = this.state.todasInsumos.find(
      (valueInsumos) => valueInsumos._id === arrayValue[key].insumoId
    );
    if (!insumo) return;

    if (insumo.verInsumoVenta) {
      this.setState({
        modalVerInsumo: true,
        modalVerInsumoId: insumo._id,
        modalVerInsumoPrecioId: precioId,
        modalVerInsumoIndex: key,
        modalVerInsumoTipoDeCambio: tipoDeCambio
      })
    }
  }

  cerrarVerInsumo = async (precio) => {

    if (precio && precio > 0) {
      const insumos = await this.formRef.current.getFieldValue('insumos');
      insumos[this.state.modalVerInsumoIndex].precioUnitario = precio;
      await this.formRef.current.setFieldsValue({ insumos });
      this.onChangePrecioCantidadDescuento(undefined, this.state.modalVerInsumoIndex);
    }

    this.setState({
      modalVerInsumo: false,
      modalVerInsumoId: null,
      modalVerInsumoPrecioId: null,
      modalVerInsumoIndex: 0,
      modalVerInsumoTipoDeCambio: 1
    });
  }
  async onChangeEstado(value, inicial) {
    if (!inicial) {
      this.formRef.current.setFieldsValue({
        direccionEntrega: {
          municipioId: undefined,
          coloniaId: undefined
        }
      });
    }
    await axios
      .post(
        "municipios/selectMunicipios",
        { estadoId: value },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          let objetoMunicipios = res.data.map((value) => {
            return (
              <Option value={value._id} key={value._id}>
                {value.nombre}
              </Option>
            );
          });
          this.setState({
            todasMunicipios: res.data,
            objetoMunicipios: objetoMunicipios,
          });
        }
      });
  }

  async onChangeMunicipio(value, inicial) {
    await axios
      .post(
        "colonias/selectColonias",
        { municipioId: value },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          let objetoColonias = res.data.map((value) => {
            return (
              <Option value={value._id} key={value._id}>
                {value.cp + " - " + value.nombre}
              </Option>
            );
          });
          this.setState({
            todasColonias: res.data,
            objetoColonias: objetoColonias,
          });
        }
      });
  }


  async onSearchColonia(value) {
    if (value.toString().length === 5) {
      await axios
        .post(
          "colonias/buscarCP",
          { cp: value },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          if (res.data.status === 404) {
            message.info("No se encontro el codigo postal");
          } else {
            this.formRef.current.setFieldsValue({
              direccionEntrega: {
                paisId: res.data.paisId,
                estadoId: res.data.estadoId,
                municipioId: res.data.municipioId
              }
            });
            this.onChangeEstado(res.data.estadoId, true);
            this.onChangeMunicipio(res.data.municipioId, true);
          }
        });
    }
  }
  async onSelectColoniaId(coloniaId, fieldKey) {
    const direccionEntrega = this.formRef.current.getFieldValue("direccionEntrega");
    if (!direccionEntrega?.colonia) {
      const nombreColonia = this.state.todasColonias.find((todasColonia) => todasColonia._id.toString() === coloniaId.toString())?.nombre
      await this.formRef.current.setFieldsValue({
        direccionEntrega: {
          colonia: nombreColonia
        }
      })
    }
  }

  handleDireccionEntregaChange(direccionValues) {
    // Callback desde TabEntregaDireccion cuando se guardan cambios en el modal
    if (direccionValues) {
      this.formRef.current?.setFieldsValue({
        direccionEntrega: direccionValues
      });
      this.setState({ 
        direccionEntregaData: direccionValues 
      });
    }
  }

  async handleChangeDireccionEntrega(value) {
    this.setState({ loadingEntrega: true })
    if (value) {
      const direccion = this.state.direccionesCliente.find((direccion) => direccion._id.toString() === value.toString())
      if (direccion) {
        if (direccion.estadoId) {
          await this.onChangeEstado(direccion.estadoId, true);
        }
        if (direccion.municipioId) {
          await this.onChangeMunicipio(direccion.municipioId, true);
        }
        if (direccion.plantaEntregaId) {
          this.onSearchPlantaEntrega(direccion.plantaEntregaId, "direccionEntrega", { byId: true, setSelected: false });
        }
        this.formRef.current.setFieldsValue({
          direccionEntrega: {
            paisId: direccion.paisId,
            estadoId: direccion.estadoId,
            municipioId: direccion.municipioId,
            coloniaId: direccion.coloniaId,
            colonia: direccion.colonia,
            calle: direccion.calle,
            numeroCalle: direccion.numeroCalle,
            numeroInterior: direccion.numeroInterior,
            descripcion: direccion.descripcion,
            telefono: direccion.telefono,
            correo: direccion.correo,
            observaciones: direccion.observaciones,
            plantaEntregaId: direccion.plantaEntregaId,
            referencia: direccion.referencia,
            clienteNombre: direccion?.clienteNombre,
            clienteRfc: direccion?.clienteRfc
          }
        })
      }
    }
    this.setState({ loadingEntrega: false })
  }
  onSearchPlantaEntrega = (value, fieldKey, opts = {}) => {
    const { byId = false, setSelected = false } = opts;
    if (byId) {
      axios
        .post(
          "plantaDeEntrega/selectPlantaEntregaPorId",
          { id: value },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          const p = res?.data?.dato || null;
          if (!p || !p._id) {
            this.setState(prev => ({
              objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: [] },
              loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
            }));
            message.warning("No se encontró la planta por ID.");
            return;
          }

          const option = (
            <Option key={p._id} value={p._id} padre={p.plantaEntregaId}>
              {p.label}
            </Option>
          );

          this.setState(prev => ({
            objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: [option] },
            loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
          }));

          if (setSelected && (this.props.form?.setFieldsValue || this.form?.setFieldsValue)) {
            const form = this.props.form || this.form;
            form.setFields([
              { name: ['"direccionEntrega"', fieldKey, 'plantaEntregaId'], value: p._id }
            ]);
          }
        })
        .catch((err) => {
          console.error(err);
          message.error("Error al buscar planta por ID");
          this.setState(prev => ({
            objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: [] },
            loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
          }));
        });

      return;
    }
    this.setState(prev => ({
      loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: true }
    }));
    axios
      .post(
        "plantaDeEntrega/selectPlantasDeEntrega",
        {
          query: value || ""
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res?.data.success !== 2) {
          this.setState(prev => ({
            objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: [] },
            loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
          }));
          return;
        }
        const items = Array.isArray(res.data.plantas) ? res.data.plantas : [];
        const options = items.map(it => (
          <Option key={it._id} value={it._id} padre={it.plantaEntregaId}>
            {it.label}
          </Option>
        ));

        this.setState(prev => ({
          objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: options },
          loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
        }));
      })
      .catch((err) => {
        console.error(err);
        message.error("Error al buscar plantas de entrega");
        this.setState(prev => ({
          objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: [] },
          loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
        }));
      });
  }
  consultarInformacionEntrega() {
    if (this.state.todasPaises.length > 0) return
    this.setState({ loadingEntrega: true })
    const direccionEntrega = this.formRef.current.getFieldValue("direccionEntrega");

    axios.post("direcciones/selectInformacionDomicilio", { direccion: direccionEntrega }, {
      headers: this.props.headersToken
    })
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            loadingEntrega: false,
            todasPaises: res.data.paises,
            todasEstado: res.data.estados,
            todasMunicipios: res.data.municipios,
            todasColonias: res.data.colonias,
            objetoMunicipios: res.data.municipios.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
            objetoColonias: res.data.colonias.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.cp + " - " + value.nombre}
                </Option>
              );
            }),
            objetoPaises: res.data.paises.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.abreviatura}
                </Option>
              );
            }),
            objetoEstados: res.data.estados.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.abreviatura}
                </Option>
              );
            }),
          })
        } else {
          message.info("No se encontró información para entrega")
          this.setState({
            loadingEntrega: false
          })
        }
      })
  }

  onDobleClickDescuento = (arrayKey) => {
    this.setState(prev => ({
      tiposDescuento: {
        ...prev.tiposDescuento,
        [arrayKey]: prev.tiposDescuento[arrayKey] === 'cantidad' ? 'porcentaje' : 'cantidad'
      }
    }), () => {
      const insumos = this.formRef.current.getFieldValue('insumos')
      if (this.state.tiposDescuento[arrayKey] === 'cantidad') {
        if (this.props.escuela) {
          // El Desc. Cliente se queda; solo se limpia el adicional en %.
          insumos[arrayKey].descuentoAdicional = 0
          sincronizarDescuentoFila(insumos[arrayKey])
        } else {
          insumos[arrayKey].descuento = 0
        }
      } else {
        insumos[arrayKey].descuentoCantidad = 0
      }
      this.formRef.current.setFieldsValue({ insumos })
      this.onChangePrecioCantidadDescuento(0, arrayKey)
    })
  }

  // Complemento Escuela: % predeterminado del cliente seleccionado.
  descuentoPredeterminadoCliente = () => {
    const clienteId = this.formRef.current?.getFieldValue("clienteId");
    if (!clienteId) return 0;
    const cliente = this.state.todasClientes.find(
      (valueCliente) => valueCliente._id?.toString() === clienteId.toString()
    );
    return cliente?.descuentoPredeterminado || 0;
  }

  // Complemento Escuela: Desc. Cliente y Desc. Adic. alimentan `descuento` (su
  // cascada), que es el unico que entra en el calculo.
  onChangeDescuentoEscuela = (arrayKey) => {
    const insumos = this.formRef.current.getFieldValue("insumos");
    sincronizarDescuentoFila(insumos[arrayKey]);
    this.formRef.current.setFieldsValue({ insumos });
    this.onChangePrecioCantidadDescuento(undefined, arrayKey);
  }

  async consultarDatosEquipoMedico() {
    this.setState({ loading: true })
    await axios
      .post(
        "ventas/selectDatosParaEquipoMedico",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            loading: false,
            todasDoctores: res.data.doctores,
            todasPacientes: res.data.pacientes,
            todasCirugias: res.data.cirugias,
            objetoDoctores: res.data.doctores.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.codigo + ' - ' + value.nombre}
                </Option>
              );
            }),
            objetoPacientes: res.data.pacientes.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.codigo + ' - ' + value.nombre}
                </Option>
              );
            }),
            objetoCirugias: res.data.cirugias.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.codigo + ' - ' + value.nombre}
                </Option>
              );
            }),
          });
        } else {
          message.error('No se encontraron datos de equipo medico')
        }
      });
  }

  abrirAgregarCirugia(value) {
    this.setState({
      modalAgregarCirugia: true,
    })
  }

  cerrarAgregarCirugia(value) {
    this.setState({
      modalAgregarCirugia: false,
    })
    this.consultarDatosEquipoMedico()
  }

  abrirAgregarDoctor(value) {
    this.setState({
      modalAgregarDoctor: true,
    })
  }

  cerrarAgregarDoctor(value) {
    this.setState({
      modalAgregarDoctor: false,
    })
    this.consultarDatosEquipoMedico()
  }

  abrirAgregarPaciente(value) {
    this.setState({
      modalAgregarPaciente: true,
    })
  }

  cerrarAgregarPaciente(value) {
    this.setState({
      modalAgregarPaciente: false,
    })
    this.consultarDatosEquipoMedico()
  }

  eliminarInsumo = (name, arrayKey, remove) => {
    remove(name);
    this.setState(prev => {
      const nuevosObligatorios = {};
      Object.entries(prev.insumosObligatoriosLista).forEach(([k, v]) => {
        const i = parseInt(k);
        if (i < arrayKey) nuevosObligatorios[i] = v;
        else if (i > arrayKey) nuevosObligatorios[i - 1] = v;
      });
      const nuevosTipos = {};
      Object.entries(prev.tiposDescuento).forEach(([k, v]) => {
        const i = parseInt(k);
        if (i < arrayKey) nuevosTipos[i] = v;
        else if (i > arrayKey) nuevosTipos[i - 1] = v;
      });
      const nuevosNoEliminables = {};
      Object.entries(prev.insumosNoEliminablesLista).forEach(([k, v]) => {
        const i = parseInt(k);
        if (i < arrayKey) nuevosNoEliminables[i] = v;
        else if (i > arrayKey) nuevosNoEliminables[i - 1] = v;
      });
      return { insumosObligatoriosLista: nuevosObligatorios, tiposDescuento: nuevosTipos, insumosNoEliminablesLista: nuevosNoEliminables };
    });
  };

  moverInsumo = (fromIndex, toIndex, moveAntd) => {
    moveAntd(fromIndex, toIndex);
    this.setState(prev => {
      const nuevosTipos = { ...prev.tiposDescuento };
      const temp1 = nuevosTipos[fromIndex];
      nuevosTipos[fromIndex] = nuevosTipos[toIndex];
      nuevosTipos[toIndex] = temp1;

      const nuevosObligatorios = { ...prev.insumosObligatoriosLista };
      const temp2 = nuevosObligatorios[fromIndex];
      nuevosObligatorios[fromIndex] = nuevosObligatorios[toIndex];
      nuevosObligatorios[toIndex] = temp2;

      const nuevosNoEliminables = { ...prev.insumosNoEliminablesLista };
      const temp3 = nuevosNoEliminables[fromIndex];
      nuevosNoEliminables[fromIndex] = nuevosNoEliminables[toIndex];
      nuevosNoEliminables[toIndex] = temp3;

      return { tiposDescuento: nuevosTipos, insumosObligatoriosLista: nuevosObligatorios, insumosNoEliminablesLista: nuevosNoEliminables };
    });
  };

  dejarSoloObligatorios = () => {
    if (!this.removeInsumoRef) return;
    const currentInsumos = this.formRef.current.getFieldValue('insumos') || [];
    const obligatorios = this.state.insumosObligatoriosLista;

    const indicesARemover = [];
    currentInsumos.forEach((_, i) => {
      if (!obligatorios[i]) indicesARemover.push(i);
    });
    if (indicesARemover.length === 0) return;

    const nuevosObligatorios = {};
    const nuevosTipos = {};
    let newIndex = 0;
    currentInsumos.forEach((_, oldIndex) => {
      if (obligatorios[oldIndex]) {
        nuevosObligatorios[newIndex] = true;
        if (this.state.tiposDescuento[oldIndex] !== undefined)
          nuevosTipos[newIndex] = this.state.tiposDescuento[oldIndex];
        newIndex++;
      }
    });

    this.removeInsumoRef(indicesARemover);
    this.setState({ insumosObligatoriosLista: nuevosObligatorios, tiposDescuento: nuevosTipos });
  };

  quitarObligatorios = () => {
    if (!this.removeInsumoRef) return;
    const currentInsumos = this.formRef.current.getFieldValue('insumos') || [];
    const obligatorios = this.state.insumosObligatoriosLista;

    const indicesARemover = [];
    currentInsumos.forEach((_, i) => {
      if (obligatorios[i]) indicesARemover.push(i);
    });
    if (indicesARemover.length === 0) return;

    const nuevosTipos = {};
    let newIndex = 0;
    currentInsumos.forEach((_, oldIndex) => {
      if (!obligatorios[oldIndex]) {
        if (this.state.tiposDescuento[oldIndex] !== undefined)
          nuevosTipos[newIndex] = this.state.tiposDescuento[oldIndex];
        newIndex++;
      }
    });

    this.removeInsumoRef(indicesARemover);
    this.setState({ insumosObligatoriosLista: {}, tiposDescuento: nuevosTipos });
  };

  abrirVistaPrevia() {
    const values = this.formRef.current.getFieldsValue();
    if (!values.insumos || values.insumos.length === 0) {
      return message.warning("Agregue insumos para ver la vista previa");
    }
    if (values.contado === 1 && !values.formaDePagoId) {
      return message.warning("Seleccione la forma de pago para ver la vista previa");
    }
    // La vista previa no pasa por validateFields. Un renglon con producto pero sin cantidad
    // (o sin precio) llega al backend sin ese campo: el total sale NaN, viaja como null en el
    // JSON y el PDF truena en numeroALetra. Los renglones totalmente vacios se ignoran.
    const esNumero = (n) => n !== null && n !== undefined && n !== "" && Number.isFinite(Number(n));
    const renglonCapturado = (value) => value?.insumoId || esNumero(value?.cantidad) || esNumero(value?.precioUnitario);
    const renglonIncompleto = values.insumos.findIndex((value) =>
      renglonCapturado(value) && (!value.insumoId || !esNumero(value.cantidad) || !esNumero(value.precioUnitario))
    );
    if (renglonIncompleto !== -1) {
      return message.warning(`Complete insumo, cantidad y precio del renglón ${renglonIncompleto + 1} para ver la vista previa`);
    }
    const insumos = values.insumos.filter(renglonCapturado);
    if (insumos.length === 0) {
      return message.warning("Agregue insumos para ver la vista previa");
    }
    // T. Cambio borrado: el IEPS por cuota divide entre el y el total tambien sale NaN/Infinity.
    if (values.tipoDeCambio !== undefined && (!esNumero(values.tipoDeCambio) || Number(values.tipoDeCambio) <= 0)) {
      return message.warning("Capture el tipo de cambio para ver la vista previa");
    }
    // Calcular total y totalPagar igual que en onFinish
    let total = 0;
    let subtotal = 0;
    let cuentasCliente = 0;
    insumos.forEach(value => {
      total += value.subtotal || 0;
      subtotal += value.subtotal || 0;
      (value.arrayImpuestos || []).forEach(imp => {
        total += round2Decimals(imp.totalImpuestos || 0);
      });
      (value.arrayRetenciones || []).forEach(ret => {
        cuentasCliente += round2Decimals(ret.totalRetenciones || 0);
      });
    });
    this.setState({
      modalVistaPrevia: true,
      datosVistaPrevia: {
        ...values,
        insumos,
        ubicacionesEnvio: this.state.ubicacionesEnvio,
        mercanciasEnvio: this.state.mercanciasEnvio,
        xmlSubido: this.state.xmlSubido,
        cadenaOriginalSAT: this.state.cadenaOriginalSAT,
        noCertificadoSAT: this.state.noCertificadoSAT,
        noCertificadoCFDI: this.state.noCertificadoCFDI,
        uuid: this.state.uuid,
        selloSAT: this.state.selloSAT,
        selloCFDI: this.state.selloCFDI,
        fechaTimbrado: this.state.fechaTimbrado,
        qrCode: this.state.qrCode,
        cfdi: this.state.cfdi,
        folioFIngresada: this.state.folioFIngresada,
        serieFIngresada: this.state.serieFIngresada,
        totalFIngresada: this.state.totalFIngresada,
        subtotalFIngresada: this.state.subtotalFIngresada,
        total:       round2Decimals(total),
        subtotal:    round2Decimals(subtotal),
        totalPagar:  round2Decimals(total - cuentasCliente),
      }
    });
  }
  
      
  getObservacionesConfig = () => {
    const { empresaId, activarPagare, quitarImpuestosOpcionalVentas } = this.props;

    return {
      observaciones: {
        label: "Observaciones",
        value: this.formRef.current?.getFieldValue("observaciones") || "",
        onSave: (newValue) => {
          this.formRef.current?.setFieldsValue({ observaciones: newValue });
          this.forceUpdate();
        },
      },

      observaciones2: { 
        label: "Observaciones Internas",
        value: this.formRef.current?.getFieldValue("observaciones2") || "",
        tooltip: "Estas observaciones no se imprimirán en la venta.",
        onSave: (newValue) => {
          this.formRef.current?.setFieldsValue({ observaciones2: newValue });
          this.forceUpdate();
        },
      },

      checkboxes: [
        ...(activarPagare
          ? [{ label: "Pagaré", name: "imprimirPagare" }]
          : []),
        ...(quitarImpuestosOpcionalVentas && this.state.factura === 3
          ? [{ label: "Quitar Impuestos", name: "quitarImpuestos", onChange: (e) => {
              this.setState({ quitarImpuestos: e.target.checked }, () => {
                const insumos = this.formRef.current.getFieldValue("insumos");
                if (insumos?.length) this.recalcularInsumosEnBatch(insumos);
              });
            }}]
          : []),
        { label: "Imprimir", name: "imprimirObservaciones" },
        { label: "Des. Imprimir Banco", name: "deshabilitarBanco" },
      ],

      camposCondicionales:
        ["677c1e57f38e06c3032974fb", "60cb97c241d9aa33f448305c"].includes(
          empresaId?.toString()
        ) ? (
          <>
            <Col span={8} xs={24} sm={12} lg={8}>
              <FormItem name="articulo" label="Articulo">
                <InputItem />
              </FormItem>
            </Col>

            <Col span={8} xs={24} sm={12} lg={8}>
              <FormItem name="diaPago" label="Dia Pago">
                <InputItem />
              </FormItem>
            </Col>

            <Col span={8} xs={24} sm={12} lg={8}>
              <FormItem name="concepto" label="Concepto">
                <InputItem />
              </FormItem>
            </Col>

            <Col span={8} xs={24} sm={12} lg={8}>
              <FormItem name="pagoSemana" label="Pago Semana">
                <InputNumberItem dinero />
              </FormItem>
            </Col>

            <Col span={8} xs={24} sm={12} lg={8}>
              <FormItem name="recargoSemana" label="Recargo Semana">
                <InputNumberItem dinero />
              </FormItem>
            </Col>

            <Col span={8} xs={24} sm={12} lg={8}>
              <FormItem name="parcialidadVigente" label="Parcialidad Vigente">
                <InputNumberItem />
              </FormItem>
            </Col>

            <Col span={8} xs={24} sm={12} lg={8}>
              <FormItem name="parcialidades" label="Parcialidades">
                <InputNumberItem />
              </FormItem>
            </Col>
          </>
        ) : null,

      camposFechas: null,
      totales: null,
    };
  };

  getInsumosColumns() {
    // Escuela: Insumo y Proyecto ceden el ancho de Desc. Cliente para que
    // Subtotal / Impuesto / Total no se encoja.
    return [
      { title: "#", width: "3%" },
      { title: "Clave", width: "5%" },
      { title: "Insumo", width: this.props.escuela ? "18%" : "22%" },
      { title: "Unidad", width: "6%" },
      { title: "Proyecto", width: this.props.escuela ? "10%" : "12%" },
      { title: "PU", width: "9%" },
      { title: "Precio Neto", width: "9%" },
      { title: "Inventario", width: "8%" },
      {
        title: (
          <FormItem noStyle shouldUpdate>
            {({ getFieldValue }) => {
              const items = getFieldValue("insumos") || [];
              const totalCantidad = items.reduce((suma, it) => suma + (Number(it?.cantidad) || 0), 0);
              return (
                <>
                  <div>Cant.</div>
                  <div style={{ fontWeight: 400, fontSize: '11px', color: '#868585' }}>
                    Total: {totalCantidad}
                  </div>
                </>
              );
            }}
          </FormItem>
        ),
        width: "8%",
      },
      ...(this.props.escuela
        ? [{ title: (<>Desc. Cliente{' '}<Tooltip title="Descuento predeterminado del cliente. El Desc. Adic. se aplica en cascada sobre lo que queda." mouseEnterDelay={0.5}><span style={{ cursor: 'help', color: '#1890ff', fontSize: '12px' }}>?</span></Tooltip></>), width: "6%" }]
        : []),
      { title: (<>{this.props.escuela ? "Desc. Adic." : "Desc."}{' '}<Tooltip title="Doble click en la celda para cambiar entre descuento % y $" mouseEnterDelay={0.5}><span style={{ cursor: 'help', color: '#1890ff', fontSize: '12px' }}>?</span></Tooltip></>), width: "8%" },
      { title: "Subtotal / Impuesto / Total", width: "13%" },
      {
        title: (
          <Space size={4}>
            <Tooltip title={this.state.modoReordenar ? "Terminar de reordenar" : "Reordenar insumos"}>
              <ButtonItem
                key="btn-reordenar"
                type={this.state.modoReordenar ? "primary" : "default"}
                onClick={() => this.setState({ modoReordenar: !this.state.modoReordenar })}
                icon={<SwapOutlined rotate={90} />}
                morado={this.state.modoReordenar}
                blanco={!this.state.modoReordenar}
                lessTime
                size="small"
              />
            </Tooltip>
            {Object.keys(this.state.insumosObligatoriosLista).length > 0 && (
              <Tooltip title="Dejar solo obligatorios">
                <ButtonItem
                  key="btn-solo-obligatorios"
                  onClick={this.dejarSoloObligatorios}
                  icon={<ScissorOutlined />}
                  naranja
                  lessTime
                  size="small"
                />
              </Tooltip>
            )}
            {Object.keys(this.state.insumosObligatoriosLista).length > 0 && (
              <Tooltip title="Quitar obligatorios">
                <ButtonItem
                  key="btn-quitar-obligatorios"
                  onClick={this.quitarObligatorios}
                  icon={<ScissorOutlined />}
                  rojo
                  lessTime
                  size="small"
                />
              </Tooltip>
            )}
          </Space>
        ),
        width: "12%"
      }
    ];
  }

  // Método para renderizar cada fila de la tabla de insumos
  renderInsumoRow({ key, name, fieldKey, restField, arrayKey, remove, move }) {
    this.removeInsumoRef = remove;
    const clienteIdActual = this.formRef.current?.getFieldValue("clienteId");
    const usarPrecioClienteActual = this.formRef.current?.getFieldValue("usarPrecioCliente");
    const fields = this.formRef.current?.getFieldValue('insumos') || [];
    const esPrimero = arrayKey === 0;
    const esUltimo = arrayKey === fields.length - 1;
    const filaConConflicto = (this.state.filasConError || []).includes(arrayKey);
    return (
      <React.Fragment key={key}>
        <tr className={`fila-insumo${filaConConflicto ? ' fila-insumo-conflicto' : ''}`}>
          <td className="td-border">
            <div style={{ fontSize: '14px', textAlign: 'center', color: '#868585' }}>
              {arrayKey + 1}
            </div>
          </td>
           <td className="td-border">
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const insumoId = getFieldValue(['insumos', arrayKey, 'insumoId']);
                const insumoSeleccionado = this.state.todasInsumos?.find(
                  (insumo) => insumo._id.toString() === insumoId?.toString()
                );
                return (
                  <div style={{ fontSize: '14px', textAlign: 'center', color: '#868585', whiteSpace: 'normal', wordBreak: 'break-word' }}>
                    {insumoSeleccionado?.claveClienteAlternativa || insumoSeleccionado?.clave || '-'}
                  </div>
                );
              }}
            </FormItem>
          </td>
          {/* Columna: Insumo */}
          <td className="td-border" style={{
            maxWidth: '200px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}>
            <FormItem
              {...restField}
              name={[name, "insumoId"]}
              required
              noStyle
            >
              <SelectInsumosItem
                empresaId={this.props.empresaId}
                headersToken={this.props.headersToken}
                clienteId={clienteIdActual}
                usarPrecioCliente={usarPrecioClienteActual}
                sinBorde
                autoFocus
                focusTdIndex={3}
                disabled={this.state.xmlSubido || this.state.insumosNoEliminablesLista[arrayKey]}
                dropdownMatchSelectWidth={600}
                width="100%"
                placeholder="Insumo"
                ocultarCodigoYUnidad
                style={{
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                height: 'auto',
                minHeight: '32px',
                lineHeight: '1.4'
              }}
                onChange={(value, insumo) =>
                  this.onChangeInsumoProyecto(value, arrayKey, 'insumo', false, insumo)
                }
              />
            </FormItem>
            {this.state.insumosObligatoriosLista[arrayKey] && (
              <div style={{ fontSize: 11, color: '#fa8c16', whiteSpace: 'normal', marginTop: 2 }}>
                ● Obligatorio del kit
              </div>
            )}
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const insumoId = getFieldValue(['insumos', arrayKey, 'insumoId']);
                const insumoSeleccionado = this.state.todasInsumos?.find(
                  (insumo) => insumo._id.toString() === insumoId?.toString()
                );
                if (!insumoSeleccionado?.nombreClienteAlternativo) return null;
                return (
                  <div style={{ fontSize: 11, color: '#999', whiteSpace: 'normal', marginTop: 2 }}>
                    {insumoSeleccionado.descripcion}
                  </div>
                );
              }}
            </FormItem>
          </td>

          {/* Columna: Unidad */}
          <td className="td-border">
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const insumoId = getFieldValue(['insumos', arrayKey, 'insumoId']);
                const insumoSeleccionado = this.state.todasInsumos?.find(
                  (insumo) => insumo._id.toString() === insumoId?.toString()
                );
                const unidad = insumoSeleccionado?.unidad;
                const unidadTexto = typeof unidad === 'object' && unidad !== null
                  ? (unidad.nombre || unidad.descripcion || '-')
                  : (unidad || '-');
                return (
                  <div style={{ fontSize: '14px', textAlign: 'center' }}>
                    {unidadTexto}
                    {insumoSeleccionado?.presentacionCliente && (
                      <div style={{ fontSize: 11, color: '#999' }}>{insumoSeleccionado.presentacionCliente}</div>
                    )}
                  </div>
                );
              }}
            </FormItem>
          </td>

          {/* Columna: Proyecto */}
          <td className="td-border" style={{ maxWidth: '150px', overflow: 'hidden' }}>
            <FormItem
              shouldUpdate={(prev, curr) =>
                prev.proyectoId !== curr.proyectoId
              }
              noStyle
            >
              {({ getFieldValue }) => {
                const proyectoId = getFieldValue("proyectoId");
                const arrayValue = getFieldValue("insumos");
                const insumoValue = arrayValue[arrayKey];
                return (
                  <FormItem
                    {...restField}
                    name={[name, "proyectoId"]}
                    required
                    noStyle
                    initialValue={proyectoId}
                  >
                    <SelectItem
                      sinBorde
                      width="100%"
                      placeholder="Proyecto"
                      className="select-insumo-wrap"
                      disabled={insumoValue?.apartado > 0 || this.state.insumosNoEliminablesLista[arrayKey]}
                      style={{
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                        height: 'auto',
                        minHeight: '32px',
                        lineHeight: '1.4',
                      }}
                      onChange={(value) =>
                        this.onChangeInsumoProyecto(
                          value,
                          arrayKey,
                          'proyecto'
                        )
                      }
                    >
                      {this.state.objetoProyectos}
                    </SelectItem>
                  </FormItem>
                );
              }}
            </FormItem>
          </td>

          {/* Columna: PU (Precio Unitario) */}
          <td
            className="td-border"
            onContextMenu={(e) => {
              e.preventDefault();
              this.abrirVerInsumo(arrayKey);
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <div style={{ flex: 1 }}>
                <FormItem
                  {...restField}
                  name={[name, "precioUnitario"]}
                  noStyle
                  required
                  numberCero
                >
                  <InputNumberItem
                    sinBorde
                    disabled={this.state.xmlSubido || this.estaBloqueado("precioUnitario", arrayKey) || this.state.insumosNoEliminablesLista[arrayKey]}
                    onChange={(value) =>
                      this.onChangePrecioCantidadDescuento(
                        value,
                        arrayKey
                      )
                    }
                    placeholder="Precio Unitario"
                    dinero
                  />
                </FormItem>
              </div>
              {/* Aviso en vivo de rango: no bloquea la captura, solo advierte.
                  El candado real se aplica al guardar y en el backend. */}
              {this.state.fueraDeRango[arrayKey]?.campo === "precioUnitario" ? (
                <Tooltip title={this.state.fueraDeRango[arrayKey].motivo}>
                  <WarningOutlined style={{ color: "#faad14", marginLeft: 4 }} />
                </Tooltip>
              ) : null}
              <BotonAutorizacion
                visible={this.props.autorizacionesRapidas && !this.state.xmlSubido && this.tieneInsumoSeleccionado(arrayKey) && this.estaBloqueado("precioUnitario", arrayKey)}
                onClick={() => this.abrirModalAutorizacion("precioUnitario", arrayKey)}
              />
            </div>
          </td>

          {/* Columna: Precio Neto (con impuestos) */}
          <td className="td-border">
            <FormItem
              {...restField}
              name={[name, "precioUnitarioConImpuestos"]}
              noStyle
              required
            >
              <InputNumberItem
                sinBorde
                disabled={this.state.xmlSubido || this.estaBloqueado("precioUnitario", arrayKey) || this.state.insumosNoEliminablesLista[arrayKey]}
                dinero
                onChange={(value) => this.onChangePrecioConImpuestos(value, arrayKey)}
                placeholder="Precio Unitario con Impuestos"
              />
            </FormItem>
          </td>

          {/* Columna: Inventario */}
          <td
            className="td-border"
            onDoubleClick={() => {
              const insumos = this.formRef.current.getFieldValue('insumos');
              const row = insumos[arrayKey];
              const insumoObj = this.state.todasInsumos?.find(i => i._id === row?.insumoId);
              this.abrirDisponibilidad(row?.insumoId, insumoObj?.nombre || insumoObj?.descripcion || '', row?.proyectoId);
            }}
            onContextMenu={(e) => {
              e.preventDefault();
              const insumos = this.formRef.current.getFieldValue('insumos');
              const row = insumos[arrayKey];
              const insumoObj = this.state.todasInsumos?.find(i => i._id === row?.insumoId);
              this.abrirHistorialCliente(row?.insumoId, insumoObj?.nombre || insumoObj?.descripcion || '', arrayKey);
            }}
            title="Doble clic: disponibilidad · Clic derecho: historial con este cliente"
            style={{ cursor: 'pointer' }}
          >
            <div style={{ pointerEvents: 'none' }}>
              <FormItem
                {...restField}
                name={[name, "cantidadProyecto"]}
                required
                noStyle
              >
                <InputNumberItem
                  sinBorde
                  disabled
                  placeholder="Inventario"
                  precision={5}
                />
              </FormItem>
            </div>
          </td>

          {/* Columna: Cantidad */}
          <td className="td-border">
            <FormItem
              noStyle
              shouldUpdate={(prev, curr) =>
                prev.insumos[arrayKey]?.cantidadProyecto !==
                curr.insumos[arrayKey]?.cantidadProyecto
              }
            >
              {({ getFieldValue }) => {
                const insumos = getFieldValue("insumos");
                const cantidadProyecto = insumos[arrayKey].cantidadProyecto;
                let max = 0;
                if (cantidadProyecto === "No inventariable") {
                  max = Infinity;
                } else {
                  max = cantidadProyecto;
                }
                return (
                  <FormItem
                    {...restField}
                    name={[name, "cantidad"]}
                    number
                    noStyle
                    required
                    type="number"
                  >
                    <InputNumberItem
                      sinBorde
                      disabled={this.state.xmlSubido || this.state.insumosNoEliminablesLista[arrayKey]}
                      placeholder={
                        max && max !== Infinity
                          ? "Max: " + max
                          : "Cantidad"
                      }
                      max={10000000}
                      onChange={(value) =>
                        this.onChangePrecioCantidadDescuento(
                          value,
                          arrayKey
                        )
                      }
                    />
                  </FormItem>
                );
              }}
            </FormItem>
          </td>

          {/* Columna: Desc. Cliente (complemento Escuela) */}
          {this.props.escuela && (
            <td className="td-border">
              <FormItem
                {...restField}
                key={`desc-base-${arrayKey}`}
                name={[name, "descuentoBase"]}
                numberCero
                noStyle
                initialValue={0}
              >
                <InputNumberItem
                  disabled={this.estaBloqueado("descuento", arrayKey)}
                  sinBorde
                  placeholder="Desc. %"
                  porcentaje
                  max={100}
                  onChange={() => this.onChangeDescuentoEscuela(arrayKey)}
                />
              </FormItem>
            </td>
          )}

          {/* Columna: Descuento */}
          <td className="td-border">
            <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ flex: 1 }}>
            {this.state.tiposDescuento[arrayKey] === 'cantidad' ? (
              <FormItem
                {...restField}
                key={`desc-cantidad-${arrayKey}`}
                name={[name, "descuentoCantidad"]}
                numberCero
                noStyle
                initialValue={0}
              >
                <InputNumberItem
                  disabled={this.estaBloqueado("descuento", arrayKey)}
                  sinBorde
                  placeholder="Desc. $"
                  dinero
                  onDoubleClick={() => this.onDobleClickDescuento(arrayKey)}
                  onChange={(value) =>
                    this.onChangePrecioCantidadDescuento(value, arrayKey)
                  }
                />
              </FormItem>
            ) : (
              <FormItem
                {...restField}
                key={`desc-porcentaje-${arrayKey}`}
                name={[name, this.props.escuela ? "descuentoAdicional" : "descuento"]}
                required
                numberCero
                noStyle
                initialValue={0}
              >
                <InputNumberItem
                  disabled={this.estaBloqueado("descuento", arrayKey)}
                  sinBorde
                  placeholder="Desc. %"
                  porcentaje
                  max={100}
                  onDoubleClick={() => this.onDobleClickDescuento(arrayKey)}
                  onChange={(value) =>
                    this.props.escuela
                      ? this.onChangeDescuentoEscuela(arrayKey)
                      : this.onChangePrecioCantidadDescuento(value, arrayKey)
                  }
                />
              </FormItem>
            )}
            </div>
            {this.state.fueraDeRango[arrayKey]?.campo === "descuento" ? (
              <Tooltip title={this.state.fueraDeRango[arrayKey].motivo}>
                <WarningOutlined style={{ color: "#faad14", marginLeft: 4 }} />
              </Tooltip>
            ) : null}
            <BotonAutorizacion
              visible={this.props.autorizacionesRapidas && this.tieneInsumoSeleccionado(arrayKey) && this.estaBloqueado("descuento", arrayKey)}
              onClick={() => this.abrirModalAutorizacion("descuento", arrayKey)}
            />
            </div>
          </td>

          {/* Columna: Subtotal / Impuesto / Total*/}
          <td className="td-border">
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const subtotal = getFieldValue(['insumos', arrayKey, 'subtotal']) || 0;
                const impuestos = getFieldValue(['insumos', arrayKey, 'impuestos']) || 0;
                const total = getFieldValue(['insumos', arrayKey, 'total']) || 0;

                const formatNumber = (num) => {
                  return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                };

                return (
                  <div className="celda-totales" style={{ fontSize: '12px' }}>
                    <div>${formatNumber(subtotal)}</div>
                    <div>${formatNumber(impuestos)}</div>
                    <div className="total-bold">Total: ${formatNumber(total)}</div>
                  </div>
                );
              }}
            </FormItem>

            {/* Campos hidden para mantener los valores en el form */}
            <FormItem {...restField} name={[name, "subtotal"]} required numberCero hidden>
              <InputNumberItem />
            </FormItem>
            <FormItem {...restField} name={[name, "impuestos"]} required numberCero hidden>
              <InputNumberItem />
            </FormItem>
            <FormItem {...restField} name={[name, "total"]} required numberCero hidden>
              <InputNumberItem />
            </FormItem>
          </td>

          <td className="td-border-sin-right" style={{ textAlign: 'center' }}>
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                let arrayValue = getFieldValue("insumos");

                let mostrarMarbetes = false;
                let mostrarLeyenda = false;
                let mostrarObservaciones = false;
                let mostrarLotes = false;
                let mostrarAgrupaciones = false;
                let mostrarKitVariable = false;
                let insumoId;
                let proyectoId;
                let insumoOriginal;

                if (arrayValue[arrayKey]?.insumoId && this.state.todasInsumos) {
                  const insumo = this.state.todasInsumos.find(
                    (valueInsumos) => valueInsumos._id === arrayValue[arrayKey].insumoId
                  );
                  insumoOriginal = insumo;

                  mostrarMarbetes = insumo?.marbetes;
                  mostrarLotes = insumo?.lotesCaducidades;
                  mostrarAgrupaciones = insumo?.agrupaciones;
                  mostrarLeyenda = insumo?.leyendaVenta;
                  mostrarObservaciones = insumo?.observacionesVenta;
                  mostrarKitVariable = insumo?.insumoCompuesto && insumo?.kitVariable;

                  insumoId = insumo?._id;
                  proyectoId = arrayValue[arrayKey]?.proyectoId;
                }

                let buttons = [];

                if (arrayValue[arrayKey]?.insumoId) {
                  buttons.push(
                    <Tooltip key="det" title="Ver detalle del insumo">
                      <ButtonItem
                        type="primary"
                        size="small"
                        icon={<EyeOutlined />}
                        cyan
                        onClick={() =>
                          this.abrirDetalleInsumo(
                            arrayValue[arrayKey].insumoId,
                            insumoOriginal?.nombre || insumoOriginal?.descripcion || ''
                          )
                        }
                      />
                    </Tooltip>
                  );
                }

                if (mostrarLeyenda && !this.state.xmlSubido) {
                  buttons.push(
                    <Tooltip key="ley" title="Agregar Leyenda">
                      <ButtonItem
                        type="primary"
                        size="small"
                        icon={<FileTextOutlined />}
                        lima2
                        verde={arrayValue[arrayKey].leyenda}
                        onClick={() =>
                          this.abrirLeyenda(
                            arrayKey,
                            arrayValue[arrayKey].leyenda,
                            arrayValue[arrayKey].insumoId
                          )
                        }
                      />
                    </Tooltip>
                  );
                }

                if (mostrarMarbetes) {
                  buttons.push(
                    <Tooltip key="mar" title="Marbetes">
                      <ButtonItem
                        type="primary"
                        size="small"
                        cyan2
                        icon={<TagsOutlined />}
                        onClick={() =>
                          this.abrirElegirMarbetes(
                            arrayKey,
                            arrayValue[arrayKey].marbetes,
                            insumoId,
                            proyectoId
                          )
                        }
                      />
                    </Tooltip>
                  );
                }

                if (mostrarAgrupaciones) {
                  buttons.push(
                    <Tooltip key="agr" title="Agrupaciones">
                      <ButtonItem
                        type="primary"
                        size="small"
                        cyan2
                        icon={<AppstoreOutlined />}
                        onClick={() =>
                          this.abrirElegirAgrupaciones(
                            arrayKey,
                            arrayValue[arrayKey].agrupaciones,
                            insumoId,
                            proyectoId
                          )
                        }
                      />
                    </Tooltip>
                  );
                } else if (mostrarLotes) {
                  buttons.push(
                    <Tooltip key="lot" title={this.props.taxidermia ? "Animales" : "Lotes"}>
                      <ButtonItem
                        type="primary"
                        size="small"
                        amarillo2
                        icon={<DatabaseOutlined />}
                        onClick={() =>
                          this.abrirElegirLotes(
                            arrayKey,
                            arrayValue[arrayKey].lotes,
                            insumoId,
                            proyectoId,
                            arrayValue[arrayKey].cantidad
                          )
                        }
                      />
                    </Tooltip>
                  );
                }

                if (textoDescripcionLarga(insumoOriginal)) {
                  buttons.push(
                    <BotonDescripcionLarga
                      key="desc-larga"
                      renglon={arrayValue[arrayKey]}
                      insumoOriginal={insumoOriginal}
                      onToggle={(valor) => {
                        const insumosActuales = this.formRef.current.getFieldValue('insumos');
                        insumosActuales[arrayKey].imprimirDescripcionLarga = valor;
                        this.formRef.current.setFieldsValue({ insumos: insumosActuales });
                        this.forceUpdate();
                      }}
                    />
                  );
                }

                if (mostrarObservaciones) {
                  buttons.push(
                    <Tooltip key="obs" title="Agregar Observaciones">
                      <ButtonItem
                        type="primary"
                        size="small"
                        cyan2
                        icon={<CommentOutlined />}
                        verde={arrayValue[arrayKey].observaciones}
                        onClick={() =>
                          this.abrirObservaciones(
                            arrayKey,
                            arrayValue[arrayKey].observaciones,
                            arrayValue[arrayKey].insumoId,
                            arrayValue[arrayKey].observacionesXml
                          )
                        }
                      />
                    </Tooltip>
                  );
                }

                if (this.state.insumosNoEliminablesLista[arrayKey]) {
                  const pedidoOrigenNumero = arrayValue[arrayKey]?.pedidoOrigenNumero;
                  const cantidadEntregada = arrayValue[arrayKey]?.cantidad;
                  buttons.push(
                    <Tooltip
                      key="entregadoOrigen"
                      title={pedidoOrigenNumero ? `Entregado del pedido ${pedidoOrigenNumero} — ${cantidadEntregada} pzas` : "Ya entregado desde el pedido de origen"}
                    >
                      <ButtonItem
                        type="primary"
                        size="small"
                        azul2
                        icon={<InfoCircleOutlined />}
                      />
                    </Tooltip>
                  );
                }

                if (this.state.complementoComercioExterior && arrayValue[arrayKey]?.insumoId) {
                  buttons.push(
                    <Tooltip key="ce" title="Comercio Exterior">
                      <ButtonItem
                        type="primary"
                        size="small"
                        icon={<GlobalOutlined />}
                        naranja2
                        verde={
                          arrayValue[arrayKey].comercioExteriorInsumo &&
                          Object.keys(arrayValue[arrayKey].comercioExteriorInsumo).length > 0
                        }
                        onClick={() =>
                          this.abrirComercioExteriorInsumo(
                            arrayKey,
                            arrayValue[arrayKey].comercioExteriorInsumo || {},
                            arrayValue[arrayKey].insumoId
                          )
                        }
                      />
                    </Tooltip>
                  );
                }

                if (mostrarKitVariable) {
                  buttons.push(
                    <Tooltip key="kit" title="Elegir Insumos Del Kit">
                      <ButtonItem
                        type="primary"
                        size="small"
                        lila2
                        icon={<BuildOutlined />}
                        verde={arrayValue[arrayKey].componentesKit?.length > 0}
                        onClick={() =>
                          this.abrirElegirComponentesKit(
                            arrayKey,
                            arrayValue[arrayKey].componentesKit,
                            insumoId
                          )
                        }
                      />
                    </Tooltip>
                  );
                  buttons.push(
                    <Tooltip key="kit-imprimir" title={arrayValue[arrayKey].imprimirComponentesKit ? "No Imprimir Insumos Del Kit" : "Imprimir Insumos Del Kit"}>
                      <ButtonItem
                        type="primary"
                        size="small"
                        icon={<PrinterOutlined />}
                        verde={arrayValue[arrayKey].imprimirComponentesKit}
                        onClick={() => {
                          const insumosActuales = this.formRef.current.getFieldValue('insumos');
                          insumosActuales[arrayKey].imprimirComponentesKit = !insumosActuales[arrayKey].imprimirComponentesKit;
                          this.formRef.current.setFieldsValue({ insumos: insumosActuales });
                          this.forceUpdate();
                        }}
                      />
                    </Tooltip>
                  );
                }

                return (
                  <div className="acciones-container">
                    <Space size={4} style={{ justifyContent: 'center' }}>
                      
                      {this.state.modoReordenar ? (
                        <>
                          <ButtonItem
                            type="primary"
                            size="small"
                            disabled={esPrimero}
                            cyan
                            onClick={() => this.moverInsumo(arrayKey, arrayKey - 1, move)}
                            icon={<ArrowUpOutlined />}
                            lessTime
                          />
                          <ButtonItem
                            type="primary"
                            size="small"
                            disabled={esUltimo}
                            naranja
                            onClick={() => this.moverInsumo(arrayKey, arrayKey + 1, move)}
                            icon={<ArrowDownOutlined />}
                            lessTime
                          />
                        </>
                      ) : (
                        buttons
                      )}

                      {!this.state.xmlSubido && !this.state.insumosObligatoriosLista[arrayKey] && !this.state.insumosNoEliminablesLista[arrayKey] && !(
                        this.state.envioLocalInsumoId &&
                        (arrayValue[arrayKey]?.insumoId?._id || arrayValue[arrayKey]?.insumoId)?.toString() === this.state.envioLocalInsumoId.toString()
                      ) && (
                        <Tooltip title="Eliminar">
                          <ButtonItem
                            rojo2
                            icon={<DeleteOutlined />}
                            onClick={() => this.eliminarInsumo(name, arrayKey, remove)}
                            size="small"
                            lessTime
                          />
                        </Tooltip>
                      )}

                    </Space>
                  </div>
                );
              }}
            </FormItem>
          </td>
        </tr>

        {/* Fila de Hospedaje: solo aparece si el insumo del renglón es el de alguna habitación del
            hotel. Va como renglón aparte y no como columnas nuevas porque la tabla ya está saturada,
            y sería una columna vacía para todos los clientes que no son hoteles. */}
        {this.props.moduloHoteleria && (
          <FormItem noStyle shouldUpdate={(prev, curr) => prev.insumos && curr.insumos && prev.insumos[arrayKey]?.insumoId !== curr.insumos[arrayKey]?.insumoId}>
            {({ getFieldValue }) => {
              const insumoIdFila = getFieldValue(["insumos", arrayKey, "insumoId"]);
              if (!insumoIdFila || !this.state.insumosHospedajeIds.has(String(insumoIdFila))) return null;
              return (
                <tr className="fila-observaciones">
                  <td colSpan={this.props.escuela ? 12 : 11} className="td-border-sin-right">
                    <div style={{ paddingLeft: 25, paddingTop: 4, paddingBottom: 4 }}>
                      <FormItem {...restField} name={[name, "hospedaje"]} noStyle>
                        <FilaHospedajeVenta
                          empresaId={this.props.empresaId}
                          headersToken={this.props.headersToken}
                          habitaciones={this.state.habitacionesHotel}
                          insumoId={insumoIdFila}
                          disabled={this.state.xmlSubido}
                          onNochesChange={(noches) => this.onChangeNochesHospedaje(noches, arrayKey)}
                        />
                      </FormItem>
                    </div>
                  </td>
                </tr>
              );
            }}
          </FormItem>
        )}

        {/* Fila de Leyenda */}
                <FormItem noStyle shouldUpdate={(prev, curr) => prev.insumos && curr.insumos && prev.insumos[arrayKey]?.leyenda !== curr.insumos[arrayKey]?.leyenda}>
                  {({ getFieldValue }) => {
                    let arrayValue = getFieldValue("insumos");
                    if (arrayValue && arrayValue[arrayKey]?.leyenda) {
                      return (
                        <tr className="fila-leyenda">
                          <td colSpan={this.props.escuela ? 12 : 11} className="td-border">
                            <div className="contenedor-leyenda">
                              <div className="texto-leyenda">
                                <b>Leyenda:</b> {arrayValue[arrayKey].leyenda}
                              </div>
                            </div>
                          </td>
                        </tr>
                      );
                    }
                  }}
                </FormItem>

        {/* Fila de Observaciones */}
        <FormItem noStyle shouldUpdate={(prev, curr) => prev.insumos && curr.insumos && (prev.insumos[arrayKey]?.observaciones !== curr.insumos[arrayKey]?.observaciones || prev.insumos[arrayKey]?.observacionesXml !== curr.insumos[arrayKey]?.observacionesXml)}>
          {({ getFieldValue }) => {
            let arrayValue = getFieldValue("insumos");
            if (arrayValue && arrayValue[arrayKey]?.observaciones) {
              return (
                <tr className="fila-observaciones">
                  <td colSpan={this.props.escuela ? 12 : 11} className="td-border-sin-right">
                    <div style={{ display: 'flex', justifyContent: 'left', alignItems: 'left', backgroundColor: arrayValue[arrayKey].observacionesXml ? '#dceeffff' : 'white' }}>
                      <div style={{ width: '100%', textAlign: 'left', paddingLeft: 25, color: "#005661"}}>
                        {String(arrayValue[arrayKey].observaciones)
                          .split(/\r?\n/)
                          .map((line, i) => <span key={i}>{line}<br /></span>)}
                      </div>
                    </div>
                  </td>
                </tr>
              );
            }
          }}
        </FormItem>

        {/* Fila de Insumos del Kit */}
        <FormItem noStyle shouldUpdate={(prev, curr) => prev.insumos && curr.insumos && prev.insumos[arrayKey]?.componentesKit !== curr.insumos[arrayKey]?.componentesKit}>
          {({ getFieldValue }) => {
            let arrayValue = getFieldValue("insumos");
            const componentesKit = arrayValue?.[arrayKey]?.componentesKit;
            if (componentesKit && componentesKit.length > 0) {
              return (
                <tr className="fila-observaciones">
                  <td colSpan={this.props.escuela ? 12 : 11} className="td-border-sin-right">
                    <div style={{ display: 'flex', justifyContent: 'left', alignItems: 'left' }}>
                      <div style={{ width: '100%', textAlign: 'left', paddingLeft: 25, color: "#005661" }}>
                        <b>Insumos del kit:</b> {componentesKit.map(valueComponente => `${valueComponente.descripcion || '-'} (x${valueComponente.cantidad})`).join(", ")}
                      </div>
                    </div>
                  </td>
                </tr>
              );
            }
          }}
        </FormItem>
      </React.Fragment>
    );
  }

  render() {
    const isMobile = window.innerWidth <= 1000;

    const steps = [
      {
        title: 'Agregar Venta',
        description: 'Hola, esta es la pantalla para agregar ventas. Desde aquí podrás generar facturas o remisiones de forma sencilla. También podrás elegir si la venta será de contado o a crédito, asignar un cliente y agregar los productos o servicios. Todo en un mismo lugar para que no pierdas tiempo y tengas el control total de tus operaciones.',
        placement: 'top',
        target: null,
      },
      {
        title: 'Datos Generales',
        description: 'Contiene la información general de la venta: tipo de comprobante (remisión o factura), si es de contado o crédito, datos del cliente y vendedor, así como el proyecto vinculado y la lista de precios aplicada.',
        target: () => this.refGenerales.current, 
      },
      {
        title: 'Tipo de Comprobante',
        description: 'Aquí puedes elegir si es remisión o factura. Si eliges factura, la fecha no se puede modificar.',
        target: () => this.refFactura.current,
      },
      {
        title: 'Forma de Venta',
        description: 'Aquí puedes elegir si es de contado o de crédito, dependiendo de la venta y de tu cliente.',
        target: () => this.refContado.current,
      },
      {
        title: 'Cliente',
        description: 'Aquí se elige el cliente, y también puedes agregar uno nuevo directamente con el botón de "+"',
        target: () => this.refCliente.current,
      },
      {
        title: 'Vendedor',
        description: 'Aquí se selecciona el vendedor. Esta información es útil para futuros reportes y estadísticas.',
        target: () => this.refVendedor.current,
      },
      {
        title: 'Moneda Y Regimen Fiscal',
        description: 'Aquí se eligen los datos de la moneda, como el tipo de cambio y la moneda utilizada para la venta. Al igual si tienes varios regímenes fiscales, puedes elegir el que corresponda.',
        target: () => this.refMoneda.current,
      },
      {
        title: 'Forma de Pago',
        description: 'Estos son los datos sobre el pago de la venta, en caso de que sea de contado.',
        target: () => this.refPago.current,
      },
      ...(this.refCuentasXC.current ? [
        {
          title: 'Enviar a Cuentas por Cobrar',
          description: 'Este switch se utiliza para mandar una venta de contado a cuentas por cobrar. Se recomienda únicamente si la venta se paga dentro del mes. De lo contrario, se tendría que cancelar y volver a realizar.',
          target: () => this.refCuentasXC.current,
        },
      ] : []),
      {
        title: 'Insumos',
        description: 'Aquí agregamos los insumos de la venta, junto con su precio unitario y cantidad, para calcular el total y otros detalles.',
        target: () => this.refInsumos.current,
      },
      {
        title: 'Observaciones',
        description: 'El área de observaciones permite agregar un texto personalizado que se imprimirá en la venta. Asegúrate de activar el check de imprimir para que se incluya en el documento.',
        target: () => this.refObservaciones.current,
      },
      {
        title: 'Totales de la Venta',
        description: 'Aquí puedes ver los totales de la venta. Estos se actualizan automáticamente conforme vayas agregando o modificando los insumos.',
        target: () => this.refTotales.current,
      }
    ];

    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title={this.props.location?.state?.anticipo ? "Agregar Anticipo" : "Agregar Venta"}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={[
            <ButtonItem
              key="tour"
              type="primary"
              style={{ marginTop: 10, marginBottom: 3 }}
              disabled={this.state.loading}
              onClick={() => this.setState({ openTour: true })}
            >
              Tour
            </ButtonItem>
          ]}
        />
        <div className="card-background" style={{ paddingTop: 0 }}>
          <Spin
            spinning={this.state.loading}
            style={{ display: "block", margin: "0 0 0 auto" }}
          >
            <Form
              ref={this.formRef}
              name="agregarVenta"
              layout
              onFinish={(values) => {
                this.setState({ modalConfirmacion: true, valuesForm: values, loadingModal: true })
                axios.post("clientes/informacionCredito", {
                  clienteId: values.clienteId,
                  empresaId: this.props.empresaId
                }, { headers: this.props.headersToken })
                  .then(res => {
                    if (res.data.success === 2) {
                      this.setState({
                        creditoDisponible: res.data.creditoDisponible,
                        loadingModal: false
                      })
                    } else {
                      this.setState({
                        loadingModal: false
                      })
                    }
                  })
              }}
              onFinishFailed={this.onFinishFailed}
              onValuesChange={(changedValues, allValues) => {
                if (this.state.filasConError.length > 0) {
                  this.setState({ filasConError: this.calcularFilasConErrorInventario(allValues.insumos) });
                }
              }}
            >

                  <FormItem
                    noStyle
                    shouldUpdate={(prev, curr) =>
                      prev.insumos?.length !== curr.insumos?.length ||
                      prev.factura !== curr.factura
                    }
                  >
                    {({ getFieldValue }) => {
                      const insumos = getFieldValue("insumos");
                      const factura = getFieldValue("factura");
                      const disabled = insumos && insumos.length > 0 ? true : false;
                      return (
                        <VentasForm
                          showFormaDePago={true}
                          totalPagar={this.state.totalPagar || 0}
                          fecha={this.formRef.current?.getFieldValue("fechaVenta") || this.horaServidor()}
                          onFechaChange={(fecha) => {
                            this.formRef.current.setFieldsValue({
                              fechaVenta: fecha
                            })
                          }}
                          fechaDisabled={factura === 1}
                          showFecha={false}
                          // Visibilidad de secciones opcionales
                          showDoctor={this.props.equipoMedico}
                          showRegimenFiscal={!!this.state.activarRegimenes && this.state.factura === 1}
                          showMoneda={true}
                          datosGeneralesCol={{ xs: 24, sm: 24, md: 24, lg: 18, xl: 18 }}
                          monedaCol={{ xs: 24, sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }}

                          belowDatosGeneralesTitle="VENTA ONLINE"
                          belowDatosGeneralesContent={
                            this.props.ventaOnline ? (
                                <div>
                                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                    <SwitchItem
                                      checked={this.state.marcarVentaOnline}
                                      onChange={(checked) => {
                                        if (checked) {
                                          const proyectoId = this.formRef.current.getFieldValue('proyectoId');
                                          const precioId = this.formRef.current.getFieldValue('precioId');
                                          const clienteId = this.formRef.current.getFieldValue('clienteId');
                                          const monedaId = this.formRef.current.getFieldValue('monedaId');
                                          const insumos = this.formRef.current.getFieldValue('insumos') || [];
                                          if (!proyectoId || !precioId || !clienteId || !monedaId) {
                                            return message.warning('Complete primero los datos principales de la venta (proyecto, lista de precios, cliente y moneda)');
                                          }
                                          if (insumos.length === 0) {
                                            return message.warning('Agregue al menos un insumo antes de marcar la venta como online');
                                          }
                                        }
                                        this.setState({ marcarVentaOnline: checked, deliveryMethod: null });
                                        this.actualizarEnvioPickup(null);
                                        if (checked) {
                                          this.cargarSucursalesEntrega();
                                        }
                                      }}
                                    />
                                    <span>Marcar como Venta Online</span>
                                  </div>
                                  {this.state.marcarVentaOnline && (
                                    <>
                                      <div style={{ fontSize: 12, color: '#1890ff', marginTop: 8 }}>
                                        Esta venta aparecerá en el dashboard de ventas e-commerce.
                                      </div>
                                      {this.state.loadingSucursales ? (
                                        <div style={{ marginTop: 12, textAlign: 'center' }}>
                                          <Spin size="small" />
                                        </div>
                                      ) : !this.state.entregaSucursalActivada && !this.state.entregaLocalActivada ? (
                                        <div style={{ fontSize: 12, color: '#ff4d4f', marginTop: 8 }}>
                                          No se puede marcar como venta online: no hay métodos de entrega configurados (ni recolección en sucursal ni entrega local).
                                        </div>
                                      ) : (
                                        <>
                                          <Radio.Group
                                            style={{ display: 'block', marginTop: 10, marginBottom: 10 }}
                                            value={this.state.deliveryMethod}
                                            onChange={(e) => {
                                              const metodo = e.target.value;
                                              this.setState({ deliveryMethod: metodo });
                                              this.actualizarEnvioPickup(metodo);
                                            }}
                                          >
                                            <Tooltip title={this.state.entregaSucursalActivada ? "El cliente recoge el pedido en una sucursal configurada para la tienda en línea" : "No disponible: la recolección en sucursal no está configurada"}>
                                              <Radio value="pickup" disabled={!this.state.entregaSucursalActivada}>Recolección en sucursal</Radio>
                                            </Tooltip>
                                            <Tooltip title={this.state.entregaLocalActivada ? "Se entrega en la dirección capturada en la pestaña Entrega" : "No disponible: la entrega local no está configurada"}>
                                              <Radio value="local" disabled={!this.state.entregaLocalActivada}>Entrega local</Radio>
                                            </Tooltip>
                                          </Radio.Group>
                                          {this.state.deliveryMethod === 'pickup' && (
                                            <SelectItem
                                              placeholder="Sucursal de recolección"
                                              width="100%"
                                              value={this.state.pickupBranchId}
                                              onChange={(value) => this.setState({ pickupBranchId: value })}
                                              options={this.state.opcionesSucursales}
                                              filterOption={(input, opt) =>
                                                (opt.label ?? '').toString().toLowerCase().includes(input.toLowerCase())
                                              }
                                            />
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                </div>
                            ) : null
                          }

                          datosGeneralesContent={(
                            <div ref={this.refGenerales}>
                            <Row gutter={[16, 8]} align="middle">
                              <Col xs={24} sm={24} md={14} lg={14} ref={this.refCliente}>
                                <div style={{ display: "flex", alignItems: "flex-end", gap: 6 }}>
                                  <FormItem
                                    label="Cliente"
                                    name="clienteId"
                                    required
                                    margin
                                    labelCol={{ span: 4 }}
                                    wrapperCol={{ span: 20 }}
                                    style={{ flex: 1, marginBottom: 0, minWidth: 0 }}
                                  >
                                    <SelectClientesItem
                                      empresaId={this.props.empresaId}
                                      headersToken={this.props.headersToken}
                                      sinBorde
                                      autoFocus
                                      dropdownMatchSelectWidth={600}
                                      width="100%"
                                      placeholder="Cliente"
                                      onChange={(valueId, cliente) => this.onChangeCliente(valueId, cliente)}
                                    />
                                  </FormItem>
                                  <ButtonItem type="primary" icon={<PlusOutlined />} cyan disabled={disabled} onClick={this.abrirAgregarCliente} style={{ marginBottom: 4 }} />
                                </div>
                              </Col>
                            
                                <Col xs={12} sm={10} md={10} lg={10}>

                                    <FormItem
                                        label="Fecha:"
                                        name="fechaVenta"
                                        required
                                        margin
                                        initialValue={moment()}
                                        labelCol={{ span: 8 }}
                                        wrapperCol={{ span: 14 }}
                                    >
                                        {(() => {
                                            const permitirFechaAnterior = factura === 1 && this.state.facturaFechaAnterior;
                                            const fechaMinima = this.horaServidor().subtract(72, "hours");
                                            const fechaMaxima = this.horaServidor();
                                            const rangoHoras = (inicio, fin) => Array.from({ length: Math.max(fin - inicio, 0) }, (_, i) => inicio + i);
                                            return (
                                                <DatePickerItem
                                                    disabled={factura === 1 && !this.state.facturaFechaAnterior}
                                                    showTime={permitirFechaAnterior || undefined}
                                                    dateFormat={permitirFechaAnterior ? "DD/MM/YYYY HH:mm:ss" : "DD/MM/YYYY"}
                                                    disabledDate={permitirFechaAnterior ? (current) => current && (current < fechaMinima.clone().startOf("day") || current > fechaMaxima.clone().endOf("day")) : undefined}
                                                    disabledTime={permitirFechaAnterior ? (current) => {
                                                        if (!current) return {};
                                                        if (current.isSame(fechaMinima, "day")) {
                                                            return {
                                                                disabledHours: () => rangoHoras(0, fechaMinima.hour()),
                                                                disabledMinutes: (hora) => hora === fechaMinima.hour() ? rangoHoras(0, fechaMinima.minute()) : [],
                                                                disabledSeconds: (hora, minuto) => hora === fechaMinima.hour() && minuto === fechaMinima.minute() ? rangoHoras(0, fechaMinima.second()) : [],
                                                            };
                                                        }
                                                        if (current.isSame(fechaMaxima, "day")) {
                                                            return {
                                                                disabledHours: () => rangoHoras(fechaMaxima.hour() + 1, 24),
                                                                disabledMinutes: (hora) => hora === fechaMaxima.hour() ? rangoHoras(fechaMaxima.minute() + 1, 60) : [],
                                                                disabledSeconds: (hora, minuto) => hora === fechaMaxima.hour() && minuto === fechaMaxima.minute() ? rangoHoras(fechaMaxima.second() + 1, 60) : [],
                                                            };
                                                        }
                                                        return {};
                                                    } : undefined}
                                                    placeholder="Fecha de Venta"
                                                    allowClear={false}
                                                />
                                            );
                                        })()}
                                    </FormItem>
                              </Col>
                              
                            </Row>

                            <Row gutter={[16, 8]}>

                              <Col xs={24} sm={24} md={14} lg={14} ref={this.refVendedor}>
                                <FormItem
                                  label="Vendedor"
                                  name="vendedorId"
                                  labelCol={{ span: 4 }}
                                  wrapperCol={{ span: 20 }}
                                  margin
                                  required
                                  initialValue={this.props.usuarioId}
                                >
                                  <SelectItem placeholder="Vendedor" disabled={this.props.permisoBloquearVendedorVenta}>
                                    {this.state.objetoUsuarios}
                                  </SelectItem>
                                </FormItem>
                              </Col>
                             {/* Tipo*/}
                              <Col xs={12} sm={12} md={10} lg={10} ref={this.refFactura}>
                                <FormItem
                                  name="factura"
                                  label="Tipo"
                                  labelCol={{ span: 8 }}
                                  wrapperCol={{ span: 10 }}
                                  initialValue={2}
                                  required
                                  margin
                                >
                                  <SelectItem
                                    disabled={disabled && (this.state.cotizacionesSeleccionadas?.length === 0 && this.state?.pedidosSeleccionados?.length === 0 && this.state?.embarquesSeleccionados?.length === 0 && !this.state.cotizacionId && !this.state.pedidoId && !this.state.embarqueId) && !this.props.location?.state?.duplicar}
                                    value={this.state.factura}
                                    onChange={(value) => {
                                      const clienteId = this.formRef.current.getFieldValue("clienteId");
                                      const cliente = this.state.todasClientes.find(c => c._id === clienteId)
                                      this.formRef.current.setFieldsValue({
                                        fechaVenta: this.horaServidor(),
                                        usoDeCfdiId: cliente?.usoDeCFDIID || undefined
                                      })
                                      const newState = { factura: value };
                                      if (value !== 3 && this.state.quitarImpuestos) {
                                        newState.quitarImpuestos = false;
                                        this.formRef.current.setFieldsValue({ quitarImpuestos: false });
                                      }
                                      //El form conserva los valores de los campos desmontados,
                                      //hay que limpiar la fecha al salir de No Contable
                                      if (value !== 3) {
                                        this.formRef.current.setFieldsValue({ fechaPagoInformativa: undefined });
                                      }
                                      this.setState(newState, () => {
                                        if (value !== 3 && newState.quitarImpuestos === false) {
                                          const insumos = this.formRef.current.getFieldValue("insumos");
                                          if (insumos?.length) this.recalcularInsumosEnBatch(insumos);
                                        }
                                      });
                                    }}
                                  >
                                    <Option value={2}>Remisión</Option>
                                    {this.props.permisoFacturarVentas && this.props.certificada && (
                                    <Option value={1}>Factura</Option>
                                    )}
                                    {this.state.ventasNoContables && (
                                      <Option value={3}>No Contable</Option>
                                    )}
                                </SelectItem>
                                </FormItem>
                              </Col>

                            </Row>
                            <Row gutter={[16, 8]}>

                             {/* Canal */}
                              <Col xs={12} sm={24} md={14} lg={14}>
                                <div style={{ display: 'flex', alignItems: 'baseline', gap: 4 }}>
                                  <div style={{ flex: 1, minWidth: 0 }}>
                                    <FormItem
                                      label="Canal"
                                      name="canalDeVentaId"
                                      labelCol={{ span: 4 }}
                                      wrapperCol={{ span: 20 }}
                                      margin
                                    >
                                      <SelectItem placeholder="Canal de Venta">
                                        {this.state.objetoCanalesVenta}
                                      </SelectItem>
                                    </FormItem>
                                  </div>
                                  <ButtonItem
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={this.abrirAgregarCanal}
                                  />
                                </div>
                              </Col>

                              {/* Método */}
                              <Col xs={12} sm={12} md={10} lg={10} ref={this.refContado}>
                               <FormItem
                                  label="Método"
                                  name="contado"
                                  initialValue={1}
                                  required
                                  margin
                                  disabled={!this.props.permisoVenderCredito}
                                  labelCol={{ span: 8}}
                                  wrapperCol={{ span: 10 }}
                                >
                                  <SelectItem
                                    onChange={this.onChangeContado.bind(this)}
                                  >
                                    <Option value={1}>Contado - PUE</Option>
                                    <Option value={2} disabled={this.props.location?.state?.anticipo}>
                                      Crédito - PPD
                                    </Option>
                                  </SelectItem>
                                </FormItem>
                              </Col>
                            </Row>
                            
                              <FormItem shouldUpdate noStyle>
                                {({ getFieldValue }) => 
                                  getFieldValue("contado") === 3 ? (
                                    <Row gutter={[20, 8]}>
                                      <Col xs={24} sm={12} md={12} lg={10} xl={10}>
                                          <FormItem
                                              required
                                              number
                                              margin
                                              label="Enganche"
                                              name="monto"
                                              type="number"
                                              max={this.state.totalPagar}
                                              labelCol={{ span: 6 }}
                                              wrapperCol={{ span: 18 }}
                                            >
                                              <InputNumberItem
                                                dinero
                                                placeholder="Enganche"
                                                disabled={!this.state.totalPagar}
                                              />
                                            </FormItem>
                                      </Col>
                                    </Row>
                                  ) : null
                                }
                              </FormItem>
                            </div>
                          )}

                          datosVentaContent={
                              <FormItem
                                  noStyle
                                  shouldUpdate={(prev, curr) =>
                                      prev.factura !== curr.factura ||
                                      prev.clienteId !== curr.clienteId
                                  }
                              >
                                  {({ getFieldValue }) => {
                                      const clienteId = getFieldValue("clienteId");
                                      const disabled = !clienteId;
                                      const clienteActual = this.state.todasClientes?.find((c) => c._id === clienteId);
                                      return (
                                          <>
                                          {/* Precio */}
                                            <Col xs={24} sm={24} md={24} lg={24}>
                                              <div style={{ display: "flex", alignItems: "flex-end", gap: 6 }}>
                                                <FormItem
                                                    name="precioId"
                                                    label="Precio"
                                                    margin
                                                    required
                                                    labelCol={{ span: 7 }}
                                                    wrapperCol={{ span: 14 }}
                                                    style={{ flex: 1, marginBottom: 0, minWidth: 0 }}
                                                  >
                                                  <SelectItem
                                                    placeholder={clienteId ? "Precio" : "Elige un cliente primero"}
                                                    disabled={disabled || this.estaBloqueado("listaPrecios")}
                                                    onChange={(value) => this.onChangePrecioId(value)}
                                                  >
                                                    {this.state.objetoPrecios}
                                                  </SelectItem>
                                                </FormItem>
                                                <BotonAutorizacion
                                                  visible={this.props.autorizacionesRapidas && !disabled && this.estaBloqueado("listaPrecios")}
                                                  onClick={() => this.abrirModalAutorizacion("listaPrecios")}
                                                />
                                              </div>
                                            </Col>
                                            {clienteActual?.empresaAlterna?.activo && (
                                            <Col xs={24} sm={24} md={24} lg={24}>
                                              <FormItem
                                                name="usarEmpresaAlterna"
                                                label="Usar Empresa Alterna"
                                                valuePropName="checked"
                                                initialValue={true}
                                                margin
                                                specialLayoutSwitch
                                              >
                                                <SwitchItem />
                                              </FormItem>
                                            </Col>
                                            )}
                                            {this.props.insumosXClienteEmpresa && clienteActual?.insumosXCliente && (
                                            <Col xs={24} sm={24} md={24} lg={24}>
                                              <FormItem
                                                name="usarPrecioCliente"
                                                label="Usar Precios del Cliente"
                                                valuePropName="checked"
                                                initialValue={true}
                                                margin
                                                specialLayoutSwitch
                                              >
                                                <SwitchItem onChange={(checked) => this.onChangeUsarPrecioCliente(checked)} />
                                              </FormItem>
                                            </Col>
                                            )}

                                            {/* Proyecto */}
                                            <Col xs={24} sm={24} md={24} lg={24}>
                                              <FormItem
                                                label="Proyecto"
                                                name="proyectoId"
                                                labelCol={{ span: 7 }}
                                                wrapperCol={{ span: 14 }}
                                                required
                                                margin
                                              >
                                                <SelectItem>{this.state.objetoProyectos}</SelectItem>
                                              </FormItem>
                                            </Col>

                                            {/* Serie personalizada */}
                                            {this.props.complementoSeriesPersonalizadas && this.props.permisoElegirSerieFolioPersonalizado && this.state.todasSeriesVenta.length > 0 && (
                                              <Col xs={24} sm={24} md={24} lg={24}>
                                                <FormItem
                                                  label="Serie"
                                                  name="serieVentaId"
                                                  labelCol={{ span: 7 }}
                                                  wrapperCol={{ span: 14 }}
                                                  margin
                                                >
                                                  <SelectItem placeholder="Selecciona una serie (opcional)" allowClear>
                                                    {this.state.todasSeriesVenta.map((serie) => (
                                                      <Option value={serie._id} key={serie._id}>
                                                        {`${serie.nombre} (${serie.serieFacturas}/${serie.serieRemisiones}) - Sig. Factura: ${serie.folioFacturas ?? 1} / Sig. Remisión: ${serie.folioRemisiones ?? 1}`}
                                                      </Option>
                                                    ))}
                                                  </SelectItem>
                                                </FormItem>
                                              </Col>
                                            )}

                                          </>
                                      );
                                  }}
                              </FormItem>
                          }

                          // Contenido de DATOS DEL CLIENTE
                          datosClienteContent={(
                            <>
                              <Row gutter={[16, 8]}>
                                <Col span={24}>
                                  <FormItem
                                    noStyle
                                    shouldUpdate={(prev, curr) => prev.clienteId !== curr.clienteId}
                                  >
                                    {({ getFieldValue }) => {
                                      const clienteIdActual = getFieldValue('clienteId');
                                      const clienteActual = this.state.todasClientes?.find(c => c._id === clienteIdActual);
                                      const requiereOrdenCompra = clienteActual?.usarAdenda &&
                                        (clienteActual?.adendaActiva === "Viscofan" ||
                                          clienteActual?.adendaActiva === "Lesaffre" ||
                                          clienteActual?.adendaActiva === "Continental" ||
                                          clienteActual?.adendaActiva === "Goodyear");
                                      const esLesaffre = clienteActual?.usarAdenda && clienteActual?.adendaActiva === "Lesaffre";
                                      const esGoodyear = clienteActual?.usarAdenda && clienteActual?.adendaActiva === "Goodyear";
                                      return (
                                        <FormItem
                                          name="ordenDeCompra"
                                          label="O Compra"
                                          pattern
                                          margin
                                          labelCol={{ span: 8 }}
                                          wrapperCol={{ span: 14 }}
                                          required={esLesaffre || esGoodyear}
                                          tooltip={requiereOrdenCompra ? "La Orden de Compra es usada para esta adenda" : undefined}
                                        >
                                          <InputItem placeholder="Orden de Compra" />
                                        </FormItem>
                                      );
                                    }}
                                  </FormItem>
                                </Col>

                                <Col span={24}>
                                  <FormItem
                                    name="req"
                                    label="Req"
                                    pattern
                                    margin
                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 14 }}
                                  >
                                    <InputItem placeholder="Requisición" />
                                  </FormItem>
                                </Col>

                                <Col span={24}>
                                  <FormItem
                                    noStyle
                                    shouldUpdate={(prev, curr) => prev.clienteId !== curr.clienteId}
                                  >
                                    {({ getFieldValue }) => {
                                      const clienteIdActual = getFieldValue('clienteId');
                                      const clienteActual = this.state.todasClientes?.find(c => c._id === clienteIdActual);
                                      const esContinental = clienteActual?.usarAdenda && clienteActual?.adendaActiva === "Continental";
                                      return (
                                        <FormItem
                                          pattern
                                          name="atencion"
                                          label="Atención a"
                                          margin
                                          required={esContinental}
                                          tooltip={esContinental
                                            ? "Se manda como Solicitante en la adenda Continental. Captura el correo del solicitante, ej: comprador@conti.com.mx"
                                            : "Indica a quién dirigir este documento."}
                                          labelCol={{ span: 8 }}
                                          wrapperCol={{ span: 14 }}
                                        >
                                          <InputItem placeholder={esContinental ? "Solicitante, ej: comprador@conti.com.mx" : "Atención a"} />
                                        </FormItem>
                                      );
                                    }}
                                  </FormItem>
                                </Col>
                              </Row>
                            </>
                          )}

                          extrasContent={(
                            <Row gutter={[16, 8]}>
                              <Col span={24}>
                                <FormItem
                                  name="fechaEntregaEstimada"
                                  label="F. Entrega Est."
                                  margin
                                  labelCol={{ span: 8 }}
                                  wrapperCol={{ span: 14 }}
                                >
                                  <DatePickerItem placeholder="Fecha de entrega estimada" />
                                </FormItem>
                              </Col>
                            </Row>
                          )}

                          // Contenido de DOCTOR
                          doctorContent={this.props.equipoMedico ? (
                            <>
                                <Row gutter={[16, 8]}>

                                {/* DOCTOR */}
                                <Col xs={24} sm={24} md={20} lg={20}>
                                    <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'baseline',
                                        gap: 4,
                                        flexWrap: 'wrap'
                                    }}
                                    >
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <FormItem
                                        name="doctorId"
                                        label="Doctor:"
                                        labelCol={{ span: 8 }}
                                        wrapperCol={{ span: 16 }}
                                        margin
                                        required={this.state.docObligatorio}
                                        >
                                        <SelectItem placeholder="Doctor">
                                            {this.state.objetoDoctores}
                                        </SelectItem>
                                        </FormItem>
                                    </div>

                                    <ButtonItem
                                        type="primary"
                                        icon={<PlusOutlined />}
                                        style={{ flexShrink: 0, height: 32 }}
                                        disabled={disabled} 
                                        onClick={this.abrirAgregarDoctor.bind(this)}
                                    />
                                    </div>
                                </Col>

                                {/* PACIENTE */}
                                <Col xs={24} sm={24} md={20} lg={20}>
                                    <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'baseline',
                                        gap: 4,
                                        flexWrap: 'wrap'
                                    }}
                                    >
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <FormItem
                                        name="pacienteId"
                                        label="Paciente:"
                                        labelCol={{ span: 8 }}
                                        wrapperCol={{ span: 16 }}
                                        margin
                                        >
                                        <SelectItem placeholder="Paciente">
                                            {this.state.objetoPacientes}
                                        </SelectItem>
                                        </FormItem>
                                    </div>

                                    <ButtonItem
                                        type="primary"
                                        icon={<PlusOutlined />}
                                        style={{ flexShrink: 0, height: 32 }}
                                        disabled={disabled} 
                                        onClick={this.abrirAgregarPaciente.bind(this)}
                                    />
                                    </div>
                                </Col>

                                {/* CIRUGÍA */}
                                <Col xs={24} sm={24} md={20} lg={20}>
                                    <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'baseline',
                                        gap: 4,
                                        flexWrap: 'wrap'
                                    }}
                                    >
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <FormItem
                                        name="cirugiaId"
                                        label="Cirugía:"
                                        labelCol={{ span: 8 }}
                                        wrapperCol={{ span: 16 }}
                                        margin
                                        >
                                        <SelectItem placeholder="Cirugia">
                                            {this.state.objetoCirugias}
                                        </SelectItem>
                                        </FormItem>
                                    </div>

                                    <ButtonItem
                                        type="primary"
                                        icon={<PlusOutlined />}
                                        style={{ flexShrink: 0, height: 32 }}
                                        onClick={this.abrirAgregarCirugia.bind(this)}
                                        disabled={disabled}
                                    />
                                    </div>
                                </Col>

                                </Row>
                            </>
                            ) : null}

                          // Contenido de REGIMEN FISCAL
                          regimenFiscalContent={(
                            <FormItem
                              name="regimenFiscalId"
                              margin
                              label="Régimen F."
                              required
                              labelCol={{ span: 6}}
                              wrapperCol={{ span: 18 }}
                            >
                              <SelectItem placeholder="Regimen Fiscal">
                                {this.state.objetoRegimenFiscal}
                              </SelectItem>
                            </FormItem>
                          )}

                          // Contenido de MONEDA - Tipo de Cambio DEBAJO
                          monedaContent={(
                            <div ref={this.refMoneda}>
                            <FormItem noStyle shouldUpdate={(prev, curr) => prev.monedaId !== curr.monedaId}>
                              {({ getFieldValue }) => {
                                const monedaId = getFieldValue('monedaId');
                                
                                return (
                                  <>
                                    {/* Moneda */}
                                    <FormItem
                                      required
                                      margin
                                      name="monedaId"
                                      label="Moneda"
                                      initialValue='60c7e4396465ad440c41c15a'
                                      labelCol={{ span: 8 }}
                                      wrapperCol={{ span: 14 }}
                                    >
                                      <SelectItem
                                        onChange={(value) => {
                                          if (value === '60c7e4396465ad440c41c15a') {
                                            this.formRef.current.setFieldsValue({ tipoDeCambio: 1 })
                                          } else {
                                            this.onChangeMoneda(value)
                                          }
                                        }}
                                        placeholder="Moneda"
                                      >
                                        {this.state.objetoMonedas}
                                      </SelectItem>
                                    </FormItem>

                                    {/* Tipo de Cambio - Solo si NO es MXN */}
                                    {monedaId !== '60c7e4396465ad440c41c15a' ? ( // ID de moneda MXN
                                      <FormItem
                                        required
                                        number
                                        margin
                                        label="T. Cambio"
                                        name="tipoDeCambio"
                                        type="number"
                                        initialValue={1} 
                                        labelCol={{ span: 8 }}
                                        wrapperCol={{ span: 14 }}
                                      >
                                        <InputNumberItem
                                          dinero
                                          placeholder="T. Cambio"
                                        />
                                      </FormItem>
                                    ) : ( // Si es MXN, ocultar el campo y asignar valor 1
                                      <FormItem 
                                        name="tipoDeCambio"
                                        initialValue={1}
                                        hidden 
                                      >
                                        <InputNumberItem />
                                      </FormItem>
                                    )}
                                  </>
                                );
                              }}
                            </FormItem>
                            </div>
                          )}
                          // Contenido de FORMA DE PAGO
                      formaDePagoContent={(   
                            <>
                              <FormItem shouldUpdate noStyle> 
                                {({ getFieldValue }) => {
                                  const contado = getFieldValue("contado");
                                  const factura = getFieldValue("factura");
                                  const cuentasXC = getFieldValue("cuentasXC");

                                 return (
                                  <Row gutter={[6, 4]} ref={this.refPago}>
                                   
                                    <Col span={24}>
                                      <FormItem
                                        name="formaDePagoId"
                                        label="F Pago"
                                        required
                                        margin
                                        labelCol={{ span: 8 }}
                                        wrapperCol={{ span: 14 }}
                                      >
                                        <SelectItem
                                          disabled={contado !== 1 || this.state.xmlSubido}
                                          placeholder="Forma de Pago"
                                        >
                                          {this.state.objetoFormasDePago}
                                        </SelectItem>
                                      </FormItem>
                                    </Col>

                                    {/* Uso CFDI */}
                                    {factura === 1 && (
                                      <Col span={24}>
                                        <FormItem
                                          name="usoDeCfdiId"
                                          label="Uso CFDI"
                                          required
                                          margin
                                          labelCol={{ span: 8 }}
                                          wrapperCol={{ span: 14 }}
                                        >
                                          <SelectItem
                                            disabled={this.state.xmlSubido}
                                            placeholder="Uso de CFDI"
                                          >
                                            {this.state.objetoUsosDeCFDI}
                                          </SelectItem>
                                        </FormItem>
                                      </Col>
                                    )}

                                    {/* Días de crédito */}
                                    {contado !== 1 && (
                                      <Col span={24}>
                                        <FormItem
                                          label="Días de crédito"
                                          name="diasCredito"
                                          numberCero
                                          margin
                                          required
                                          initialValue={0}
                                          labelCol={{ span: 8 }}
                                          wrapperCol={{ span: 14 }}
                                        >
                                          <InputNumberItem placeholder="Días de Crédito" />
                                        </FormItem>
                                      </Col>
                                    )}
                                    
                                    {/* Cuentas XC */}
                                    {(contado === 1 || contado === 3) && !this.state.desactivarBtnCXC &&
                                        <Col span={24} ref={this.refCuentasXC}>
                                          <FormItem
                                            label="Cuentas XC"
                                            name="cuentasXC"
                                            initialValue={false}
                                            valuePropName="checked"
                                            labelCol={{ span: 8 }}
                                            wrapperCol={{ span: 12 }}
                                            margin
                                          >
                                            <SwitchItem />
                                          </FormItem>
                                        </Col>
                                    }

                                    {/* Banco - Solo mostrar si NO está activado cuentasXC */}
                                    {(contado === 1 || contado === 3) && !cuentasXC ? (
                                      <Col span={24}>
                                        <FormItem
                                          required
                                          name="bancoId"
                                          label="Banco"
                                          margin
                                          labelCol={{ span: 8 }}
                                          wrapperCol={{ span: 14 }}
                                        >
                                          <SelectItem placeholder="Banco">
                                            {this.state.objetoBancos}
                                          </SelectItem>
                                        </FormItem>
                                      </Col>
                                    ) : (
                                      <FormItem name="bancoId" hidden>
                                        <InputItem />
                                      </FormItem>
                                    )}

                                    {/* Fecha de pago informativa - Solo en ventas No Contables.
                                        Va fuera del bloque de Banco para que tambien se vea a credito */}
                                    {this.state.factura === 3 && (
                                      <Col span={24}>
                                        <FormItem
                                          name="fechaPagoInformativa"
                                          label="Fecha Pago"
                                          margin
                                          labelCol={{ span: 8 }}
                                          wrapperCol={{ span: 14 }}
                                          tooltip="Fecha de pago informativa, no genera movimientos contables ni de cobranza"
                                        >
                                          <DatePickerItem
                                            placeholder="Fecha Pago"
                                            style={{ width: "100%" }}
                                          />
                                        </FormItem>
                                      </Col>
                                    )}

                                  </Row>
                                 );
                                }}
                              </FormItem>
                            </>
                          )}

                          // Tabs (Insumos, Entrega, Envío, CFDIs Relacionados)
                          tabs={[
                            {
                              key: "insumos",
                              label: "Insumos",
                              ref: this.refInsumos,
                              listName: "insumos",
                              columns: this.getInsumosColumns(),
                              renderRow: this.renderInsumoRow.bind(this),
                              renderFooter: ({ add, fields }) => {
                                // Guardar la función add en el ref para usarla desde el botón
                                this.addInsumoRef = add;

                                return (
                                  <FormItem
                                    noStyle
                                    shouldUpdate={(prev, curr) =>
                                      prev.proyectoId !== curr.proyectoId ||
                                      prev.precioId !== curr.precioId ||
                                      prev.clienteId !== curr.clienteId ||
                                      prev.monedaId !== curr.monedaId ||
                                      prev.tipoDeCambio !== curr.tipoDeCambio
                                    }
                                  >
                                    {({ getFieldValue }) => {
                                      const proyectoId = getFieldValue('proyectoId');
                                      const precioId = getFieldValue('precioId');
                                      const clienteId = getFieldValue('clienteId');
                                      const monedaId = getFieldValue('monedaId');
                                      const tipoDeCambio = getFieldValue('tipoDeCambio');

                                      // Validación de campos base
                                      const moneda = this.state.todasMonedas?.find(m => m._id === monedaId);
                                      const esMXN = moneda && (moneda.nombre === 'MXN' || moneda.nombre === 'Peso Mexicano' || moneda.clave === 'MXN');

                                      const datosBaseListos =
                                        proyectoId && precioId && clienteId && monedaId && (esMXN || tipoDeCambio);

                                      return (
                                        <div style={{ marginBottom: 6, marginTop: 6 }}>
                                          <Space>
                                            <ButtonItem
                                              type="primary"
                                              loading={false}
                                              cyan
                                              style={{
                                                  marginTop: 10,
                                                  marginBottom: 10,
                                                  justifySelf: fields.length > 0 ? "left" : null,
                                                  width: fields.length > 0 ? "auto" : null,
                                              }}
                                              disabled={this.state.xmlSubido}
                                              hotkey="alt+a"
                                              onClick={
                                                datosBaseListos
                                                  ? () => {
                                                      if (this.state.cantidadDefault) {
                                                        add({ cantidad: 1 });
                                                      } else {
                                                        add();
                                                      }
                                                    }
                                                  : () =>
                                                      message.info(
                                                        "Agregue los datos de venta primero"
                                                      )
                                              }
                                              block
                                              icon={<PlusOutlined />}
                                            >
                                              Agregar Insumo
                                            </ButtonItem>
                                            <ButtonItem
                                              style={{ marginTop: 10, marginBottom: 10 }}
                                              disabled={this.state.xmlSubido || this.state.loadingLista}
                                              icon={<SearchOutlined />}
                                              hotkey="alt+b"
                                              onClick={
                                                datosBaseListos
                                                  ? this.abrirBusquedaAvanzada
                                                  : () =>
                                                      message.info(
                                                        "Agregue los datos de venta primero"
                                                      )
                                              }
                                            >
                                              Búsqueda avanzada
                                            </ButtonItem>
                                            {!this.props
                                              .desactivarCargaExcelInsumosVentas && (
                                              <ButtonItem
                                                style={{ marginTop: 10, marginBottom: 10 }}
                                                disabled={this.state.xmlSubido}
                                                icon={<FileExcelOutlined />}
                                                onClick={
                                                  datosBaseListos
                                                    ? () => this.setState({ modalCargarExcelVisible: true })
                                                    : () =>
                                                        message.info(
                                                          "Agregue los datos de venta primero"
                                                        )
                                                }
                                              >
                                                Cargar Excel
                                              </ButtonItem>
                                            )}
                                          </Space>
                                        </div>
                                      );
                                    }}
                                  </FormItem>
                                );
                              },
                              renderHeader: () => (
                                <FormItem noStyle shouldUpdate>
                                  {({ getFieldValue }) => {
                                    const proyectoId = getFieldValue('proyectoId');
                                    const precioId = getFieldValue('precioId');
                                    const clienteId = getFieldValue('clienteId');
                                    const insumosActuales = getFieldValue('insumos') || [];
                                    return (
                                      <div style={{ flex: 1, minWidth: 0 }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                          {this.props.escuela && (
                                            <div style={{ flex: 1, minWidth: 0 }}>
                                              <SelectListasEscuelaItem
                                                empresaId={this.props.empresaId}
                                                headersToken={this.props.headersToken}
                                                placeholder="Cargar insumos de una lista escolar"
                                                disabled={this.state.xmlSubido || this.state.loadingLista || !(proyectoId && precioId && clienteId)}
                                                onChange={(idLista) => idLista && this.agregarInsumosDeListaEscolar(idLista)}
                                              />
                                            </div>
                                          )}
                                          {this.props.escuela && insumosActuales.length > 0 && (
                                            <Tooltip title="Borrar lista y observaciones">
                                              <ButtonItem
                                                icon={<ClearOutlined />}
                                                size="small"
                                                disabled={this.state.loadingLista}
                                                onClick={this.limpiarLista}
                                                style={{ height: 24, width: 24, minWidth: 24, padding: 0}}
                                                naranja
                                              />
                                            </Tooltip>
                                          )}
                                          <Tooltip title="Limpiar insumos">
                                            <ButtonItem
                                              icon={<DeleteOutlined />}
                                              danger
                                              size="small"
                                              disabled={insumosActuales.length === 0}
                                              onClick={this.limpiarInsumosLista}
                                              style={{ height: 24, width: 24, minWidth: 24, padding: 0, marginRight: 5 }}
                                            />
                                          </Tooltip>
                                        </div>
                                        {this.state.loadingLista && (
                                          <Progress
                                            percent={this.state.progresoLista}
                                            size="small"
                                            status="active"
                                            style={{ marginTop: 6, marginBottom: 0 }}
                                            showInfo={false}
                                            strokeColor="#00BFD6"
                                          />
                                        )}
                                      </div>
                                    );
                                  }}
                                </FormItem>
                              ),
                            },
                            {
                              key: "entrega",
                              label: "Entrega",
                              forceRender: true,
                              customContent: (
                                <>
                                  <TabEntregaDireccion
                                    key={`direccion-${this.state.direccionesCliente?.[0]?._id || 'no-cliente'}`}
                                    loadingEntrega={this.state.loadingEntrega}
                                    clienteDireccion={this.state.direccionesCliente?.[0]}
                                    objetoDireccionesCliente={this.state.objetoDireccionesCliente}
                                    handleChangeDireccionEntrega={this.handleChangeDireccionEntrega.bind(this)}
                                    onDireccionChange={this.handleDireccionEntregaChange.bind(this)}
                                    formInstance={this.formRef.current}
                                    addendaMabe={this.state.addendaMabe}
                                    addendaViscofan={this.state.addendaViscofan}
                                    loadingPlantasEntrega={this.state.loadingPlantasEntrega}
                                    objetoPlantasEntrega={this.state.objetoPlantasEntrega}
                                    onSearchPlantaEntrega={this.onSearchPlantaEntrega.bind(this)}
                                    objetoColonias={this.state.objetoColonias}
                                    onSearchColonia={this.onSearchColonia.bind(this)}
                                    onSelectColoniaId={this.onSelectColoniaId.bind(this)}
                                    objetoMunicipios={this.state.objetoMunicipios}
                                    onChangeMunicipio={this.onChangeMunicipio.bind(this)}
                                    objetoEstados={this.state.objetoEstados}
                                    onChangeEstado={this.onChangeEstado.bind(this)}
                                    objetoPaises={this.state.objetoPaises}
                                  />
                                </>
                              )
                            },
                            this.state.flete && this.props.fletes ? {
                              key: "envio",
                              label: "Envío",
                              forceRender: true,
                              customContent: (
                                <TabEnvio
                                  editarMercanciasEnvio={this.editarMercanciasEnvio.bind(this)}
                                  editarUbicacionesEnvio={this.editarUbicacionesEnvio.bind(this)}
                                  ubicacionesEnvio={this.state.ubicacionesEnvio}
                                  mercanciasEnvio={this.state.mercanciasEnvio}
                                  formRefGeneral={this.formRef}
                                  todasClientes={this.state.todasClientes}
                                />
                              )
                            } : null,
                            this.state.factura === 1 ? {
                              key: "cfdi-relacionados",
                              label: "CFDIs Relacionados",
                              forceRender: true,
                              customContent: (
                                <TabRelaciones />
                              )
                            } : null,
                            (this.state.usarLeyendasFiscales && this.state.factura === 1) ? {
                              key: "leyendas-fiscales",
                              label: "Leyendas Fiscales",
                              // forceRender es obligatorio: sin el, si el usuario no abre la
                              // pestaña antd no manda los valores del Form.List en el submit.
                              forceRender: true,
                              customContent: (
                                <FormListLeyendasFiscales mostrarAviso />
                              )
                            } : null,
                            (this.state.complementoDetallista && this.props.complementoDetallista && this.state.factura === 1) ? {
                              key: "detallista",
                              label: "Detallista",
                              forceRender: true,
                              customContent: (
                                <>
                                  {this.state?.detallista?.orderIdentification &&
                                    <FormItem
                                      name="orderIdentification"
                                      label="OrderIdentification"
                                      margin
                                      labelCol={{ span: 6 }}
                                      wrapperCol={{ span: 18 }}
                                      required
                                    >
                                      <InputItem placeholder="OrderIdentification" />
                                    </FormItem>
                                  }
                                  {this.state?.detallista?.referenceDateOrderIdentification &&
                                    <FormItem
                                      name="referenceDateOrderIdentification"
                                      label="ReferenceDateOrderIdentification"
                                      margin
                                      labelCol={{ span: 6 }}
                                      wrapperCol={{ span: 18 }}
                                      required
                                    >
                                      <DatePickerItem placeholder="ReferenceDateOrderIdentification" />
                                    </FormItem>
                                  }
                                  {this.state?.detallista?.additionalInformation &&
                                    <FormItem
                                      name="typeAdditionalInformation"
                                      label="TypeAdditionalInformation"
                                      margin
                                      labelCol={{ span: 6 }}
                                      wrapperCol={{ span: 18 }}
                                      required
                                    >
                                      <SelectItem
                                        placeholder="Type - AdditionalInformation"
                                      >
                                        <Option value="AAE">AAE - Cuenta predial</Option>
                                        <Option value="CK">CK - Número de cheque</Option>
                                        <Option value="ACE">ACE - Numero de documento(Remisión)</Option>
                                        <Option value="ATZ">ATZ - Número de aprobación.</Option>
                                        <Option value="AWR">AWR - Numero de documento que  se reemplaza</Option>
                                        <Option value="ON">ON - Número de pedido (comprador)</Option>
                                        <Option value="DQ">DQ - Folio de recibo de mercancías</Option>
                                        <Option value="IV">IV - Número de Factura</Option>
                                      </SelectItem>
                                    </FormItem>
                                  }
                                  {this.state?.detallista?.additionalInformation &&
                                    <FormItem
                                      name="referenceIdentificationAdditionalInformation"
                                      label="ReferenceIdentification"
                                      margin
                                      labelCol={{ span: 6 }}
                                      wrapperCol={{ span: 18 }}
                                      required
                                    >
                                      <InputItem placeholder="ReferenceIdentification - AdditionalInformation" />
                                    </FormItem>
                                  }
                                  {this.state?.detallista?.deliveryNote &&
                                    <FormItem
                                      name="deliveryNote"
                                      label="DeliveryNote"
                                      margin
                                      labelCol={{ span: 6 }}
                                      wrapperCol={{ span: 18 }}
                                      required
                                    >
                                      <InputItem placeholder="DeliveryNote" />
                                    </FormItem>
                                  }
                                  {this.state?.detallista?.referenceDateDeliveryNote &&
                                    <FormItem
                                      name="referenceDateDeliveryNote"
                                      label="ReferenceDateDeliveryNote"
                                      margin
                                      labelCol={{ span: 6 }}
                                      wrapperCol={{ span: 18 }}
                                      required
                                    >
                                      <DatePickerItem placeholder="ReferenceDateDeliveryNote" />
                                    </FormItem>
                                  }
                                </>
                              )
                            } : null,
                            (this.props.anticipos && !this.props.location?.state?.anticipo) ? {
                              key: "anticipos",
                              label: "Anticipos",
                              forceRender: true,
                              customContent: (
                                <TabAnticipos totalVenta={this.state.totalPagar || 0} />
                              )
                            } : null,
                            (this.state.complementoComercioExterior) ? {
                              key: "comercio-exterior",
                              label: "Comercio Exterior",
                              forceRender: true,
                              customContent: (
                                <>
                                  <FormItem
                                    name={["comercioExterior", "activar"]}
                                    label="Activar Comercio Exterior"
                                    margin
                                    labelCol={{ span: 6 }}
                                    wrapperCol={{ span: 18 }}
                                    valuePropName="checked"
                                  >
                                    <SwitchItem />
                                  </FormItem>
                                  <FormItem
                                    name="exportacion"
                                    label="Exportacion"
                                    margin
                                    labelCol={{ span: 6 }}
                                    wrapperCol={{ span: 18 }}
                                  >
                                    <SelectItem
                                      placeholder="Exportacion"
                                    >
                                      <Option value="01">01 - No aplica</Option>
                                      <Option value="02">02 - Definitiva</Option>
                                      <Option value="03">03 - Temporal</Option>
                                      <Option value="04">02 - Definitiva con clave distinta a A1 o cuando no existe enajenación en términos del CFF</Option>
                                    </SelectItem>
                                  </FormItem>
                                  <FormItem
                                    name={["comercioExterior", "certificadoOrigen"]}
                                    label="Certificado Origen"
                                    margin
                                    labelCol={{ span: 6 }}
                                    wrapperCol={{ span: 18 }}
                                  >
                                    <SelectItem
                                      placeholder="Certificado Origen"
                                    >
                                      <Option value={1}>1 - SI</Option>
                                      <Option value={0}>0 - NO</Option>
                                    </SelectItem>
                                  </FormItem>
                                  <FormItem shouldUpdate={(prev, curr) => prev.comercioExterior?.certificadoOrigen !== curr.comercioExterior?.certificadoOrigen} noStyle>
                                    {({ getFieldValue }) => {
                                      const certificadoOrigen = getFieldValue(['comercioExterior', 'certificadoOrigen']);
                                      return certificadoOrigen === 1 ?
                                        (
                                          <FormItem
                                            name={["comercioExterior", "numCertificadoOrigen"]}
                                            label="Número Certificado Origen"
                                            margin
                                            labelCol={{ span: 6 }}
                                            wrapperCol={{ span: 18 }}
                                          >
                                            <InputItem placeholder="Número Certificado Origen" />
                                          </FormItem>
                                        )
                                        : null;
                                    }}
                                  </FormItem>
                                  <FormItem
                                    name={["comercioExterior", "clavePedimentoId"]}
                                    label="Clave De Pedimento"
                                    margin
                                    labelCol={{ span: 6 }}
                                    wrapperCol={{ span: 18 }}
                                  >
                                    <SelectClavePedimentoItem
                                      empresaId={this.props.empresaId}
                                      headersToken={this.props.headersToken}
                                      sinBorde
                                      autoFocus
                                      dropdownMatchSelectWidth={600}
                                      width="100%"
                                      placeholder="Clave de Pedimento"
                                    />
                                  </FormItem>
                                  <FormItem
                                    name={["comercioExterior", "incoTermId"]}
                                    label="IncoTerm"
                                    margin
                                    labelCol={{ span: 6 }}
                                    wrapperCol={{ span: 18 }}
                                  >
                                    <SelectIncoTermsItem
                                      empresaId={this.props.empresaId}
                                      headersToken={this.props.headersToken}
                                      sinBorde
                                      autoFocus
                                      dropdownMatchSelectWidth={600}
                                      width="100%"
                                      placeholder="Inco Term"
                                    />
                                  </FormItem>
                                  <FormItem
                                    number
                                    margin
                                    label="T. Cambio USD"
                                    name={["comercioExterior", "tipoDeCambioUSD"]}
                                    type="number"
                                    labelCol={{ span: 6 }}
                                    wrapperCol={{ span: 18 }}
                                  >
                                    <InputNumberItem
                                      dinero
                                      onFocus={(e) => {
                                        const comercioExterior = this.formRef.current.getFieldValue('comercioExterior') || {};
                                        if (!comercioExterior.tipoDeCambioUSD || comercioExterior.tipoDeCambioUSD === 0) {
                                          this.obtenerTipoCambioUSDCO();
                                        }
                                      }}
                                      placeholder="T. Cambio USD"
                                    />
                                  </FormItem>
                                  <FormItem
                                    name={["comercioExterior", "observaciones"]}
                                    label="Observaciones"
                                    margin
                                    labelCol={{ span: 6 }}
                                    wrapperCol={{ span: 18 }}
                                  >
                                    <InputItem placeholder="Observaciones" />
                                  </FormItem>
                                </>
                              )
                            } : null
                          ].filter(Boolean)}
                          defaultActiveKey="insumos"
                          onTabChange={(key) => {
                            if (key === 'envio') {
                              const insumos = this.formRef.current.getFieldValue('insumos')
                              let flete = false
                              for (const insumo of insumos) {
                                const insumoO = this.state.todasInsumos.find(valueTI => valueTI._id.toString() === insumo?.insumoId?.toString())
                                flete = flete || !!insumoO?.flete
                              }

                              if (!flete) {
                                return this.setState({ flete: false })
                              }
                            }

                            if (key === "entrega") {
                              this.consultarInformacionEntrega()
                            }

                            return this.setState({ activeTabKey: key })
                          }}
                          isMobile={isMobile}
                          formInstance={this.formRef.current}
                          tableClassName="tabla-insumos-agregar-venta"

                          // Observaciones y Totales
                          observacionesConfig={(() => {
                            const config = this.getObservacionesConfig();
                            return {
                              ...config,
                              ref: this.refObservaciones,
                              totales: (
                                <FormItem shouldUpdate noStyle>
                                  {({ getFieldValue }) => {
                                    let arrayInsumos = getFieldValue("insumos") || [];
                                    let arrayRetenciones = [];
                                    let cuentasCliente = 0;
                                    let subtotal = 0;
                                    let arrayImpuestos = [];
                                    let total = 0;
                                    arrayInsumos.forEach((value) => {
                                      if (value) {
                                        if (
                                          value.subtotal &&
                                          value.total &&
                                          value.arrayImpuestos
                                        ) {
                                          subtotal += value.subtotal;
                                          total += value.subtotal;
                                          value.arrayImpuestos.forEach((valueImpuestos) => {
                                            let index = arrayImpuestos.findIndex(
                                              (valueImpuestosAnterios) =>
                                                valueImpuestosAnterios.descripcionFactura ===
                                                valueImpuestos.descripcionFactura
                                                &&
                                                valueImpuestosAnterios.tasaCuota ===
                                                valueImpuestos.tasaCuota
                                                &&
                                                valueImpuestosAnterios.impuesto ===
                                                valueImpuestos.impuesto
                                            );
                                            if (index !== -1) {
                                              let newItem = {
                                                totalImpuestos:
                                                  arrayImpuestos[index].totalImpuestos +
                                                  valueImpuestos.totalImpuestos,
                                                baseImpuesto:
                                                  arrayImpuestos[index].baseImpuesto +
                                                  valueImpuestos.baseImpuesto,
                                                descripcionFactura:
                                                  valueImpuestos.descripcionFactura,
                                                tasaCuota:
                                                  valueImpuestos.tasaCuota,
                                                impuesto:
                                                  valueImpuestos.impuesto,
                                                montoImpuesto:
                                                  valueImpuestos.montoImpuesto,
                                                local: valueImpuestos.local,
                                              };
                                              arrayImpuestos.splice(index, 1, newItem);
                                            } else {
                                              arrayImpuestos.push({
                                                tasaCuota: valueImpuestos.tasaCuota,
                                                impuesto: valueImpuestos.impuesto,
                                                local: valueImpuestos.local,
                                                montoImpuesto: valueImpuestos.montoImpuesto,
                                                baseImpuesto: valueImpuestos.baseImpuesto,
                                                descripcionFactura: valueImpuestos.descripcionFactura,
                                                totalImpuestos: valueImpuestos.totalImpuestos,
                                              });
                                            }
                                          });
                                          if (value.arrayRetenciones) {
                                            value.arrayRetenciones.forEach((valueRetenciones) => {
                                              let index = arrayRetenciones.findIndex(
                                                (valueRetencionesAnterios) =>
                                                  valueRetencionesAnterios.descripcionFactura ===
                                                  valueRetenciones.descripcionFactura
                                                  &&
                                                  valueRetencionesAnterios.tasaCuota ===
                                                  valueRetenciones.tasaCuota
                                                  &&
                                                  valueRetencionesAnterios.impuesto ===
                                                  valueRetenciones.impuesto
                                              );
                                              cuentasCliente += round2Decimals(valueRetenciones.totalRetenciones);
                                              if (index !== -1) {
                                                let newItem = {
                                                  totalRetenciones:
                                                    arrayRetenciones[index].totalRetenciones +
                                                    valueRetenciones.totalRetenciones,
                                                  baseRetencion:
                                                    arrayRetenciones[index].baseRetencion +
                                                    valueRetenciones.baseRetencion,
                                                  descripcionFactura:
                                                    valueRetenciones.descripcionFactura,
                                                  tasaCuota:
                                                    valueRetenciones.tasaCuota,
                                                  impuesto:
                                                    valueRetenciones.impuesto,
                                                  montoRetencion:
                                                    valueRetenciones.montoRetencion,
                                                  local: valueRetenciones.local,
                                                };
                                                arrayRetenciones.splice(index, 1, newItem);
                                              } else {
                                                arrayRetenciones.push({
                                                  tasaCuota: valueRetenciones.tasaCuota,
                                                  impuesto: valueRetenciones.impuesto,
                                                  montoRetencion: valueRetenciones.montoRetencion,
                                                  local: valueRetenciones.local,
                                                  baseRetencion: valueRetenciones.baseRetencion,
                                                  descripcionFactura: valueRetenciones.descripcionFactura,
                                                  totalRetenciones: valueRetenciones.totalRetenciones,
                                                });
                                              }
                                            });
                                          }
                                        }
                                      }
                                    });
                                    arrayImpuestos = arrayImpuestos.map(valueImpuesto => {
                                      total += round2Decimals(valueImpuesto.totalImpuestos)
                                      return {
                                        ...valueImpuesto,
                                        totalImpuestos: round2Decimals(valueImpuesto.totalImpuestos),
                                      }
                                    })
                                    if (this.state.totalPagar !== (total - cuentasCliente)) {
                                      setTimeout(() => this.setState({ totalPagar: (total - cuentasCliente) }), 0);
                                    }
                                    
                                    // Retornar el objeto que VentasForm espera
                                    const totalesData = {
                                      subtotal: dineroDisabledMask(subtotal),
                                      total: dineroDisabledMask(total),
                                      totalPagar: dineroDisabledMask(total - cuentasCliente),
                                      impuestos: arrayImpuestos.map((valueArray) => ({
                                        descripcion: valueArray.descripcionFactura,
                                        total: dineroDisabledMask(valueArray.totalImpuestos)
                                      })),
                                      retenciones: arrayRetenciones.map((value) => ({
                                        descripcion: value.descripcionFactura,
                                        total: dineroDisabledMask(value.totalRetenciones)
                                      }))
                                    };
                                    
                                    // Renderizar la tabla de totales
                                    return (
                                      <div ref={this.refTotales}>
                                      <table className="table" style={{ marginTop: 0, fontSize: "16px" }}>
                                        <tbody>
                                          <tr>
                                            <th className="th-totales" style={{ width: "50%", fontSize: "16px" }}>
                                              Total Insumos
                                            </th>
                                            <td className="td-totales-right" style={{ width: "50%", fontSize: "16px" }}>
                                              {arrayInsumos.reduce((suma, it) => suma + (Number(it?.cantidad) || 0), 0)}
                                            </td>
                                          </tr>
                                        </tbody>

                                        <tbody>
                                          <tr>
                                            <th className="th-totales" style={{ width: "50%", fontSize: "16px" }}>
                                              Subtotal
                                            </th>
                                            <td className="td-totales-right" style={{ width: "50%", fontSize: "16px" }}>
                                              {totalesData.subtotal}
                                            </td>
                                          </tr>
                                        </tbody>

                                        {totalesData.impuestos && totalesData.impuestos.map((impuesto, index) => (
                                          <tbody key={index}>
                                            <tr>
                                              <th className="th-totales" style={{ fontSize: "16px" }}>{impuesto.descripcion}</th>
                                              <td className="td-totales-right" style={{ fontSize: "16px" }}>{impuesto.total}</td>
                                            </tr>
                                          </tbody>
                                        ))}

                                        <tbody>
                                          <tr>
                                            <th className="th-totales" style={{ fontSize: "16px" }}>Total</th>
                                            <td className="td-totales-right" style={{ fontSize: "16px" }}>
                                              {totalesData.total}
                                            </td>
                                          </tr>
                                        </tbody>

                                        {totalesData.retenciones && totalesData.retenciones.map((retencion, index) => (
                                          <tbody key={index}>
                                            <tr>
                                              <th className="th-totales" style={{ fontSize: "16px" }}>{retencion.descripcion}</th>
                                              <td className="td-totales-right" style={{ fontSize: "16px" }}>{retencion.total}</td>
                                            </tr>
                                          </tbody>
                                        ))}

                                        <tbody>
                                          <tr>
                                            <th className="th-totales" style={{ fontSize: "17px" }}>Total a Pagar</th>
                                            <td className="td-totales-right" style={{ fontSize: "18px" }}>
                                              {totalesData.totalPagar}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                       </div>
                                    );
                                  }}
                                </FormItem>
                              )
                            };
                          })()}

                          // Botones de acción
                          actionButtons={(
                            
                            <>
                             {this.props.cargarXmlPrevio && (
                                <Upload
                                  showUploadList={{
                                    showRemoveIcon: true,
                                    showPreviewIcon: false,
                                  }}
                                  onRemove={() => {
                                    this.formRef.current.resetFields();
                                    this.formRef.current.setFieldsValue({
                                      insumos: []
                                    });
                                    this.setState({
                                      xmlSubido: false,
                                      archivosXml: [],
                                      cadenaOriginalSAT: null,
                                      noCertificadoSAT: null,
                                      noCertificadoCFDI: null,
                                      uuid: null,
                                      selloSAT: null,
                                      selloCFDI: null,
                                      fechaTimbrado: null,
                                      qrCode: null,
                                      cfdi: null,
                                      folioFIngresada: null,
                                      serieFIngresada: null,
                                      totalFIngresada: null,
                                      subtotalFIngresada: null,
                                    });
                                  }}
                                  fileList={this.state.archivosXml}
                                  customRequest={this.cargarXmlPrevio.bind(this)}
                                  accept=".xml"
                                >
                                  {this.props.permisoXmlPrevio && (
                                    <ButtonItem type="primary" blanco hotkey="shift+x" icon={<IconFileXml />}>
                                      Xml previo
                                    </ButtonItem>
                                  )}
                                </Upload>
                              )}
                              <ButtonItem
                             
                               hotkey="shift+c"
                                type="primary"
                                rojoB
                                onClick={this.atras.bind(this)}
                              >
                                Cancelar
                              </ButtonItem>
                              <ButtonItem
                                type="primary"
                                blanco
                                onClick={this.abrirVistaPrevia.bind(this)}
                              >
                                Vista previa
                              </ButtonItem>
                              {this.props.permisoEntregarInsumosVenta && this.state.embarquesSeleccionados?.length === 0 &&
                                <Tooltip title={Object.keys(this.state.insumosNoEliminablesLista).length > 0 ? "Hay renglones ya entregados desde un pedido — usa '+ Agregar' y entrega el resto después desde Entregar Insumos" : null}>
                                  <span>
                                    <ButtonItem
                                     htmlType="submit"
                                      hotkey="shift+i"
                                      type="primary"
                                      cyanB
                                      disabled={Object.keys(this.state.insumosNoEliminablesLista).length > 0}
                                      onClick={() => this.setState({ entregarInsumos: true, entregarDisponibles: false })}
                                    >
                                     {this.props.location?.state?.anticipo ? "Agregar" : "Agregar y Entregar Insumos"}
                                    </ButtonItem>
                                  </span>
                                </Tooltip>
                              }
                              {this.state.entregarDisponiblesVenta && this.props.permisoEntregarInsumosVenta && this.state.embarquesSeleccionados?.length === 0 && !this.props.location?.state?.anticipo &&
                                <Tooltip title="Guarda la venta y entrega lo que haya en inventario; el resto queda pendiente">
                                  <span>
                                    <ButtonItem
                                      htmlType="submit"
                                      hotkey="shift+d"
                                      type="primary"
                                      azulMB
                                      onClick={() => this.setState({ entregarInsumos: false, agregarSinAfectarInventario: false, entregarDisponibles: true })}
                                    >
                                      Agregar y Entregar Disponibles
                                    </ButtonItem>
                                  </span>
                                </Tooltip>
                              }
                              {!this.props.location?.state?.anticipo &&
                                <ButtonItem
                                  hotkey="shift+a"
                                  htmlType="submit"
                                  type="primary"

                                  verdeB
                                  onClick={() => this.setState({ entregarInsumos: false, entregarDisponibles: false })}
                                >
                                  + Agregar
                                </ButtonItem>
                              }
                              {this.state.xmlSubido && this.state.embarquesSeleccionados?.length === 0 &&
                                <Tooltip title={Object.keys(this.state.insumosNoEliminablesLista).length > 0 ? "Hay renglones ya entregados desde un pedido — usa '+ Agregar' y entrega el resto después desde Entregar Insumos" : null}>
                                  <span>
                                    <ButtonItem
                                     htmlType="submit"
                                      hotkey="shift+s"
                                      type="primary"

                                      cafeB
                                      disabled={Object.keys(this.state.insumosNoEliminablesLista).length > 0}
                                      onClick={() => this.setState({ entregarInsumos: true, agregarSinAfectarInventario: true, entregarDisponibles: false })}
                                    >
                                      Agregar y Entregar Sin Afectar Inventario
                                    </ButtonItem>
                                  </span>
                                </Tooltip>
                              }
                             
                            </>
                          )}
                        />
                        )
                    }}
                  </FormItem>
            </Form>
          </Spin>
        </div>
        <ModalItem
          title="Confirmacion"
          visible={this.state.modalConfirmacion}
          onCancel={() => this.setState({ modalConfirmacion: false })}
          onOk={() => {
            this.setState({ modalConfirmacion: false });
            this.onFinish(this.state.valuesForm);
          }}
          spinning={this.state.loadingModal}
          footer
        >
          <h1 style={{ textAlign: "center" }}>Desea continuar</h1>
          {(this.state.creditoDisponible && this.state.valuesForm.contado === 2) ? (
            <h2 style={{ textAlign: "center" }}>
              El cliente un credito disponible de
              {" " + dineroDisabledMask(this.state.creditoDisponible)}.
            </h2>
          ) : null}
        </ModalItem>
        <ElegirTipoDeCliente
          visible={this.state.modalElegirTipoDeCliente}
          id={this.state.modalElegirTipoDeClienteId}
          nombre={this.state.modalElegirTipoDeClienteNombre}
          cerrarElegirTipoDeCliente={this.cerrarElegirTipoDeCliente.bind(this)}
        />
        <MandarCorreo
          visible={this.state.modalCorreo}
          id={this.state.modalCorreoId}
          cerrarMandarCorreo={this.cerrarMandarCorreo.bind(this)}
        />
        <ModalAutorizacion
          visible={!!this.state.modalAutorizacion?.visible}
          permisoId={this.state.modalAutorizacion?.permisoId}
          contexto={this.state.modalAutorizacion?.contexto}
          opcionesValor={this.state.objetoPrecios}
          onAutorizado={this.onAutorizado}
          onCancel={() => this.setState({ modalAutorizacion: null })}
        />
        <VistaPreviaVenta
          visible={this.state.modalVistaPrevia}
          datosVenta={this.state.datosVistaPrevia}
          cerrarVistaPreviaVenta={() => this.setState({ modalVistaPrevia: false, datosVistaPrevia: null })}
        />
        <ElegirMarbetes
          visible={this.state.modalElegirMarbetes}
          cerrarElegirMarbetes={this.cerrarElegirMarbetes.bind(this)}
          marbetes={this.state.modalElegirMarbetesMarbetes}
          insumoId={this.state.modalElegirMarbetesInsumoId}
          proyectoId={this.state.modalElegirMarbetesProyectoId}
        />
        <ElegirLotes
          visible={this.state.modalElegirLotes}
          cerrarElegirLotes={this.cerrarElegirLotes.bind(this)}
          lotes={this.state.modalElegirLotesLotes}
          insumoId={this.state.modalElegirLotesInsumoId}
          proyectoId={this.state.modalElegirLotesProyectoId}
          clienteId={this.state.modalElegirLotesClienteId}
          cantidad={this.state.modalElegirLotesCantidad}
          pedidosSeleccionados={this.state.pedidosSeleccionados}
          cotizacionesSeleccionadas={this.state.cotizacionesSeleccionadas}
        />
        <ElegirAgrupaciones
          visible={this.state.modalElegirAgrupaciones}
          cerrarElegirAgrupaciones={this.cerrarElegirAgrupaciones.bind(this)}
          agrupaciones={this.state.modalElegirAgrupacionesAgrupaciones}
          insumoId={this.state.modalElegirAgrupacionesInsumoId}
          proyectoId={this.state.modalElegirAgrupacionesProyectoId}
          clienteId={this.state.modalElegirAgrupacionesClienteId}
        />
        <ElegirComponentesKit
          visible={this.state.modalElegirComponentesKit}
          cerrarElegirComponentesKit={this.cerrarElegirComponentesKit.bind(this)}
          componentes={this.state.modalElegirComponentesKitComponentes}
        />
        <AgregarCliente
          visible={this.state.modalAgregar}
          cerrarModal={this.cerrarAgregarCliente}
        />
        <AgregarCanalVenta
          visible={this.state.modalAgregarCanal}
          cerrarModal={this.cerrarAgregarCanal}
        />
        <ElegirLeyenda
          visible={this.state.modalLeyenda}
          cerrarElegirLeyenda={this.cerrarLeyenda.bind(this)}
          leyenda={this.state.modalLeyendaLeyenda}
          leyendasPasadas={this.state.modalLeyendaLeyendasPasadas}
          clienteIdActual={this.state.clienteIdActual}
          nombreClienteActual={this.state.nombreClienteActual}
        />
        <ElegirObservaciones
          visible={this.state.modalObservaciones}
          cerrarElegirObservaciones={this.cerrarObservaciones.bind(this)}
          observaciones={this.state.modalObservacionesObservaciones}
          observacionesPasadas={this.state.modalObservacionesObservacionesPasadas}
          observacionesXml={this.state.modalObservacionesObservacionesXml}
          clienteIdActual={this.state.clienteIdActual}
          nombreClienteActual={this.state.nombreClienteActual}
        />
        {!this.props.desactivarCargaExcelInsumosVentas && (
          <ModalCargarExcelInsumos
            visible={this.state.modalCargarExcelVisible}
            onCancel={() => this.setState({ modalCargarExcelVisible: false })}
            empresaId={this.props.empresaId}
            headersToken={this.props.headersToken}
            nombreDocumento="Venta"
            clienteId={this.formRef.current?.getFieldValue("clienteId")}
            precioId={this.formRef.current?.getFieldValue("precioId")}
            hayInsumosCapturados={(this.formRef.current?.getFieldValue("insumos") || []).length > 0}
            cantidadInsumosCapturados={(this.formRef.current?.getFieldValue("insumos") || []).length}
            permitirReemplazar
            onConfirmar={this.cargarInsumosDesdeExcel}
          />
        )}
        <VerInsumo
          visible={this.state.modalVerInsumo}
          cerrarVerInsumo={(precio) => this.cerrarVerInsumo(precio)}
          id={this.state.modalVerInsumoId}
          precioId={this.state.modalVerInsumoPrecioId}
          tipoDeCambio={this.state.modalVerInsumoTipoDeCambio}
          headersToken={this.props.headersToken}
          empresaId={this.props.empresaId}
        />
        <ComercioExteriorInsumo
          visible={this.state.modalComercioExteriorInsumo}
          cerrarComercioExteriorInsumo={this.cerrarComercioExteriorInsumo.bind(this)}
          values={this.state.modalComercioExteriorInsumoValues}
        />
        <AgregarCirugia
          visible={this.state.modalAgregarCirugia}
          cerrarAgregarCirugia={this.cerrarAgregarCirugia.bind(this)}
        />
        <AgregarDoctor
          visible={this.state.modalAgregarDoctor}
          cerrarAgregarDoctor={this.cerrarAgregarDoctor.bind(this)}
        />
        <AgregarPaciente
          visible={this.state.modalAgregarPaciente}
          cerrarAgregarPaciente={this.cerrarAgregarPaciente.bind(this)}
        />
        <DetalleInsumoModal
          visible={this.state.modalDetalleInsumoVisible}
          onClose={this.cerrarDetalleInsumo}
          insumoId={this.state.insumoSeleccionadoDetalle.id}
          nombreInsumo={this.state.insumoSeleccionadoDetalle.nombre}
          headersToken={this.props.headersToken}
          empresaId={this.props.empresaId}
        />
        <DisponibilidadInsumoModal
          visible={this.state.modalDisponibilidadVisible}
          onClose={this.cerrarDisponibilidad}
          insumoId={this.state.insumoSeleccionadoDisponibilidad.id}
          nombreInsumo={this.state.insumoSeleccionadoDisponibilidad.nombre}
          headersToken={this.props.headersToken}
          empresaId={this.props.empresaId}
          proyectoId={this.state.insumoSeleccionadoDisponibilidad.proyectoId}
        />
        <HistorialInsumoClienteModal
          visible={this.state.modalHistorialClienteVisible}
          onClose={this.cerrarHistorialCliente}
          insumoId={this.state.insumoSeleccionadoHistorial.id}
          nombreInsumo={this.state.insumoSeleccionadoHistorial.nombre}
          clienteId={this.state.insumoSeleccionadoHistorial.clienteId}
          permitirUsarPrecio={
            !this.state.xmlSubido &&
            !this.estaBloqueado("precioUnitario", this.state.insumoSeleccionadoHistorial.index)
          }
          headersToken={this.props.headersToken}
          empresaId={this.props.empresaId}
        />
        <BusquedaAvanzadaInsumosModal
          visible={this.state.modalBusquedaAvanzadaVisible}
          onClose={this.cerrarBusquedaAvanzada}
          onAgregar={this.agregarInsumoDesdeBusqueda}
          headersToken={this.props.headersToken}
          empresaId={this.props.empresaId}
          {...this.state.contextoBusquedaAvanzada}
        />
        <TourItem open={this.state.openTour} onClose={() => this.setState({ openTour: false })} steps={steps} />
      </>
    );

  }
}

const mapStateToProps = (state) => {
  return {
    insumosXClienteEmpresa: state.empresa.insumosXCliente,
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    usuarioId: state.user.usuarioId,
    autorizacionesRapidas: state.empresa.autorizacionesRapidas,
    certificada: state.empresa.certificada,
    complementoDetallista: state.empresa.complementoDetallista,
    complementoSeriesPersonalizadas: state.empresa.complementoSeriesPersonalizadas,
    fletes: state.empresa.fletes,
    equipoMedico: state.empresa.equipoMedico,
    moduloHoteleria: state.empresa.moduloHoteleria,
    lotesCaducidades: state.empresa.lotesCaducidades,
    cargarXmlPrevio: state.empresa.cargarXmlPrevio,
    activarPagare: state.empresa.activarPagare,
    quitarImpuestosOpcionalVentas: state.empresa.quitarImpuestosOpcionalVentas,
    desactivarCargaExcelInsumosVentas: state.empresa.desactivarCargaExcelInsumosVentas,
    anticipos: state.empresa.anticipos,
    escuela: state.empresa.escuela,
    ventaOnline: state.empresa.ventaOnline,
    taxidermia: state.empresa.taxiderma,
    impresoraSeleccionada: state.empresa.impresoraSeleccionada,
    permisoFacturarVentas:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615ce36bf30e81b54183cfaf"
      )?.activado,
    permisoEntregarInsumosVenta:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615ccbaff30e81b54183cf71"
      )?.activado,
    permisoRemision:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "68a0b80d4319162f78ce6417"
      )?.activado,
    permisoVenderCredito:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "68a0b80d4319162f78ce6419"
      )?.activado,
    permisoModificarMoneda:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "68a0b80d4319162f78ce641a"
      )?.activado,
    permisoModificarListaPrecios:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "68a0b80d4319162f78ce6420"
      )?.activado,
    permisoModificarPrecioUnitario:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "68a0b80d4319162f78ce641b"
      )?.activado,
    permisoModificarDescuento:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "68a0b80d4319162f78ce641c"
      )?.activado,
    permisoXmlPrevio:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "68a0b80d4319162f78ce641f"
      )?.activado,
    permisoBloquearVendedorVenta:
      state.user.tipo !== 0 &&
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a5d8627b6cc374e24fd22a0"
      )?.activado,
    permisoElegirSerieFolioPersonalizado:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a9b6273e58adfd453dfa6f7"
      )?.activado,
  };
};
export default connect(mapStateToProps)(AgregarVenta);